/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useDebounce } from 'use-lodash-debounce';
import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { hasFeatureAccess } from 'src/utils/featurePermission';
import { EmptyContent } from 'src/components/empty-content';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import _, { isArray, isEmpty, isPlainObject } from 'lodash';
import { shallowEqual } from 'react-redux';
import useSnackbar from 'src/hooks/useCustomSnackbar';
import useFlatSelectionScopeReset from 'src/hooks/useFlatSelectionScopeReset';
// use @mui
import {
    Box,
    Card,
    Tab,
    Tabs,
    InputAdornment,
    TextField,
    Button,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Popper,
    Grow,
    Paper,
    ClickAwayListener,
    Typography,
    useTheme,
    useMediaQuery,
} from '@mui/material';
// sections
import SelectArchiveReasons from 'src/components/Dropdowns/SelectArchiveReasons';
import { updateLeadDataCount } from 'src/redux/slices/whatsapp';
import { updateSuperAdmin } from 'src/redux/slices/superAdmin';
import capitalizeFirstLetter from 'src/utils/capitalizedFunc';
import {
    cleanSelectionModel,
    isFlatSelectionForRows,
    buildPracticeByLeadId,
    isRowSelected,
    pruneSelectedLeadIds,
    selectionMatchesRows,
} from 'src/utils/selectionModel';
import { taskModeReloadFields } from 'src/utils/taskModeQuery';
import { shouldSkipCounterReload } from 'src/utils/newLeadCounterGate';
import { resolveNewLeadViewMode } from 'src/utils/resolveNewLeadViewMode';
import { updatePracticeIdToChange } from 'src/redux/slices/practiceTreatmentList';
import { loadCustomTabs, selectCustomTabsForParent } from 'src/redux/slices/customTableTabs';
import PmsSchedulingStatus from '../../components/pms/PmsSchedulingStatus';
import usePmsSchedulingScope from '../../hooks/usePmsSchedulingScope';
import { PracticeEditDialog } from '../../sections/@dashboard/practiceTreatment';
import { AppointmentPage, FollowUp } from '../../sections/@dashboard/lead';
import { Activities } from '../../sections/@dashboard/leadDetail';
import {
    TreatmentAndAppointment,
    PaymentOption,
    PersonalDetails,
    MessageAndReminder,
} from '../../sections/@dashboard/general/app';
// component
import DashBoardReportsWidget from '../../components/reportsWidget/DashBoardReportsWidget';
import AttendedTableReportsWidget from '../../components/reportsWidget/AttendedTableReportsWidget';
import StartedTableReportsWidget from '../../components/reportsWidget/StartedTableReportsWidget';
import FTATableReportsWidget from '../../components/reportsWidget/FTATableReportsWidget';
import ClinCheckStatusPopup from '../../components/dialogPopUp/ClinCheckStatusPopup';
import BookedTableReportsWidget from '../../components/reportsWidget/BookedTableReportsWidget';
import { ActionCards } from '../../components/actionCards';
import NewLeadTaskDueWidget from '../../components/reportsWidget/NewLeadTaskDueWidget';
import { Iconify, Label, MultiDatePicker } from '../../components';
import FloatingBulkActionBar from '../../components/BulkActionBar/FloatingBulkActionBar';
import { ReferralDropdown, MultiTreatmentDropdown, PracticeDropdowns } from '../../components/Dropdowns';
import { NO_TREATMENT_SENTINEL_ID } from '../../components/Dropdowns/SelectMultiTreatments';
import MultiAssigneesDropdown from '../../components/Dropdowns/SelectMultiAssignees';
import { AttendedAppointment } from '../../components/Attended';
import { SearchAutocompleteTags } from '../../components/AutoComplete';
import {
    ArchivedLeadPopUp,
    AssignTaskPopup,
    EditPersonalDetailsPopup,
    AppointmentAssignTaskPopup,
    ArchivedOrRestorePopup,
    AttendedNotePopup,
    BulkReminderPopup,
} from '../../components/dialogPopUp';
import SmartBulkReminderModal from '../../components/dialogPopUp/SmartBulkReminderModal';
import { UnableToContact } from '../../components/failedToAttendTabs';
import WhatsAppFollowUpStep from '../../components/WhatsAppFollowUpStep';
import WhatsAppCloseStep from '../../components/WhatsAppCloseStep';
import { TableFilterResult } from '../../components/table';
import {
    OpenDialogPopup,
    OpenConsultationPopup,
    OpenAttendedPopup,
    OpenUnAttendedPopup,
    OpenRestoreArchived,
    OpenEditAppointmentPopup
} from '../../components/fullScreenPopUps';
import AppointmentBookingRouter from '../../components/appointments/AppointmentBookingRouter';
import ContactLeadPopupRouter from '../../components/fullScreenPopUps/ContactLeadPopupRouter';
import OpenContactLeadPopup from '../../components/fullScreenPopUps/OpenContactLeadPopup';
import { DentallyPaymentConfirmation, DentallyTreatmentAvailabilityWizardStep, DentallyFollowUpConfirmWizardStep, BookingModeToggle } from '../../components/dentally';
import { PmsAvailabilityWizardStep, PmsBookingConfirmStep } from '../../components/pms';
import { usePmsBookingSession, PmsBookingRecovery } from '../../components/pms/usePmsBookingSession.tsx';
import { useDateRangePicker } from '../../components/date-range-picker';
import TreatmentPlanDatePicker from '../../components/dialogPopUp/TreatmentPlanDatePicker';
import { NewLeadDataGrid } from './tables/AllLeadTable/NewLeadDataGrid';
import TableShell from '../../components/tableShell/TableShell';
import WidgetButtons from '../../components/reportsWidget/WidgetButtons';
import ActiveFilterChip from '../../components/tableShell/ActiveFilterChip';
import { resolveTabLabel } from '../superAdmin/tableDefaults/constants';
import { selectGlobalPrefForTable } from '../../utils/globalTablePrefsCascade';
import { AlignerApproveLeadDataGrid } from './tables/AllLeadTable/AlignerApproveLeadDataGrid';
import TreatmentEditPopover from './tables/AllLeadTable/TreatmentEditPopover';
import { FormProvider } from '../../components/hook-form';
import DepositPaymentPopover from './tables/AllLeadTable/DepositPaymentPopover';
import StartTreatmentPopup from '../../components/dialogPopUp/StartTreatmentPopup';
import CustomConfirmationDialog from './tables/AllLeadTable/CustomConfirmationDialog';
import CustomCompleteTreatmentDialog from './tables/AllLeadTable/CustomCompleteTreatmentDialog';

// redux
import { completedToStart, markAsDuplicate, unMarkAsDuplicate } from '../../redux/slices/duplicateLeads';
import { markAsSpam } from '../../redux/slices/spamLeads';
import { setCurrentTreatmentDataGlobal } from '../../redux/slices/multiTreatment';
import { getActivities } from '../../redux/slices/activity';
import { dispatch, useSelector } from '../../redux/store';
import {
    selectLoadingForLead,
    selectIsAppointmentBooked,
    selectAttendance,
    selectFollowUpLead,
    selectFollowLead,
    selectMarkAsComplete,
    selectContactLead,
    selectBookingAttendance,
    selectMultiLead,
    selectTaskTableData,
    selectAction,
    selectTableRowLead,
} from '../../redux/selectors/leadSelectors';
import {
    clearLead,
    updateSteps,
    updateFollowUpLead,
    updateLeadDetail,
    ConsultationAttended,
    RecordAttended,
    recordUnAttended,
    getLeadReminderData,
    ArchivedLeadDashBoard,
    restoreArchived,
    CompleteTreatment,
    startLoadingData,
    updateCounter,
    StartingTreatment,
    updateDashNewLead,
    dashNewTableCounter,
    selectLeads,
    updateTableType,
    startArchivedLoading,
    startLoadingDepositPending,
    UpdateDepositPendingStatus,
    setAction,
    followUpSlice,
    updateCompleteStatus,
} from '../../redux/slices/lead';
import { beginArchiveLead } from '../../redux/slices/lead/coreThunks';
import { completeTask } from '../../redux/slices/taskSlice';
import { getNewLeadTaskWidgetCounts } from '../../redux/slices/widgetCounter';
import { clearPracticeUserData } from '../../redux/slices/practiceUser';
import { getPracticeItem } from '../../redux/slices/practice';
import { setCallScriptSection } from '../../redux/slices/callScript';
import { clearMessage, getPracticeTreatmentList } from '../../redux/slices/practiceTreatment';
import { setLoader } from '../../redux/slices/loader';
// hooks/constants/util
import {
    useTabs,
    useToggle,
    useConsultationAttendToggle,
    useRecordAttendToggle,
    useUnRecordAttendToggle,
    useArchivedToggle,
    useAddTreatment,
    useTable,
    useRestoreArchived,
    useAssignTaskToggle,
    useBoolean,
    useLeadTableHelper,
    useAppointmentToggle
} from '../../hooks';
import useTableQueryParams from '../../hooks/useTableQueryParams';
import {
    TAB_HEAD_FOLLOW_UP,
    TAB_HEAD_NO_TASK,
    DASH_NEW_HEADER,
    CONSULTANT_BOOKED_HEAD,
    CONSULTANT_ATTENDED_SINGLE_HEAD,
    buildAttendedCountFilterQuery,
    CONSULTANT_CLINCHECK_ATTENDED_HEAD,
    ATTENDED_CHECKLISTS_TAB_HEAD,
    DASH_V2_CHECKLIST_TAB_HEAD,
} from '../../constants/newLead';
import { CreateLeadHeaderData } from '../../constants/LeadDetailConst';
import { TASKS_V2_CHANGED_EVENT } from '../../constants/tasksV2';
import {
    SelectTableTab,
    TabCount,
    TablePageNumber,
    TablePerPage,
    TableSearch,
    TableTreatment,
    TableFilterDate,
    TableStatus,
    TableFilterTags,
    TableOrder,
    TableOrderBy,
    TableReferral,
    TableCategory,
    TableCategoryName,
    TableBookedWith,
    TableTags,
    UpdateTableData,
    TableDepositPending,
    TableConsultationBookedWith,
    TableAssignees,
    TableArchiveReason,
    TablePracticeFilter,
    TableContactedCountFilter,
    TableChecklistState,
} from '../../utils/allTableTab';
import { handleDeletePaymentMethods } from '../../utils/depositUtils';
import { handleLatestData, filterLeadTreatmentsForCustomTab } from '../../utils/getLeadLatestData';
import { localStorageRemoveItem } from '../../utils/storage-available';
import { resolveBookedWidgetClickTarget } from '../../utils/bookedTableFilters';
// style
import { common, grey, primary } from '../../theme/palette';
import {
    stackStyle,
    textFieldStyle,
    searchWrapperStyle,
    tabsStyle,
    tabStyle,
    cancelBtnStyle,
    yesBtnStyle,
    treatmentBoxStyle,
    referralBoxStyle,
    treatmentTagFilterStyle,
    filterFormBoxStyle,
    referralOutBoxStyle,
    searchFilterContent,
    zIndexStyle,
    borderRadiosStyle,
    dialogTitleStyle,
    dialogActionStyle,
} from '../../styles/NewLead';
import TransferLeadDialog from '../../components/dialogPopUp/TransferLeadDialog';
import useHasMultiplePractices, { isLeadTransferable } from '../../hooks/useHasMultiplePractices';


const NewLead = ({
    leadData,
    updateLeadPage: updateLeadPageProp,
    pageCount,
    type,
    setUpdateList,
    tableTitle,
    counter,
    reloadCounter,
    reloadTaskCounter,
    onClose,
    rowStatus,
    defaultHideColumn,
    columnVisibilityModel,
    handleColumnVisibilityChange,
    handleColumnOrderChange,
    shouldRunEffect,
    dashBoardDateProps,
    isNoTaskLeadsTable,
    selectedTab,
    setColumnVisibilityModel,
    pinProps,
    displayForCategorySummary,
    leadCategoryType,
    forceReload,
    archiveReasonData,
    showPracticeColumn,
    onDateRangeReady,
    toolbarEnd,
    hideCounterTabs,
    isCombinedName,
    handleToggleCombineName,
    setIsCombinedName,
    isCombinedContact,
    handleToggleCombineContact,
    setIsCombinedContact,
    bookedWidgetFilter = null,
    bookedWidgetCounts,
    bookedWidgetCountsLoading = false,
    bookedWidgetCountsError = null,
    // Active-widget guidance (TableShell): when the table is being driven by a
    // dashboard widget/card filter, these carry that widget's CURRENT label +
    // colour (colour may be urgency-derived, so it must be the live value) — the
    // grid then shows a matching border trace + chip. Falsy → no trace.
    activeFilterLabel,
    activeFilterColor,
    isEnforcedByPractice,
    setIsEnforcedByPractice,
    // When the wrapper page renders ONE NewLead and uses a top-level Tabs strip
    // to switch among slice-sharing views (built-in board + treatment-scoped
    // custom tabs), pass the active customTabId in here. NewLead resets pagination
    // and fires a refetch whenever the prop changes. Leave undefined for the
    // legacy/standalone case where NewLead manages its own custom-tab strip
    // (Newest Leads inline custom tabs, etc.) — that path is unchanged.
    // null  = built-in board (no custom-tab scope)
    // Number = a specific PracticeCustomTableTab id
    controlledCustomTabId,
    // Bug 2c fix: URL-driven inner checklist strip state. ConsultantAttend passes
    // ?checklist_state= from the URL so this value is the single source of truth
    // on browser-back, preventing the Redux initialState 'in_progress' from racing.
    // null / undefined means no URL override — use Redux as normal.
    checklistStateFromUrl = null,
    // Callback to write checklistState back to the URL when the strip changes.
    // Called with the new state string ('in_progress' | 'complete').
    onChecklistStateChange = null,
    // When true, the legacy AttendedTableReportsWidget is not rendered.
    // Used by ConsultantAttend when the new tab-contextual widget row is active
    // (tasks-v2 practice with custom tabs) so both rows do not show at once.
    suppressDefaultAttendedWidget = false,
    // Task #46: ref passed by the wrapper page (NewLeadTable.jsx) that owns the
    // initial data fetch. While `.current === false`, this component's practiceTreatment
    // effect skips updateLeadPage / reloadCounter so only ONE correctly-scoped fetch
    // fires on mount. The wrapper sets `.current = true` after dispatching the fetch.
    // Null/undefined for all other table types — gate is a no-op.
    externalInitialFetchRef = null,
    // ConsultantAttend explicitly owns list/counter hydration. The practice-id
    // readiness prop flips only after that wrapper dispatches its settled request;
    // hydration-driven tab changes are recorded, not fetched, before that point.
    wrapperOwnsLeadHydration = false,
    wrapperHydratedPracticeId = null,
    // When true, the legacy StartedTableReportsWidget is not rendered.
    // Used by TreatmentStarted when the new contextual widget row is active
    // so both rows do not show at once.
    suppressDefaultStartedWidget = false,
    // All Lead table no longer renders the legacy dashboard widget row.
    hideDashboardWidget = false,
    // When true, the additive checklist_state sub-strip (All / In Progress /
    // Follow-Up Complete) is not rendered. Used by TreatmentStarted, where the
    // contextual widget's In Progress / Follow-Up Complete cards are the sole
    // checklist_state control (clicking a card sets checklistState; clicking
    // again / no card = All), making the sub-strip redundant.
    hideChecklistStrip = false,
    // Called by handleSearch when a non-empty search clears all filters.
    // Wrapper pages (ConsultantAttend, TreatmentStarted, GeneralApp) use this to
    // reset their top-strip currentTab back to the default, which causes
    // useChecklistTabUrlState to delete ?tab=custom:N from the URL and update
    // controlledCustomTabId → null so NewLead stops scoping the query.
    onClearCustomTab = null,
}) => {
    const practiceId = useSelector((state) => state.practiceTreatmentList.practiceId);
    const wrapperOwnsCurrentPractice = wrapperOwnsLeadHydration && type === 'ConsultantAttend';
    const wrapperHydratedCurrentPractice = wrapperOwnsCurrentPractice
        && practiceId != null
        && String(wrapperHydratedPracticeId) === String(practiceId);
    const controlledCustomTabIdRef = useRef(controlledCustomTabId);
    useEffect(() => {
        controlledCustomTabIdRef.current = controlledCustomTabId;
    }, [controlledCustomTabId]);
    const updateLeadPage = useCallback((payload = {}, ...args) => {
        const hasCustomTabId = Object.prototype.hasOwnProperty.call(payload, 'customTabId');
        const activeCustomTabId = controlledCustomTabIdRef.current;
        const scopedPayload = !hasCustomTabId && activeCustomTabId != null
            ? { ...payload, customTabId: activeCustomTabId }
            : payload;
        return updateLeadPageProp(scopedPayload, ...args);
    }, [updateLeadPageProp]);
    // Custom treatment-scoped sub-tabs (loaded once per practice; appended to the
    // parent table's tab strip below). See spec:
    // docs/superpowers/specs/2026-05-01-custom-treatment-sub-tabs-design.md
    const customTabs = useSelector((s) => selectCustomTabsForParent(s, practiceId, tableTitle), shallowEqual);
    const practiceTreatment = useSelector((state) => state.practiceTreatmentList.practiceTreatment);
    // Subscribe to the All-Practices selection so this component re-
    // renders and re-fires its reload effects whenever the user flips
    // the multi-practice selector. Without this subscription, thunks
    // that read `activePracticeIds` via `store.getState()` use the new
    // value on their NEXT dispatch (route change, filter change) — but
    // an active lead table doesn't know to refetch just because the
    // selection changed. Adding this to the reload-effect deps below
    // closes that reactivity gap (P1 from phase-4 review).
    const activePracticeIds = useSelector(
        (state) => state.practiceTreatmentList?.activePracticeIds,
    );
    // Serialise to a stable string so the useEffect dep compare is
    // value-based rather than reference-based (arrays are new on every
    // Redux state emit, which would fire the effect even without a
    // real change).
    const activePracticeIdsKey = Array.isArray(activePracticeIds)
        ? activePracticeIds.join(',')
        : '';
    const { handleTableData } = useLeadTableHelper(type);
    const { page, order, orderBy, setPage, rowsPerPage, onChangePage, onChangeRowsPerPage, setRowsPerPage } = useTable({
        defaultOrder: 'desc',
    });
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
    });
    const location = useLocation();
    const currentPagePath = location.pathname;
    const { initialFilters, syncToUrl, hasUrlFilters } = useTableQueryParams();
    const theme = useTheme();
    const isLight = theme.palette.mode === 'light';
    const [mobileFiltersExpanded, setMobileFiltersExpanded] = useState(false);
    // Active contextual widget reported by a widget rendered INSIDE NewLead
    // (NewLeadTaskDueWidget). Pages that render their contextual widget externally
    // (Attended, Treatment Started) pass activeFilterLabel/Color props instead;
    // the two are merged when driving the TableShell trace below.
    const [internalActiveWidget, setInternalActiveWidget] = useState(null);
    const isMobileFilters = useMediaQuery('(max-width:768px)');

    const inputRef = useRef();
    const personalDetailPopupRef = useRef();
    const rowLead = useRef();
    // Row whose "Transfer to another practice" dialog is open (row menu entry).
    const [transferRow, setTransferRow] = useState(null);
    const hasMultiplePractices = useHasMultiplePractices();
    // Stores the V2 task UUID of the cell that opened the contactLead popup.
    // Checked in handleClose to complete the task on a genuine save (markAsComplete).
    const pendingV2TaskIdRef = useRef(null);

    const { enqueueSnackbar } = useSnackbar();
    const [currentWidget, setCurrentWidget] = useState('1');

    const picker = useDateRangePicker(null, null);
    const message = useSelector((state) => state.practiceTreatment.message);
    const error = useSelector((state) => state.practiceTreatment.error);
    const activityList = useSelector((state) => state.activity.activityList);
    const results = useSelector((state) => state.practiceTreatment?.treatmentsList?.results);
    const categoryList = useSelector((state) => state.practiceTreatment.categoryList);
    const practiceUser = useSelector((state) => state.practiceUser.practiceUser);
    const practice = useSelector((state) => state.practice.practice);
    // Phase 2 cascade: system-default global table prefs (renames + hidden_tabs)
    // fall back here when the practice has no override.
    const globalTablePreferencesForStrip = useSelector((state) => state.tablePreferences?.globalTablePreferences);
    const { dentallyEnabledGlobal } = useSelector((state) => state.practice);
    const baseHiddenFilters = [
        ...(practice?.preferences?.hidden_filters?.[tableTitle] || []),
        ...(practice?.preferences?.hidden_filters?._table_filters?.[tableTitle] || []),
    ];
    const pmsScope = usePmsSchedulingScope(practiceId);
    const pmsEnabledGlobal = pmsScope.enabled;
    const isDentallyBooking = useSelector((state) => state.lead.isDentallyBooking);
    const loadingForLead = useSelector(selectLoadingForLead);
    const referralData = useSelector((state) => state.schema.referral);
    const [currentTreatmentData, setCurrentTreatmentData] = useState({});
    const isPaymentMandatory = practice?.preferences?.is_payment_enforced_before_treatment;
    const [depositStatus, setDepositStatus] = useState(false);
    const [practiceListMap, setPracticeListMap] = useState({});
    const isAppointmentBooked = useSelector(selectIsAppointmentBooked);
    const attendance = useSelector(selectAttendance);
    const followUpLead = useSelector(selectFollowUpLead);
    const followLead = useSelector(selectFollowLead);
    const markAsComplete = useSelector(selectMarkAsComplete);
    const [appointmentOutcomeSelection, setAppointmentOutcomeSelection] = useState(null);
    const contactLead = useSelector(selectContactLead);
    const BookingAttendance = useSelector(selectBookingAttendance);
    const multiLead = useSelector(selectMultiLead);
    // Live mirror of the current selection so handleBulkComplete can prune the
    // completed ids without capturing a stale `multiLead` in its useCallback closure.
    const multiLeadRef = useRef(multiLead || { leadId: [], isFlatSelection: false });
    useEffect(() => { multiLeadRef.current = multiLead || { leadId: [], isFlatSelection: false }; }, [multiLead]);
    const taskTableData = useSelector(selectTaskTableData);
    const { limit, offset, filter, assignUser } = taskTableData || {};
    const action = useSelector(selectAction);
    const isLoader = useSelector((state) => state.loaderReducer.isLoader);
    const getUserList = () => practiceUser.results.filter((el) => el.user && el.user.first_name && !el.user.is_superuser);
    const superData = useSelector((state) => state.superAdmin.superData);
    // Attended checklist strip — prefer the already-fetched widget payload (re-fetched on
    // every custom-tab switch by AttendedTabContextualWidget) over the `counter` prop so
    // strip badges stay in sync without an extra getCounter call. Legacy practices that
    // don't mount the contextual widget will always have attendedTabCounts=null and fall
    // back to the existing counter path below.
    const attendedTabCounts = useSelector((s) => s.widgetCounter.attendedTabCounts);
    // Treatment Started checklist strip — parallel mechanism for the TS table.
    // Populated by getTsChecklistCounts in TreatmentStarted.jsx on every custom-tab switch.
    const tsChecklistCounts = useSelector((s) => s.widgetCounter.tsChecklistCounts);
    // Subscribe to permissions slice so this component re-renders when permissions
    // settle for the current practice. `hasFeatureAccess` reads store state directly
    // (not reactive); without this subscription, `isV2EnabledForPractice` may be false
    // at mount (permissions not yet loaded) and the lazy-initialized `newLeadViewMode`
    // permanently starts as 'contacts', causing a wrong contacts-mode fetch on a
    // tasks-mode deep-link from the Launchpad.
    const { permissionsLoading, permissionsPracticeId } = useSelector(
        (s) => ({ permissionsLoading: s.permissions.loading, permissionsPracticeId: s.permissions.practiceId }),
        shallowEqual,
    );
    // Permissions are ready for the current practice once loading is done and the
    // snapshot's practiceId matches. We treat the empty-permissions bootstrap state
    // (practiceId=null, loading=false) as NOT ready so we never fire a contacts-mode
    // fetch on a tasks deep-link before the flag check is valid.
    const permissionsReady = !permissionsLoading && permissionsPracticeId === practiceId;

    const orderByValue = orderBy === 'name' ? 'created_at' : orderBy;
    const allType = type === 'Dashboard' || type === 'NoTaskTable';
    const notAllType = type !== 'Dashboard' && type !== 'NoTaskTable';
    const newType = type === 'NewLeadTable';
    const dashType = type === 'DashNewLeadTable';
    const noDashType = type !== 'DashNewLeadTable';
    const archType = type === 'ArchiveTable';

    // Stable signal: the page was opened via a Launchpad tasks-mode deep-link
    // (?viewMode=tasks). initialFilters (line ~380) is a [] memo, so this never
    // changes after mount. Declared HERE (right after its deps newType + initialFilters)
    // — NOT ~1000 lines below — because it's referenced in useCallback dep-arrays
    // (refreshTableWithCurrentFilters / refreshCountersOnly) that are evaluated at
    // render; a below-first-use declaration is a TDZ crash in the minified bundle
    // (feedback-tdz-callback-dep-order). #121 hotfix.
    const isTasksDeepLinkUrl = newType && initialFilters.viewMode === 'tasks';
    const notArchType = type !== 'ArchiveTable';
    const consultantAttendedType = type === 'ConsultantAttend';
    const attendedChecklistsType = type === 'AttendedChecklists';
    const consultantClinCheckAttendedType = type === 'ConsultantClinCheckAttend';
    const notClinCheckType = type !== 'ConsultantClinCheckAttend';
    const consultantBookedType = type === 'ConsultantBooked';
    const noConsultantBookedType = type !== 'ConsultantBooked';
    const treatmentStartedType = type === 'treatmentStarted' || type === 'treatmentStartedWithInvisalign';
    const noTreatmentStartedType = type !== 'treatmentStarted';
    const failedToAttendType = type === 'FailedToAttend';
    const noFailedToAttendType = type !== 'FailedToAttend';
    const noClosedType = type !== 'Closed';
    const isReportData = type !== 'reportTableData';
    const reportData = type === 'reportTableData';
    const commonType = notArchType && noFailedToAttendType && noClosedType;
    const bookedWithFilter = consultantAttendedType || attendedChecklistsType || consultantClinCheckAttendedType || consultantBookedType || treatmentStartedType;

    const contactCount = TabCount(type);
    const pageNumber = TablePageNumber(type);
    const perPage = TablePerPage(type);
    const searchValue = TableSearch(type);
    const treatmentValue = TableTreatment(type);
    const assigneeSelectedForFilter = TableAssignees(type);
    const searchFilterDate = TableFilterDate(type);
    const tableStatus = TableStatus(type);
    const searchTags = TableFilterTags(type)?.toString();
    const tableOrder = TableOrder(type);
    const tableOrderBy = TableOrderBy(type);
    const referral = TableReferral(type);
    const depositPendingStatus = TableDepositPending(type);
    const contactedCountFilterValue = TableContactedCountFilter(type);
    // Bug 2c: URL param takes precedence over Redux on browser-back.
    // checklistStateFromUrl is null for tables that don't use URL-driven state
    // (TreatmentStarted, AttendedChecklists, etc.) — no behaviour change for them.
    //
    // Task #81 — non-V2 gate: DashNewLeadTable must NOT send checklist_state=in_progress
    // on non-V2 / non-checklist-enabled practices. Non-V2 leads have no checklist rows;
    // strict in_progress (even with exhaustive=true) returns 0 rows, emptying the table.
    // Gate: hasFeatureAccess('tasks-v2', practiceId) is practice-switch-accurate
    // (checks slice.practiceId, refuses stale reads during the switch window).
    // Non-V2 or unsettled → '' (no checklist param); V2 → preserve Redux / URL value.
    // All other table types (ConsultantAttend, TreatmentStarted, etc.) are unaffected —
    // their types never === 'DashNewLeadTable' so this branch never fires for them.
    const _rawChecklistState = checklistStateFromUrl || TableChecklistState(type);
    const checklistStateValue = (type === 'DashNewLeadTable' && !hasFeatureAccess('tasks-v2', practiceId))
        ? ''
        : _rawChecklistState;
    const category = TableCategory(type);
    const categoryName = TableCategoryName(type);
    const bookedWith = TableBookedWith(type);
    const searchFilterTags = TableTags(type);
    const { consultationBookedWith, apptType } = TableConsultationBookedWith(type);
    const archiveReason = TableArchiveReason(type);
    const practices = TablePracticeFilter(type);

    // Date fallback: Redux → sessionStorage → null (show all)
    const sessionDateKey = `dsem_dateRange_${type}`;
    const sessionDates = (() => { try { return JSON.parse(sessionStorage.getItem(sessionDateKey)); } catch { return null; } })();
    // Check .length: an empty array [] is truthy but [0] is undefined, causing
    // "Cannot read 'startDate' of undefined" (Sentry: REACT-DC, 6 users, 24 events).
    const startDate = searchFilterDate?.length > 0 ? searchFilterDate[0]?.startDate : (sessionDates?.startDate || null);
    const endDate = searchFilterDate?.length > 0 ? searchFilterDate[0]?.endDate : (sessionDates?.endDate || null);

    const hasActiveFilters = Boolean(
        searchValue ||
        treatmentValue?.length > 0 ||
        startDate ||
        endDate ||
        referral?.length > 0 ||
        bookedWith?.length > 0 ||
        depositPendingStatus ||
        consultationBookedWith?.length > 0 ||
        assigneeSelectedForFilter?.length > 0 ||
        archiveReason?.length > 0 ||
        practices?.length > 0 ||
        // The Booked widget scope counts as an active filter. Without this the board could
        // land pre-scoped to "Upcoming this week", return nothing, and render a bare
        // "No Data" — the DataGrid's own empty state already offers "Clear all filters"
        // when hasActiveFilters is true, which is where a user staring at an empty table
        // actually looks (the card's "Clear to see all" chip is up and to the left).
        //
        // Scoped to ConsultantBooked deliberately. onResetFilter clears bookedWidgetFilter
        // (see the consultantBookedType branch there), so the CTA genuinely fixes the
        // emptiness. It does NOT clear the New board's task bucket (that resets to
        // 'due_now', not null) or Attended/Started's contextual filter (owned by the page,
        // not by onResetFilter) — offering the button on those boards would produce a clear
        // that leaves the table just as empty.
        (consultantBookedType && Boolean(bookedWidgetFilter))
    );

    const buildUrlFilterState = (overrides = {}) => {
        const state = {};
        const sv = overrides.search !== undefined ? overrides.search : searchValue;
        if (sv) state.search = sv;
        const tv = overrides.treatment !== undefined ? overrides.treatment : treatmentValue;
        if (tv?.length) state.treatment = tv;
        const rv = overrides.referral !== undefined ? overrides.referral : referral;
        if (rv) state.referral = rv;
        const sd = overrides.startDate !== undefined ? overrides.startDate : startDate;
        const ed = overrides.endDate !== undefined ? overrides.endDate : endDate;
        if (sd) state.startDate = sd;
        if (ed) state.endDate = ed;
        const dp = overrides.depositPaid !== undefined ? overrides.depositPaid : depositPendingStatus;
        if (dp) state.depositPaid = dp;
        const bw = overrides.bookedWith !== undefined ? overrides.bookedWith : bookedWith;
        if (bw?.length) state.bookedWith = bw;
        const cbw = overrides.consultationBookedWith !== undefined ? overrides.consultationBookedWith : consultationBookedWith;
        if (cbw?.length) state.consultationBookedWith = cbw;
        const asn = overrides.assignee !== undefined ? overrides.assignee : assigneeSelectedForFilter;
        if (asn?.length) state.assignee = asn;
        const ar = overrides.archiveReason !== undefined ? overrides.archiveReason : archiveReason;
        if (ar) state.archiveReason = ar;
        const tgs = overrides.tags !== undefined ? overrides.tags : searchFilterTags;
        if (tgs?.length) state.tags = tgs;
        const nt = overrides.noTreatment !== undefined ? overrides.noTreatment : false;
        if (nt) state.noTreatment = true;
        return state;
    };

    const open = useBoolean();
    const openBulkReminder = useBoolean();

    const paymentDeleteToggle = useToggle();

    const [tableData, setTableData] = useState(leadData);

    // Exactly ONE clear control visible at a time. With no rows on screen the DataGrid's
    // centred empty state already offers "Clear All Filters" where the user is actually
    // looking, so the filter-bar chip stands down; as soon as there are rows the chip is
    // the only clear control again. Showing both was redundant — two ways to do one thing.
    // Loading is excluded: mid-fetch there is no empty state yet, so hiding the chip then
    // would leave no clear control at all for a frame.
    const showEmptyStateClear = hasActiveFilters
        && !loadingForLead
        && (tableData?.length || 0) === 0;
    const [validStep, setValidStep] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const shouldCallReminder = useRef(true);
    const [active, setActive] = useState(0);
    const [searchQuery, setSearchQuery] = useState(decodeURIComponent(searchValue) || null);
    const [search, setSearch] = useState(decodeURIComponent(searchValue) || '');
    const [startConfirmation, setStartConfirmation] = useState(false);
    const [startTreatment, setStartTreatment] = useState('');
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [checkOptions, setCheckOptions] = useState(false);
    const [headings, setHeading] = useState([]);
    const [date, setDate] = useState([startDate, endDate]);
    const [userList, setUserList] = useState([]);
    const [filters, setFilters] = useState([]);
    const [, setDepositPendingFilter] = useState('');
    const [assignees, setAssignees] = useState([]);
    // noTreatmentFilter: true when "No treatment" sentinel is selected in the treatment dropdown.
    // Mutually exclusive with real treatment selections — selecting one clears the other.
    const [noTreatmentFilter, setNoTreatmentFilter] = useState(false);
    const [anchorEditTreatment, setAnchorEditTreatment] = useState(null);
    // Bug 1 fix: explicit busy gate for checklist-strip tab switches.
    // Set true when handleChangeChecklistState fires; cleared by NewLeadDataGrid
    // once BOTH the new rows AND their checklist cells have resolved.
    // Scoped to this path only — does NOT change handleLoading's 500ms for all tables.
    const [isChecklistSwitching, setIsChecklistSwitching] = useState(false);
    // checklistAllTabCount removed — Attended All badge now sourced from
    // attendedTabCounts.all, a tab-scoped parallel count call added to
    // getAttendedTabWidgetCounts. This avoids the pageCount-capture race
    // where an early unscoped table fetch could overwrite the scoped total.

    const treatmentData = [];
    treatmentValue?.map((value) => treatmentData.push(value.id));

    const assigneeData = [];
    assigneeSelectedForFilter?.map((value) => assigneeData.push(value.id));

    const bookedWithData = [];
    if (Array.isArray(bookedWith)) {
        bookedWith.map((value) => bookedWithData.push(value?.id));
    }

    const consultationBookedWithData = [];
    if (Array.isArray(consultationBookedWith)) {
        consultationBookedWith.map((value) => consultationBookedWithData.push(value?.id));
    }

    const noAwatingCount = counter?.filter((value) => value.filterStatus === 'AWAITING_RESPONSE');
    const nhsCount = counter?.filter((value) => value.filterStatus === 'NHS');
    const [appoinmentSelectData, setAppoinmentSelectData] = useState(null);
    const [forceUpdate, setForceUpdate] = useState(false);
    const [anchorElAssign, setAnchorElAssign] = useState(null);
    const [appoinmentSelectedId, setAppoinmentSelectedId] = useState(null);
    const [anchorClinCheck, setAnchorClinCheck] = useState(null);
    const [anchorDepositPayment, setAnchorDepositPayment] = useState(null);
    const tableRowLead = useSelector(selectTableRowLead);
    const [contactLeadDefaultTab, setContactLeadDefaultTab] = useState('overview');
    // Sidebar tab to pre-select when the attended popup is opened via a task cell
    // (Email → 'email', WhatsApp → 'whatsapp'). Null for Follow-up button opens.
    const [consultationAttendSidebarTab, setConsultationAttendSidebarTab] = useState(null);
    // Superadmin debug: which leads-table control launched the contact popup.
    // Set dynamically in the 'contactLead' case from the event payload so the
    // single <ContactLeadPopupRouter> below can report the exact entry button.
    const [contactLeadDebugSource, setContactLeadDebugSource] = useState('leads-table');
    // Dentally follow-up booking state
    const [dentallySlot, setDentallySlot] = useState(null);
    const [selectedDentallyTreatment, setSelectedDentallyTreatment] = useState(null);
    const [dentallyAssignees, setDentallyAssignees] = useState([]);
    const [followUpConfirmStepState, setFollowUpConfirmStepState] = useState({});
    const [useDentallyFlow, setUseDentallyFlow] = useState(true);
    // PMS scheduling state
    const [pmsSlot, setPmsSlot] = useState(null);
    const pmsBookingSession = usePmsBookingSession();
    // Keep the owner mounted during uncertain writes; otherwise use native steps only for booking.
    const BookingContactPopup = !pmsBookingSession.canNavigate() || (BookingAttendance && isAppointmentBooked === 'Booking Details' && (!pmsScope.ready || pmsEnabledGlobal) && !dentallyEnabledGlobal)
        ? OpenContactLeadPopup : ContactLeadPopupRouter;
    const [pmsPractitioner, setPmsPractitioner] = useState(null);
    const [pmsDate, setPmsDate] = useState(null);
    const [pmsDuration, setPmsDuration] = useState(30);
    const [pmsConfirmStepState, setPmsConfirmStepState] = useState({});
    const handleToggleBookingMode = useCallback((useDentally) => {
        setUseDentallyFlow(useDentally);
        if (!useDentally) {
            setDentallySlot(null);
            setSelectedDentallyTreatment(null);
            setDentallyAssignees([]);
        }
    }, []);

    const {
        toggle: openTreatmentEditPopup,
        onOpen: onopenTreatmentEditPopup,
        onClose: onCloseTreatmentEditPopup,
    } = useToggle();

    const {
        toggle: openDepositPaymentPopup,
        onOpen: onOpenDepositPaymentPopup,
        onClose: onCloseDepositPaymentPopup,
    } = useToggle();

    // Serialize to JSON so these memos are stable against new practice object
    // references from Redux updates that don't change the actual content.
    // Using the raw object as a dep causes re-fires on every practice field update
    // (notifications, preferences, etc) — which rebuilds headings, re-locks the
    // active-tab indicator, and (when combined with setHeading) can infinite-loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const tableTabsHiddenMap = useMemo(
        () => practice?.preferences?.hidden_filters?._table_tabs || null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(practice?.preferences?.hidden_filters?._table_tabs)],
    );

    // Memoized so the first setHeading effect doesn't need `practice` in its deps
    // (practice changes reference on every Redux update, which would loop).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const isAcceptingNhs = useMemo(
        () => practice?.preferences?.is_accepting_nhs_patients ?? false,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(practice?.preferences?.is_accepting_nhs_patients)],
    );

    useEffect(() => {

        if (type) {
            switch (type) {
                case 'treatmentStarted':
                    // No treatment category tabs for Treatment Started table
                    setHeading([]);
                    break;
                case 'treatmentStartedWithInvisalign': {
                    // Filter categories to only those with at least one enabled treatment in this practice
                    const categories = categoryList?.results;
                    if (categories && results?.length > 0) {
                        const activeCategoryIds = new Set(
                            results.map((t) => t?.treatment_item?.treatment_category?.id).filter(Boolean)
                        );
                        setHeading(categories.filter((cat) => cat.id === '0' || activeCategoryIds.has(cat.id)));
                    } else {
                        setHeading(categories);
                    }
                    break;
                }
                case 'NewLeadTable':
                case 'DashNewLeadTable': {
                    // Practice-level admin can hide individual category sub-tabs via
                    // `_table_tabs['Newest Leads']`. Slugs mapped to DASH_NEW_HEADER values:
                    //   '0' → category-new · 'NHS' → category-nhs · 'AWAITING_RESPONSE' → category-awaiting
                    //   '1' → follow-up-1 · '2' → follow-up-2 · '3' → follow-up-3
                    const newestHidden = tableTabsHiddenMap?.['Newest Leads'] || [];
                    const newestSlug = {
                        '0': 'category-new',
                        NHS: 'category-nhs',
                        AWAITING_RESPONSE: 'category-awaiting',
                        '1': 'follow-up-1',
                        '2': 'follow-up-2',
                        '3': 'follow-up-3',
                    };
                    const baseHeader = isAcceptingNhs
                        ? DASH_NEW_HEADER
                        : DASH_NEW_HEADER.filter((e) => e.value !== 'NHS');
                    setHeading(
                        baseHeader.filter((h) => {
                            const slug = newestSlug[String(h.value)];
                            return !slug || !newestHidden.includes(slug);
                        }),
                    );
                    break;
                }
                case 'ConsultantAttend': {
                    // Single "All Attended" tab. Admin can hide the 'attended' slug via
                    // _table_tabs['Consultation Attended Leads'] — honour it.
                    // Reported by Raj 2026-05-25 — disable wasn't reflected on FE.
                    const attendedHidden = tableTabsHiddenMap?.['Consultation Attended Leads'] || [];
                    setHeading(
                        attendedHidden.includes('attended') ? [] : CONSULTANT_ATTENDED_SINGLE_HEAD,
                    );
                    break;
                }
                case 'AttendedChecklists':
                    setHeading(ATTENDED_CHECKLISTS_TAB_HEAD);
                    break;
                case 'ConsultantClinCheckAttend':
                    setHeading(CONSULTANT_CLINCHECK_ATTENDED_HEAD);
                    break;
                case 'ConsultantBooked':
                    setHeading(CONSULTANT_BOOKED_HEAD);
                    break;
                case 'NoTaskTable': {
                    // Status strip on the No Task Assigned table — admin-controllable
                    // via `_table_tabs['No Task Assigned']`. Slugs map to TAB_HEAD_NO_TASK values.
                    const noTaskHidden = tableTabsHiddenMap?.['No Task Assigned'] || [];
                    const noTaskSlug = {
                        NEW: 'status-new',
                        FOLLOW_UP: 'status-follow-up',
                        CONSULTATION_BOOKED: 'status-consultation-booked',
                        CONSULTATION_ATTENDED: 'status-consultation-attended',
                        FAILED_TO_ATTEND_CONSULTATION: 'status-fta',
                    };
                    setHeading(
                        TAB_HEAD_NO_TASK.filter((h) => {
                            const slug = noTaskSlug[String(h.value)];
                            return !slug || !noTaskHidden.includes(slug);
                        }),
                    );
                    break;
                }
                default:
                    setHeading(TAB_HEAD_FOLLOW_UP);
                    break;
            }
        }
    }, [type, tableTitle, categoryList?.results, tableTabsHiddenMap, isAcceptingNhs, results]);

    // Serialize to JSON so the memo only recomputes when content changes, not when
    // the practice object gets a new reference on every Redux update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const tabOrderOverrides = useMemo(
        () => practice?.preferences?.tab_order_overrides || null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(practice?.preferences?.tab_order_overrides)],
    );

    // Append custom treatment-scoped sub-tabs to the parent table's tab strip.
    // Runs after the type-switch above sets the base headings; harmless when
    // there are no custom tabs.
    useEffect(() => {
        if (!customTabs?.length) return;
        const visible = customTabs
            .filter((t) => {
                if (t.is_hidden) return false;
                // Tabs with placement='top' render at the top-level tab row via the
                // parent page component (e.g. ConsultantAttend.jsx), NOT in the
                // inline category strip. Skip them here so they don't appear twice.
                if (t.placement === 'top') return false;
                const treatments = t.practice_treatments || [];
                const mode = t.treatment_scope_mode || 'include';
                // Empty practice_treatments can mean different things by mode:
                //   - include + no treatments     → 'all treatments' (BE shows all leads)
                //   - exclude + no treatments     → nothing excluded, optionally sibling-based
                //   - exclude + sibling refs only → live-resolved at BE
                //   - all (legacy)                → show
                // Trust the BE custom_table_tab filter (#125 wired) to decide leads;
                // FE should only hide the strip entry when admin marked is_hidden=true.
                if (mode === 'include' && treatments.length > 0) {
                    // Hide a tab when EVERY chosen treatment is disabled.
                    const allDisabled = treatments.every((pt) => pt?.enabled === false);
                    if (allDisabled) return false;
                }
                return true;
            })
            .map((t) => ({
                value: `custom:${t.id}`,
                // labelCount() reads `data.name` for treatmentStartedType and
                // `data.label` for everyone else, so we set both. The • suffix
                // signals an active predicate filter on the dashboard.
                name: t.attribute_predicate ? `${t.name} •` : t.name,
                label: t.attribute_predicate ? `${t.name} •` : t.name,
                // For treatmentStartedType the Tab uses item.id as key/value;
                // mirror our synthetic value to id so it survives that path.
                id: `custom:${t.id}`,
                isCustomTab: true,
                customTabId: t.id,
                hasPredicate: !!t.attribute_predicate,
            }));
        // Prepend a synthetic "All" tab on every parent that has custom tabs, so
        // users have a reset button regardless of how many categories the admin
        // has hidden. 'treatmentStartedWithInvisalign' already has an "All" entry
        // from the categoryList Redux fetch, so we skip injecting there to avoid
        // a duplicate.
        const typeToParent = {
            treatmentStarted: 'Treatment Started Leads',
            ConsultantAttend: 'Consultation Attended Leads',
            NewLeadTable: 'Newest Leads',
            DashNewLeadTable: 'Newest Leads',
            NoTaskTable: 'No Task Assigned',
            AttendedChecklists: 'Attended Checklists',
            ConsultantBooked: 'Consultation Booked Leads',
            ConsultantClinCheckAttend: 'Consultation ClinCheck Leads',
        };
        const parentName = typeToParent[type];
        const parentHidden = parentName ? (tableTabsHiddenMap?.[parentName] || []) : [];
        const needsAllTab = !!parentName
            && type !== 'treatmentStartedWithInvisalign'
            // Post-#104 Attended is a single flat tab — no Follow-up sub-tabs, so no
            // reset button is needed. ConsultantAttend.jsx renders the parent top strip
            // (built-in + custom only); the inner heading must not inject an All here either.
            && type !== 'ConsultantAttend'
            // Treatment Started has no native sub-tab strip and the synthetic "All"
            // confused users (per #58/#118 follow-up). Skip injecting it here.
            && type !== 'treatmentStarted'
            && !parentHidden.includes('all');
        // Value is 'All' (capital) to match the existing coreThunks sentinel for
        // "no contact-count filter" — keeps the active-tab highlight working when
        // contactCount is set to 'All' on click.
        const allTab = needsAllTab
            ? { value: 'All', label: 'All', name: 'All', id: 'All' }
            : null;
        // Apply saved tab order from admin V2 page (tab_order_overrides keyed by parentName).
        // I2: use full slug positions — custom-N slugs for custom tabs, raw slug for built-ins.
        const tabOrder = parentName ? (tabOrderOverrides?.[parentName] || []) : [];
        let orderedVisible = visible;
        if (tabOrder.length > 0) {
            const posMap = Object.fromEntries(tabOrder.map((slug, i) => [slug, i]));
            orderedVisible = [...visible].sort((a, b) => {
                // custom tabs keyed as "custom-<id>"; built-in tabs keyed by their raw slug value
                const slugA = a.isCustomTab ? `custom-${a.customTabId}` : (a.value || a.id || '');
                const slugB = b.isCustomTab ? `custom-${b.customTabId}` : (b.value || b.id || '');
                const pa = posMap[slugA] ?? Infinity;
                const pb = posMap[slugB] ?? Infinity;
                return pa - pb;
            });
        }
        // Bail only when there's genuinely nothing to inject. When every custom
        // tab on this parent is placement='top' the inline `visible` array is
        // empty, but we still need to inject the synthetic All so the admin's
        // 'all' slug toggle isn't a dead switch on those parents.
        if (!orderedVisible.length && !allTab) return;
        setHeading((prev) => {
            const existingIds = new Set((prev || []).map((h) => h?.value));
            const additions = orderedVisible.filter((v) => !existingIds.has(v.value));
            const prefix = allTab && !existingIds.has('All') ? [allTab] : [];
            if (!additions.length && !prefix.length) return prev;
            return [...prefix, ...(prev || []), ...additions];
        });
        // Re-run when the custom tab list, table type, hidden map, or tab ordering
        // changes. `results` is intentionally excluded — it is only needed by the
        // first setHeading effect (treatmentStartedWithInvisalign category filter)
        // and including it here caused an infinite loop: results gets a new array
        // reference on every render, which re-fires this effect, which calls
        // setHeading, which triggers a re-render → Maximum update depth exceeded.
        // tableTitle included as a general identity signal when 'type' changes across tables (was previously the V2 exclusion).
    }, [customTabs, type, tableTitle, categoryList?.results, tableTabsHiddenMap, tabOrderOverrides]);

    const currentTreatmentDataGlobal = useSelector((state) => state.multiTreatment.currentTreatmentDataGlobal);

    useEffect(() => {
        if (!isEmpty(currentTreatmentDataGlobal)) {
            dispatch(setCurrentTreatmentDataGlobal(null));
        }
        if (action) {
            dispatch(setAction(null));
        }
        // dispatch(initializeFacebookAuthToken());
        return () => (dispatch(updateLeadDataCount(false)));
    }, []);

    useEffect(() => {
        if (type) {
            dispatch(updateTableType(type));
        }
    }, [type]);

    // When the wrapper switches among slice-sharing views (built-in vs custom-top
    // tabs that all share the same Redux slice + type), reset pagination and fire
    // a fetch with the new scope. Mirrors handleChangeStatus's 'All' reset block
    // (NewLead.jsx ~L1495-1518) one-for-one so user-set filters (deposit, search,
    // treatments, tags, etc.) survive a top-strip switch — only contactCount,
    // category, and customTabId change.
    //
    // Wrapper-owned hydration can change controlledCustomTabId while async prefs
    // and custom tabs settle. Record those changes without fetching; the wrapper
    // issues the settled request. Once this practice is hydrated, later changes
    // are user-driven and follow the normal refetch path. coreThunks independently
    // rejects any late response superseded by a newer ConsultantAttend request.
    const prevControlledCustomTabIdRef = useRef(controlledCustomTabId);
    useEffect(() => {
        if (controlledCustomTabId === undefined) return; // legacy / standalone NewLead
        if (wrapperOwnsCurrentPractice && !wrapperHydratedCurrentPractice) {
            prevControlledCustomTabIdRef.current = controlledCustomTabId;
            return;
        }
        if (prevControlledCustomTabIdRef.current === controlledCustomTabId) return; // no change
        prevControlledCustomTabIdRef.current = controlledCustomTabId;
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        if (practiceId) {
            // When the incoming custom tab has a checklist_binding, default the
            // sub-strip to 'in_progress' so the green underline lands on "In Progress"
            // and the initial fetch includes checklist_state=in_progress — matching
            // the standalone AttendedChecklists route behaviour (commit d38622b2).
            // When switching away (null or non-checklist tab), clear checklistState
            // so the inline category strip resumes its normal contactedCount logic.
            const incomingTab = controlledCustomTabId != null
                ? customTabs?.find?.((t) => Number(t.id) === Number(controlledCustomTabId)) || null
                : null;
            const incomingIsChecklist = !!(incomingTab?.checklist_binding?.template_ids?.length);
            // defaultCount drives the first-strip underline (UpdateTableData count key).
            // Task #100 Risk 2: with the additive two-strip layout, the
            // contacted-count strip lands on "All" and the checklist strip lands
            // on "In Progress" by default — both render side by side.
            const defaultCount = 'All';
            // Task #14: V2 board default is 'in_progress' (safe with exhaustive semantics —
            // BE checklist_state_exhaustive=true means IP = all non-complete leads, so no
            // leads are hidden). Attended surfaces (ConsultantAttend / AttendedChecklists /
            // TreatmentStarted) keep '' (All) — they don't use exhaustive filtering.
            // Bug 2c fix preserved: a URL-restored checklistState still wins.
            const defaultChecklistState = incomingIsChecklist
                ? (checklistStateFromUrl || (type === 'DashNewLeadTable' ? 'in_progress' : ''))
                : '';
            // Checklist-bound tabs derive their treatment scope from customTabId in
            // coreThunks — forwarding treatmentData here would add a spurious
            // lead_treatments__treatment__in param that mismatches the badge counter
            // (which also doesn't include a treatment filter on initial load).
            const treatmentForTab = incomingIsChecklist ? undefined : treatmentData?.toString();
            updateLeadPage({
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder || 'desc',
                orderId: tableOrderBy || 'created_at',
                searchQuery: searchValue,
                treatment: treatmentForTab,
                startDate,
                endDate,
                contactedCount: 'All',
                checklistState: defaultChecklistState,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                category: '0',
                archiveReason,
                noTreatment: false,
                customTabId: controlledCustomTabId === null ? undefined : controlledCustomTabId,
            });
            const tableUpdateData = { count: defaultCount, checklistState: defaultChecklistState, category: '0', categoryName: '', perPage: 10, pageNumber: 0 };
            if (incomingIsChecklist) {
                // Checklist-bound tabs derive their treatment scope from customTabId, so
                // the treatment filter is dropped from the API call (treatmentForTab above)
                // and from Redux here. Keep the REMAINING treatment-state holders in sync
                // too — clear the RHF chip value and strip ?treatment= from the URL — so a
                // checklist tab can't leave a phantom "Invisalign" chip / stale URL param
                // behind while Redux + the request have already dropped it. (Non-checklist
                // custom tabs fall through and PRESERVE the user's treatment selection.)
                tableUpdateData.treatment = [];
                setValue('multiSelect', []);
                setNoTreatmentFilter(false);
                syncToUrl(buildUrlFilterState({ treatment: [] }));
            }
            UpdateTableData(type, tableUpdateData);
            if (wrappedReloadCounter) {
                wrappedReloadCounter({
                    limit: 10,
                    offset: 0,
                    order: tableOrder || 'desc',
                    orderId: tableOrderBy || 'created_at',
                    searchQuery: searchValue,
                    treatment: treatmentForTab,
                    startDate,
                    endDate,
                    contactedCount: 'All',
                    checklistState: defaultChecklistState,
                    tags: searchTags,
                    referral,
                    depositPendingStatus,
                    bookedWith: bookedWithData?.toString(),
                    assigneeIds: assigneeData?.toString(),
                    noTreatment: false,
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controlledCustomTabId, practiceId, wrapperOwnsCurrentPractice, wrapperHydratedCurrentPractice]);

    useEffect(() => {
        if (hasUrlFilters && type) {
            const urlData = {};
            if (initialFilters.search) urlData.search = encodeURIComponent(initialFilters.search);
            if (initialFilters.referral) urlData.referral = initialFilters.referral;
            if (initialFilters.startDate && initialFilters.endDate) {
                urlData.date = [{ startDate: initialFilters.startDate, endDate: initialFilters.endDate }];
            }
            if (initialFilters.depositPaid) urlData.depositPendingStatus = initialFilters.depositPaid;
            if (initialFilters.archiveReason) urlData.archiveReason = initialFilters.archiveReason;
            if (Object.keys(urlData).length > 0) {
                UpdateTableData(type, urlData);
            }
            if (initialFilters.search) {
                setSearch(initialFilters.search);
                setSearchQuery(initialFilters.search);
            }
        }
    }, []);

    const debouncedValue = useDebounce(searchValue, 300);

    const onSubmit = (data) => setValidStep(!!data);

    const handleReloadLeads = () => {
        // ── Task #46 ───────────────────────────────────────────────────────────────
        // This is the shared reload path — fired on mount via the `[followUpLead]`
        // reset effect AND after every popup close (handleClose). It must respect
        // tasks-mode: sending a contacts-mode contacted-count partition here emits
        // has_new_or_null_treatment and overwrites the wrapper's task_due_bucket fetch
        // (the deep-link 18-vs-64 race) — and after a popup close it would silently kick
        // the rep out of their task bucket back to the contacts 'New' tab. Resolve the
        // mode from the live refs (this fn is captured in effect closures that can hold a
        // stale newLeadTasksMode=false from mount); a tasks deep-link URL is always
        // authoritative (there is no manual toggle to override it any more).
        const liveTasksMode = newLeadTasksModeRef.current || isTasksDeepLinkUrl;
        const reloadPayLoad = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: liveTasksMode ? undefined : (checklistStateValue ? 'All' : contactCount),
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            bookedWidgetFilter,
            taskDueBucket: liveTasksMode ? (taskDueBucketRef.current || initialFilters.bucket || 'due_now') : undefined,
        };
        updateLeadPage(reloadPayLoad);
    };

    // Stable callback passed to NewLeadDataGrid for post-completion refresh.
    // Captures current filter state so checklist YES / undo don't wipe active filters.
    const refreshTableWithCurrentFilters = useCallback(() => {
        // #119: mirror the pagination path (handlePaginationChange ~line 2367) so a
        // post-bulk-Complete refetch preserves the active tasks-mode bucket. Without
        // this, the query dropped task_due_bucket and sent a
        // contacts-mode contactedCount → the overdue table collapsed to the No-Tasks set
        // until a manual reload. Gate on liveTasksMode; send the EXACT current bucket
        // (taskDueBucketRef.current || undefined — never force '|| due_today', which
        // would re-impose the filter on a deliberately-deselected bucket).
        const liveTasksMode = newLeadTasksModeRef.current || isTasksDeepLinkUrl;
        const payload = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            // contactedCount + taskDueBucket, shared with the
            // pagination path so tasks mode preserves the active bucket (never '|| due_today').
            ...taskModeReloadFields(liveTasksMode, {
                checklistStateValue,
                contactCount,
                taskDueBucket: taskDueBucketRef.current,
            }),
            forceRefetch: true,
        };
        updateLeadPage(payload);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [perPage, pageNumber, tableStatus, tableOrder, tableOrderBy, searchQuery, treatmentData, startDate, endDate, contactCount, checklistStateValue, searchTags, referral, practices, depositPendingStatus, bookedWithData, assigneeData, archiveReason, tableData, practiceId, isTasksDeepLinkUrl]);

    // Cheaper variant: only re-fetches badge counts, not the full list.
    // Used on every YES so badges update immediately without a table flash.
    const refreshCountersOnly = useCallback(() => {
        if (!(tableData && practiceId && wrappedReloadCounter)) return;
        // #119: same tasks-mode bucket preservation as refreshTableWithCurrentFilters —
        // the counter refetch must not drop task_due_bucket or
        // send a contacts-mode contactedCount, or the badge counts recompute against the
        // No-Tasks set. Never force '|| due_today' (keeps a deselected bucket deselected).
        const liveTasksMode = newLeadTasksModeRef.current || isTasksDeepLinkUrl;
        wrappedReloadCounter({
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: checklistStateValue ? undefined : treatmentData?.toString(),
            startDate,
            endDate,
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            ...taskModeReloadFields(liveTasksMode, {
                checklistStateValue,
                contactCount,
                taskDueBucket: taskDueBucketRef.current,
            }),
            forceRefetch: true,
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [perPage, pageNumber, tableStatus, tableOrder, tableOrderBy, searchQuery, treatmentData, startDate, endDate, contactCount, checklistStateValue, searchTags, referral, practices, depositPendingStatus, bookedWithData, assigneeData, archiveReason, tableData, practiceId, isTasksDeepLinkUrl]);

    const newLeadTaskWidgetRefreshGenerationRef = useRef(0);
    const refreshNewLeadTaskWidgetCounts = useCallback(() => {
        if (!practiceId || !newLeadTasksModeRef.current) return;
        newLeadTaskWidgetRefreshGenerationRef.current += 1;
        dispatch(getNewLeadTaskWidgetCounts(practiceId, searchQuery || null, newLeadTaskWidgetRefreshGenerationRef));
    }, [practiceId, searchQuery]);

    // When a checklist sub-strip filter is active (In Progress or Follow-Up Complete),
    // a task complete/reopen mutation can move the lead to a different state — the row
    // would stay in the wrong sub-strip until a manual refresh. Listen for the mutation
    // event and trigger a debounced table refetch (1 s trailing) when the sub-strip is
    // active. The check against checklistStateValue is captured in the stable callback
    // ref below so the event listener doesn't need to re-register on filter changes.
    const checklistStateValueRef = useRef(checklistStateValue);
    useEffect(() => { checklistStateValueRef.current = checklistStateValue; }, [checklistStateValue]);
    const refreshTableWithCurrentFiltersRef = useRef(refreshTableWithCurrentFilters);
    useEffect(() => { refreshTableWithCurrentFiltersRef.current = refreshTableWithCurrentFilters; }, [refreshTableWithCurrentFilters]);
    const refreshNewLeadTaskWidgetCountsRef = useRef(refreshNewLeadTaskWidgetCounts);
    useEffect(() => { refreshNewLeadTaskWidgetCountsRef.current = refreshNewLeadTaskWidgetCounts; }, [refreshNewLeadTaskWidgetCounts]);

    useEffect(() => {
        let debounceTimer = null;
        const handleMutation = () => {
            refreshNewLeadTaskWidgetCountsRef.current();
            if (!checklistStateValueRef.current) return; // All sub-tab — no row-removal needed
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                refreshTableWithCurrentFiltersRef.current();
            }, 1000);
        };
        window.addEventListener(TASKS_V2_CHANGED_EVENT, handleMutation);
        return () => {
            window.removeEventListener(TASKS_V2_CHANGED_EVENT, handleMutation);
            clearTimeout(debounceTimer);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Splice a lead row out of the local table state immediately (optimistic).
    // Returns { row, index } for later restore on undo.
    const removeRowOptimistically = useCallback((leadId) => {
        let removed = null;
        setTableData((prev) => {
            const idx = prev.findIndex(
                (r) => String(r.id) === String(leadId) || String(r.lead_id) === String(leadId)
            );
            if (idx === -1) return prev;
            removed = { row: prev[idx], index: idx };
            return [...prev.slice(0, idx), ...prev.slice(idx + 1)];
        });
        return removed;
    }, []);

    // Re-insert a previously removed row at its original index.
    const restoreRowOptimistically = useCallback((row, index) => {
        setTableData((prev) => {
            const insertAt = Math.min(index, prev.length);
            return [...prev.slice(0, insertAt), row, ...prev.slice(insertAt)];
        });
    }, []);

    // Checklist column definitions lifted from NewLeadDataGrid so FloatingBulkActionBar's
    // step-picker shows the same columns without a second API call.
    const [activeChecklistColumns, setActiveChecklistColumns] = useState([]);

    // Row identities that already have at least one recorded treatment payment, read off
    // the rows the table already holds (deposit_payment_data — the same field the payment
    // column renders). Lets bulk Complete mark a PAYMENT_METHOD step YES where the money
    // is logged instead of terminalising it as SKIPPED, with no extra request. Keyed by
    // row id, which on the flat tables is "<leadId>-<leadTreatmentId>" — payment-per-
    // treatment granularity, so one paid treatment can't vouch for another.
    // Lead id -> owning practice id, accumulated across pages so a cross-page
    // selection in "All Practices" mode still archives/restores each lead via its
    // own practice. Only populated when rows carry a practice (showPracticeColumn).
    const practiceByLeadIdRef = useRef({});
    const practiceByLeadId = useMemo(() => {
        if (showPracticeColumn) buildPracticeByLeadId(tableData, practiceByLeadIdRef.current);
        return showPracticeColumn ? { ...practiceByLeadIdRef.current } : undefined;
    }, [tableData, showPracticeColumn]);

    const paidRowIds = useMemo(() => {
        const ids = new Set();
        (tableData || []).forEach((row) => {
            if (Array.isArray(row?.deposit_payment_data) && row.deposit_payment_data.length > 0) {
                if (row?.id != null) ids.add(String(row.id));
            }
        });
        return ids;
    }, [tableData]);

    // Bulk checklist-complete machinery — mirrors the single-lead path in makeOnChecklistComplete:
    //   refreshCounters (badge update) → per-lead exit animation via NewLeadDataGrid → 6.5 s reconcile.
    // The grid registers its animator via setBulkCompleteAnimate (see onBulkCompleteReady prop below).
    const bulkCompleteAnimateRef = useRef(null);
    const setBulkCompleteAnimate = useCallback((fn) => {
        bulkCompleteAnimateRef.current = fn;
    }, []);

    const handleBulkComplete = useCallback((completedRowIds) => {
        refreshCountersOnly();
        refreshNewLeadTaskWidgetCounts();
        completedRowIds.forEach((rowId) => {
            if (bulkCompleteAnimateRef.current) {
                bulkCompleteAnimateRef.current(rowId);
            } else {
                // Grid not mounted (edge-case): fall back to instant removal.
                removeRowOptimistically(rowId);
            }
        });
        // P0 selection-integrity: prune the handled leads out of the Redux selection.
        // The grid is now controlled by `selectedLeadIds` (= multiLead.leadId), so
        // dropping these ids from Redux also unticks their checkboxes — no re-echo of
        // phantom ids (the old uncontrolled + keepNonExistentRowsSelected bug). On FULL
        // success the caller ALSO fires onClearSelection (clears everything); on PARTIAL
        // it does NOT, so pruning-only-completed leaves the leftover leads selected for a
        // retry. Read the live ref (not a captured `multiLead`) to avoid a stale closure.
        const currentSelection = multiLeadRef.current || { leadId: [], isFlatSelection: false };
        const current = currentSelection.leadId || [];
        // Flat tables receive exact `leadId-leadTreatmentId` row identities;
        // Booked/V1 receives lead ids. The helper supports both and therefore
        // never prunes an untouched sibling treatment after partial success.
        const remaining = pruneSelectedLeadIds(current, completedRowIds, {
            isFlatSelection: !!currentSelection.isFlatSelection,
        });
        if (remaining.length !== current.length) {
            dispatch(selectLeads({
                leadId: remaining,
                isFlatSelection: !!currentSelection.isFlatSelection,
                type: archType ? 'Restore' : 'Archive',
                loading: false,
            }));
        }
        // Reconcile: re-fetch after rows have animated out + server has settled.
        setTimeout(refreshTableWithCurrentFilters, 6500);
    }, [refreshCountersOnly, refreshNewLeadTaskWidgetCounts, removeRowOptimistically, refreshTableWithCurrentFilters, dispatch, archType]);

    // Persistent informational auto-skip surface.
    // Stores the grouped skip info returned after bulk Complete terminalizes
    // non-yes/no item types as server-side SKIPPED. Null = dialog hidden.
    // Each group is an array of lead-ID strings whose items of that type were skipped.
    // The dialog is cleared only by explicit "Got it" — never auto-dismissed.
    const [skipGroups, setSkipGroups] = useState(null);

    const handleItemsSkipped = useCallback((groups) => {
        const hasAny = groups && Object.values(groups).some((ids) => ids.length > 0);
        if (hasAny) setSkipGroups(groups);
    }, []);

    // UUID guard: composite ids like `${leadId}-${idx}` must never hit /tasks/{id}/complete/
    const V2_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    const handleClose = (status, data) => {
        if (!pmsBookingSession.reset()) return;
        dispatch(setLoader(false));
        // Complete the actioned V2 task when the popup closed after a genuine save.
        // markAsComplete is set true by AppointmentPage.onSubmit on 'finish' and
        // false by OpenContactLeadPopup.handleClose on cancel/backdrop/Escape.
        const pendingTaskId = pendingV2TaskIdRef.current;
        pendingV2TaskIdRef.current = null; // always clear, prevents stale id on next open
        if (markAsComplete && pendingTaskId && V2_UUID_RE.test(String(pendingTaskId))) {
            dispatch(updateCompleteStatus(false)); // reset flag so next cancel doesn't re-fire
            dispatch(completeTask(practiceId, pendingTaskId, () => {}));
        }
        // Task #46: keep the post-popup-close reload inside the active task bucket
        // (live refs — handleClose is captured in effect closures with a possibly stale
        // newLeadTasksMode). Otherwise a save in tasks mode kicks the rep back to contacts.
        const liveTasksMode = newLeadTasksModeRef.current || isTasksDeepLinkUrl;
        const reloadPayLoad = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: liveTasksMode ? undefined : (checklistStateValue ? 'All' : contactCount),
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            bookedWidgetFilter,
            taskDueBucket: liveTasksMode ? (taskDueBucketRef.current || initialFilters.bucket || 'due_now') : undefined,
            // Required so the post-mutation refetch bypasses the 8s GET de-dupe in
            // coreThunks (the _t cache-buster is only appended when forceRefetch is set).
            // Mirrors the sibling refreshTableWithCurrentFilters and refreshCountersOnly payloads.
            forceRefetch: true
        };

        const shouldRefreshAfterFinish = status?.toLowerCase?.() === 'finish'
            && followUpLead !== 'restoreArchived'
            && data?.skipTableRefresh !== true;

        if (shouldRefreshAfterFinish) {
            dispatch(updateCounter([]));
            updateLeadPage({ ...(!isEmpty(data) && isPlainObject(data) ? data : reloadPayLoad), forceRefetch: true });
            dispatch(getLeadReminderData(practiceId, 'dashboard', limit, offset, filter, '', assignUser, '', '', '', '', '', '', '', ''));
            if (reloadTaskCounter) {

                reloadTaskCounter(assignUser);
            }
            if (dashType || newType) {
                dispatch(dashNewTableCounter(practiceId));
            }
            if (wrappedReloadCounter) {
                wrappedReloadCounter(typeof data === 'object' ? data : reloadPayLoad);
            }
            refreshNewLeadTaskWidgetCounts();
        }
        open.onFalse();
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateSteps(null));
        dispatch(updateFollowUpLead(null));
        onCloseFollowLead();
        onCloseConsultationAttend();
        onCloseRecordAttend();
        onCloseUnRecordAttend();
        onCloseArchiveLead();
        onCloseRestoreArchived();
        closeDuplicatePopup();
        closeUnMarkAsDuplicate();
        closeMarkAsSpamDialog();
        setStartTreatment('');
        onCloseContactLead();
        setContactLeadDefaultTab('overview');
        setConsultationAttendSidebarTab(null);
        setStartConfirmation(false);
        dispatch(setCallScriptSection(null));
        setAnchorClinCheck(null);
        // Reset Dentally follow-up booking state
        setDentallySlot(null);
        setSelectedDentallyTreatment(null);
        setDentallyAssignees([]);
        // Reset PMS scheduling state
        setPmsSlot(null);
        setPmsPractitioner(null);
        setPmsDate(null);
        setUseDentallyFlow(true);
        setForceUpdate((prev) => !prev);
        // Prevent action/markAsComplete state from prior popup bleeding into the next lead's flow.
        dispatch(setAction(null));
        dispatch(updateCompleteStatus(false));
        // Only reload after a genuine save ('finish'). Cancel / backdrop / Escape
        // must leave the table exactly as-is — nothing changed, so no refetch.
        if (shouldRefreshAfterFinish) {
            handleReloadLeads();
        }
    };

    // Called by OpenConsultationPopup when the user sends an email or WhatsApp
    // from the sidebar while the attended popup is open via a task cell.
    // Completes the originating task and refreshes the table without closing the popup.
    const handleConsultationSendComplete = useCallback(() => {
        const taskId = pendingV2TaskIdRef.current;
        if (taskId && V2_UUID_RE.test(String(taskId))) {
            pendingV2TaskIdRef.current = null;
            dispatch(completeTask(practiceId, taskId, () => {
                refreshTableWithCurrentFiltersRef.current();
                refreshNewLeadTaskWidgetCounts();
            }));
        }
    }, [practiceId, refreshNewLeadTaskWidgetCounts]);

    useEffect(() => {
        if (forceReload) {
            handleReloadLeads();
        }
    }, [forceReload]);

    const STEPS = [
        {
            label: 'Contact',
            component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />,
        },
    ];

    const [leadStep, setLeadStep] = useState(STEPS);

    const { currentTab: filterStatus, onChangeTab: onChangeFilterStatus, setCurrentTab } = useTabs(SelectTableTab(type));

    // Merge custom-tab hidden_filters on top of the parent's. When the user
    // is on a "custom:<id>" tab, look up that tab record and union its
    // hidden_filters with the practice-level set declared higher up.
    //
    // Two paths produce a custom-tab scope:
    //   1. Inline custom-tab click (legacy: Newest Leads etc.) — sets `filterStatus`
    //      to 'custom:<id>'. We read that here.
    //   2. Wrapper-driven top-placement custom tab (ConsultantAttend / TreatmentStarted)
    //      — the parent page passes `controlledCustomTabId` directly; NewLead's
    //      internal filterStatus is NOT updated by that path, so we have to look
    //      at the prop too. Otherwise per-custom-tab hidden_filters silently
    //      never apply for top-placement custom tabs.
    const activeCustomTab = (() => {
        if (controlledCustomTabId !== undefined && controlledCustomTabId !== null) {
            return customTabs?.find?.((t) => Number(t.id) === Number(controlledCustomTabId)) || null;
        }
        if (typeof filterStatus !== 'string' || !filterStatus.startsWith('custom:')) return null;
        const id = filterStatus.slice('custom:'.length);
        return customTabs?.find?.((t) => String(t.id) === id) || null;
    })();
    const hiddenFilters = activeCustomTab
        ? [...baseHiddenFilters, ...(activeCustomTab.hidden_filters || [])]
        : baseHiddenFilters;

    // The MUI Tabs indicator (the green underline) slides to the tab whose `.value`
    // matches the parent `<Tabs value={...}>` prop. The historical pattern is
    // `notAllType ? contactCount : filterStatus` — fine for categorical sub-tabs
    // (FU1/FU2/FU3+) where contactCount tracks the click, and for status sub-tabs
    // (NEW/CONSULTATION_BOOKED) where filterStatus tracks it. But custom tabs and
    // the synthetic "All" tab use `filterStatus` to track the click on every parent
    // — contactCount is unchanged on click — so the indicator never moves on
    // non-`!notAllType` parents (Newest Leads, Consultation Attended, etc.) when a
    // custom or All tab is active. This helper falls back to `filterStatus` for those
    // two cases, preserving existing behaviour everywhere else.
    // Maps each tab strip's runtime value → its admin slug. Used by `labelCount`
    // to resolve the per-practice label override (set via TableDefaults inline
    // rename). Keyed by `type` so the same NewLead component picks the right
    // map for whatever parent table it's rendering.
    // Each strip value → admin slug. 'All' is the value of the synthetic reset
    // tab injected by the custom-tabs append effect below — must be mapped on
    // every parent so renames to the 'all' slug survive into labelCount().
    // Keep this map in lockstep with the `typeToParent` map further down — if a
    // parent is listed there, it should be listed here too, or label-override
    // renames silently drop on the floor.
    const stripSlugMap = useMemo(() => {
        if (type === 'ConsultantAttend') return { All: 'all' };
        if (type === 'NewLeadTable' || type === 'DashNewLeadTable') return { 0: 'category-new', NHS: 'category-nhs', AWAITING_RESPONSE: 'category-awaiting', 1: 'follow-up-1', 2: 'follow-up-2', 3: 'follow-up-3', All: 'all' };
        if (type === 'NoTaskTable') return { NEW: 'status-new', FOLLOW_UP: 'status-follow-up', CONSULTATION_BOOKED: 'status-consultation-booked', CONSULTATION_ATTENDED: 'status-consultation-attended', FAILED_TO_ATTEND_CONSULTATION: 'status-fta', All: 'all' };
        // Parents with no native category strip — only the synthetic 'All' tab.
        if (type === 'ConsultantBooked' || type === 'AttendedChecklists' || type === 'ConsultantClinCheckAttend') return { All: 'all' };
        return {};
    }, [type]);

    // When the active top-placement custom tab has hidden_sub_tabs, filter the
    // inherited inline strip to only show the slugs the tab allows.
    // When it has checklist_binding.template_ids, render the checklist strip
    // AS WELL AS the normal contacted-count strip (non-destructive composition —
    // task #100 Risk 2). Standalone AttendedChecklists route still shows only the
    // checklist strip (handled by `type === 'AttendedChecklists'` branch which
    // already feeds ATTENDED_CHECKLISTS_TAB_HEAD via setHeading at line 644-645).
    // stripSlugMap must be declared above this useMemo (TDZ guard).
    const checklistStripActive = !!(activeCustomTab?.checklist_binding?.template_ids?.length);

    // V2 checklist empty-state detection (Risk 1, task #98).
    // V1 practices never reach this branch (gated on `tasks-v2`). For V2
    // practices that show zero rows on a checklist surface — either no
    // SystemTaskTemplates configured for this table, or no Tasks auto-created
    // yet — render an EmptyState with guidance instead of a silent blank table.
    // We deliberately don't differentiate templates-vs-tasks because the
    // /tasks/table-columns/ probe requires lead_ids to return columns; with
    // zero rows the probe would always return zero columns and the
    // differentiation collapses. The copy covers both causes.
    const isV2EnabledForPractice = practiceId ? hasFeatureAccess('tasks-v2', practiceId) : false;
    const checklistEmptyStateProbeEnabled = isV2EnabledForPractice && (attendedChecklistsType || checklistStripActive);

    // New Lead "Tasks / Due" mode — V2 practices on the NewLeadTable are Tasks-only
    // (resolveNewLeadViewMode forces 'tasks'); non-V2 practices always get 'contacts'.
    // `_newLeadViewModeKey` is the per-practice localStorage key a pre-launch build
    // used to persist the rep's manual Contact-attempts/Tasks choice. That toggle no
    // longer exists, so the key is write-only now — see the stale-key-clear effect
    // below (Task 1, mode-cleanup) for why it's still written.
    const _newLeadViewModeKey = newType && practiceId ? `newLead:viewMode:${practiceId}` : null;
    const [newLeadViewMode, setNewLeadViewMode] = useState(() => {
        if (!newType || !practiceId) return 'contacts';
        return resolveNewLeadViewMode(isV2EnabledForPractice);
    });
    // Whether the Tasks widget strip is currently active (V2 + NewLeadTable + tasks mode).
    const newLeadTasksMode = newType && isV2EnabledForPractice && newLeadViewMode === 'tasks';

    // isTasksDeepLinkUrl moved up to line ~478 (right after its deps) — #121 TDZ hotfix.

    // ── Task #46: live tasks-mode mirror (read by the practiceTreatment effect) ──
    // The practiceTreatment effect (deps [practiceId, practiceTreatment, ...]) does NOT
    // depend on newLeadViewMode, so its closure can hold a STALE newLeadTasksMode=false
    // (captured at mount before permissions settled and the view-mode was corrected to
    // 'tasks'). When it then re-fires on practiceTreatment load it would dispatch a
    // contacts-mode getNewLead (contactedCount='0' → has_new_or_null_treatment) that races
    // and overwrites the wrapper's correct task_due_bucket fetch — the deep-link 18-vs-64
    // bug. These refs give that effect the LIVE mode regardless of its stale closure.
    const newLeadTasksModeRef = useRef(newLeadTasksMode);
    useEffect(() => { newLeadTasksModeRef.current = newLeadTasksMode; }, [newLeadTasksMode]);

    // ── RCA 1: mode-gate the contact-attempts counter fan-out ────────────────
    // reloadCounter (NHS / No-Treatment / Awaiting / 4× NEW_TAB_HEAD = 7 dispatches)
    // backs the contacted-count badges, which are only rendered in Contact-attempts
    // mode — in Tasks mode they're hidden, so the fan-out is pure waste on every
    // load, filter, search and pagination change. Single chokepoint: every internal
    // reloadCounter(...) call site (and every place it's forwarded to a child, e.g.
    // NewLeadDataGrid) now goes through this wrapper instead of the raw prop. Reads
    // newLeadTasksModeRef (not newLeadTasksMode) so a stale effect closure can't
    // leak a wrong mode. Scoped to the NewLeadTable page only — for every other
    // table type newLeadTasksMode is permanently false (newType gate), so this is a
    // no-op there and their own reloadCounter always fires as before.
    // The skip/fire decision is a pure predicate (shouldSkipCounterReload, in
    // newLeadCounterGate.js) rather than an inline condition here specifically so
    // its POLARITY is unit-tested directly — see that module for why.
    const wrappedReloadCounter = useCallback((...callArgs) => {
        if (!reloadCounter) return;
        if (shouldSkipCounterReload(newLeadTasksModeRef.current)) return;
        reloadCounter(...callArgs);
    }, [reloadCounter]);

    // Active task_due_bucket filter. Defaults to 'due_now' (Task N — overdue ∪
    // due_today) when entering Tasks mode so the most immediately actionable
    // bucket is pre-selected. Cleared on switch back to contacts mode.
    // URL param ?bucket=overdue|due_today|due_now from a Launchpad deep-link
    // overrides the default when present — only when the page also opens in
    // tasks mode (URL param or localStorage).
    const [taskDueBucket, setTaskDueBucket] = useState(
        () => {
            if (!(newType && isV2EnabledForPractice && newLeadViewMode === 'tasks')) return null;
            return initialFilters.bucket || 'due_now';
        },
    );
    // Mirror of taskDueBucket kept in a ref so that effects with other dep-arrays
    // (e.g. the initial-load effect that depends on practiceTreatment) always read
    // the live bucket value without needing to add taskDueBucket to their dep arrays
    // (which would cause infinite reload loops).
    const taskDueBucketRef = useRef(taskDueBucket);

    // Keep taskDueBucketRef in sync with taskDueBucket state so effects with other
    // dep-arrays can read the live value without adding taskDueBucket as a dependency.
    useEffect(() => { taskDueBucketRef.current = taskDueBucket; }, [taskDueBucket]);
    const setTaskBucket = useCallback((bucket) => {
        setTaskDueBucket(bucket);
        taskDueBucketRef.current = bucket;
    }, []);
    const currentTaskModeFields = useCallback((bucket = taskDueBucketRef.current, requestedContactCount = contactCount) => (
        taskModeReloadFields(newLeadTasksModeRef.current || isTasksDeepLinkUrl, {
            checklistStateValue,
            contactCount: requestedContactCount,
            taskDueBucket: bucket,
        })
    ), [checklistStateValue, contactCount, isTasksDeepLinkUrl]);

    // ── Permissions-correction effect (task #46) ──────────────────────────────
    // The `newLeadViewMode` lazy initializer runs once at mount. If permissions
    // hadn't settled for the current practice at that moment, `hasFeatureAccess`
    // returned false, and `newLeadViewMode` was permanently locked to 'contacts'
    // even though the URL says ?viewMode=tasks.
    //
    // This one-shot effect fires when `permissionsReady` becomes true. If the URL
    // requested tasks mode but the lazy init guessed 'contacts', we correct both
    // state values so the UI (toggle strip, widget row) reflects the right mode.
    // The `hasCorrectedModeRef` guard fires it at most once per mount.
    //
    // NOTE: this effect deliberately does NOT call updateLeadPage. The initial fetch
    // is owned by the wrapper (NewLeadTable.jsx via its initialFetchFiredRef gate),
    // which fires ONE correctly-scoped getNewLead call after permissionsReady. This
    // separation prevents the three-fetch race that occurred when both this effect
    // and the practiceTreatment effect independently dispatched updateLeadPage.
    const hasCorrectedModeRef = useRef(false);
    // Reset on practice switch so the incoming practice re-evaluates the mode
    // correction. Without this reset, navigating between practices on a deep-link
    // URL skips the correction for the second (and subsequent) practice because the
    // latch from the first practice's mount remains true.
    useEffect(() => {
        hasCorrectedModeRef.current = false;
    }, [practiceId]); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Task #36 cold-mount race guard ────────────────────────────────────────
    // The [followUpLead] effect below fires on EVERY mount because Redux initialises
    // followUpLead to null, so !followUpLead is always true on first render. That
    // cold-mount call to handleClose() → handleReloadLeads() runs before
    // newLeadTasksModeRef has settled (isV2EnabledForPractice is still async), so
    // liveTasksMode resolves false and fires a CONTACTS-mode reload
    // (contactedCount='0' → has_new_or_null_treatment=true) that races and overwrites
    // the wrapper's correct tasks-mode fetch (task_due_bucket=due_today).
    //
    // e8ce9cc6f fixed the CLOSE path; this ref fixes the MOUNT path.
    // The wrapper (NewLeadTable.jsx initialFetchFiredRef) already owns the initial
    // fetch, so skipping the spurious mount call is always safe.
    const followUpLeadMountedRef = useRef(false);
    useEffect(() => {
        if (!permissionsReady) return;
        if (hasCorrectedModeRef.current) return;
        hasCorrectedModeRef.current = true;

        // Correct when: NewLeadTable, Tasks V2 is now confirmed enabled, and the lazy
        // init guessed contacts before permissions settled. Task 1 (mode-cleanup):
        // resolveNewLeadViewMode is V2-only — 'tasks' for V2 practices, 'contacts'
        // otherwise. URL/localStorage no longer participate in this decision at all
        // (the stale `newLead:viewMode:{practiceId}` key is cleared, not read, by the
        // effect below). Non-V2 practices bail out below, unaffected.
        if (!newType) return;
        if (newLeadViewMode === 'tasks') return; // already correct — no-op
        const isV2NowEnabled = hasFeatureAccess('tasks-v2', practiceId);
        if (resolveNewLeadViewMode(isV2NowEnabled) !== 'tasks') return;

        // The lazy init made the wrong call. Fix UI state only — no fetch here.
        // (No localStorage write here — the stale-key-clear effect below already
        // persists 'tasks' unconditionally for every V2 mount.)
        const correctedBucket = initialFilters.bucket || 'due_now';
        setNewLeadViewMode('tasks');
        setTaskDueBucket(correctedBucket);
        taskDueBucketRef.current = correctedBucket;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissionsReady]);

    // ── Task 1 (mode-cleanup, 2026-07-04): clear the stale view-mode localStorage key ──
    // A pre-launch build let reps manually toggle Contact-attempts/Tasks and persisted
    // the choice to `newLead:viewMode:{practiceId}`. That toggle is gone and
    // resolveNewLeadViewMode never reads this key any more, but a stale 'contacts'
    // value written before the launch would otherwise sit in localStorage forever —
    // a landmine for any future code (e.g. a rollback) that starts trusting it again.
    // Runs once per (practiceId) mount for every V2 practice on the NewLeadTable,
    // regardless of whether the permissions-correction effect above actually fires a
    // correction (it no-ops on a warm mount where newLeadViewMode is already 'tasks',
    // which used to leave a stale 'contacts' value untouched).
    const hasClearedStaleViewModeKeyRef = useRef(false);
    useEffect(() => {
        hasClearedStaleViewModeKeyRef.current = false;
    }, [practiceId]);
    useEffect(() => {
        if (!_newLeadViewModeKey || !isV2EnabledForPractice) return;
        if (hasClearedStaleViewModeKeyRef.current) return;
        hasClearedStaleViewModeKeyRef.current = true;
        try { localStorage.setItem(_newLeadViewModeKey, 'tasks'); } catch { /* ignore */ }
    }, [_newLeadViewModeKey, isV2EnabledForPractice]);

    // NOTE: the old "smart default" effect that silently switched due_today → first
    // non-empty bucket (overdue/upcoming/...) once widget counts arrived has been REMOVED
    // (task #28). The BE now defines "Due today" = due ≤ today (overdue ∪ today), so the
    // default due_today bucket is no longer spuriously empty when there are overdue leads.
    // Silently redirecting the bucket caused the highlighted card label to diverge from the
    // rendered table set and the card count. The selected bucket must ALWAYS match what is
    // rendered + the card count; URL deep-link buckets must never be silently changed.

    // Called by NewLeadTaskDueWidget when a bucket card is clicked.
    // Stores the selection and reloads the table with task_due_bucket set.
    // Passing null clears the filter (second click on the active card).
    const handleBucketSelect = (bucket) => {
        // User made an explicit selection — store it and reload. The selected bucket is
        // the single source of truth for both the highlighted card and the rendered rows.
        setTaskBucket(bucket);
        updateLeadPage({
            limit: perPage,
            offset: 0,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: 'All',
            tags: searchTags,
            referral,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            noTreatment: false,
            ...currentTaskModeFields(bucket),
        });
    };

    // M-2: when a checklist tab returns 0 rows, the JSX renders EmptyContent instead
    // of NewLeadDataGrid. That means NewLeadDataGrid's internal clearing effect never
    // fires and isChecklistSwitching would stay true — causing a stuck loading gate on
    // the next tab switch. Reset it here once loadingForLead clears with 0 rows.
    useEffect(() => {
        if (!isChecklistSwitching) return;
        if (loadingForLead) return;
        if ((tableData?.length || 0) > 0) return;
        // 0 rows + loading done → EmptyContent path; NewLeadDataGrid is unmounted.
        setIsChecklistSwitching(false);
    }, [isChecklistSwitching, loadingForLead, tableData]);

    const displayedHeadings = useMemo(() => {
        if (!activeCustomTab?.hidden_sub_tabs?.length) return headings;
        const hiddenSlugs = new Set(activeCustomTab.hidden_sub_tabs);
        return headings.filter((h) => {
            const slug = stripSlugMap[String(h.value)];
            return !slug || !hiddenSlugs.has(slug);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [headings, activeCustomTab, stripSlugMap]);
    const stripParentForOverrides = useMemo(() => {
        if (type === 'ConsultantAttend') return 'Consultation Attended Leads';
        if (type === 'NewLeadTable' || type === 'DashNewLeadTable') return 'Newest Leads';
        if (type === 'NoTaskTable') return 'No Task Assigned';
        if (type === 'ConsultantBooked') return 'Consultation Booked Leads';
        if (type === 'AttendedChecklists') return 'Attended Checklists';
        if (type === 'ConsultantClinCheckAttend') return 'Consultation ClinCheck Leads';
        if (type === 'treatmentStarted') return 'Treatment Started Leads';
        return null;
    }, [type]);

    // Memoised because `labelCount` (called per-tab in the strip render) reads
    // activeStripValue to compute `isActive` on every cell — a string identity
    // change cascades to all tab badges. Inputs are all primitives, so the memo
    // only invalidates when the value actually changes (not on every render).
    const activeStripValue = useMemo(() => {
        const isCustomOrAll = typeof filterStatus === 'string'
            && (filterStatus === 'All' || filterStatus.startsWith('custom:'));
        const candidate = isCustomOrAll ? filterStatus : (notAllType ? contactCount : filterStatus);
        // When 'All' is the candidate but no Tab child actually carries that value (e.g. the
        // NewLeadTable contacted-count strip only has '0'/'1'/'2'/'3'), return false so MUI Tabs
        // renders "no tab selected" without a console warning. Only applies when the strip is
        // visible (displayedHeadings.length > 0); skipped for ConsultantAttend custom-tab mode
        // where an 'All Attended' Tab genuinely exists.
        if (
            candidate === 'All'
            && displayedHeadings.length > 0
            && !displayedHeadings.some((h) => (treatmentStartedType ? h?.id : h.value) === 'All')
        ) {
            return false;
        }
        return candidate;
    }, [filterStatus, notAllType, contactCount, displayedHeadings, treatmentStartedType]);

    useEffect(() => {
        dispatch(selectLeads({ leadId: [], type: '', loading: false }));
    }, [filterStatus]);

    // A flat selection is scoped to the exact filtered/task-mode dataset whose
    // composite row ids produced it. Clear only flat selections when that scope
    // changes so stale treatment rows cannot leak into a new filter, custom tab,
    // practice, or task bucket. V1 selection behavior remains unchanged. Page is
    // intentionally excluded: keepNonExistentRowsSelected supports cross-page
    // selection, and the API boundary dedupes those rows per canonical lead.
    const clearFlatSelection = useCallback(() => {
        dispatch(selectLeads({ leadId: [], type: '', loading: false }));
    }, []);
    useFlatSelectionScopeReset({
        practiceId,
        activePracticeIdsKey,
        type,
        filterStatus,
        tableStatus,
        searchValue,
        searchQuery,
        searchFilterTags,
        treatmentData,
        noTreatmentFilter,
        startDate,
        endDate,
        contactCount,
        contactedCountFilterValue,
        checklistStateValue,
        referral,
        practices,
        bookedWithData,
        consultationBookedWithData,
        assigneeData,
        category,
        depositPendingStatus,
        archiveReason,
        apptType,
        bookedWidgetFilter,
        activeFilterLabel: activeFilterLabel || internalActiveWidget?.label || null,
        currentWidget,
        controlledCustomTabId,
        selectedTab,
        displayForCategorySummary,
        leadCategoryType,
        newLeadViewMode,
        taskDueBucket,
    }, multiLeadRef, clearFlatSelection);

    // Lead id -> the LeadTreatment row the Treatment column is showing, so the bulk
    // bar can re-point that exact treatment instead of guessing one. Cross-page
    // selections are absent here and are resolved by the bar via the API, narrowed
    // to the LeadTreatment status this table lists (read off the rows themselves so
    // the status mapping is never duplicated).
    const treatmentTargets = useMemo(() => {
        const map = {};
        (tableData || []).forEach((row) => {
            if (row?.lead_id && row?.treatment_id) map[String(row.lead_id)] = row.treatment_id;
        });
        return map;
    }, [tableData]);
    const treatmentTargetStatus = useMemo(
        () => (tableData || []).find((row) => row?.status)?.status || undefined,
        [tableData]
    );

    // Reconcile selection when rows refresh underneath the controlled grid. A
    // dataset-mode transition (notably ConsultantAttend flat rows to a V1 lead
    // dataset) invalidates the entire old model; within the same mode, preserve
    // cross-page ids and remove only invalid/pending current-row ids.
    useEffect(() => {
        const currentSelection = multiLeadRef.current;
        if (!currentSelection?.leadId?.length) return;
        if (!selectionMatchesRows(currentSelection, tableData)) {
            dispatch(selectLeads({ leadId: [], type: '', loading: false }));
            return;
        }
        const cleaned = cleanSelectionModel(currentSelection.leadId, tableData, {
            isFlatSelection: !!currentSelection.isFlatSelection,
        });
        if (cleaned.length !== currentSelection.leadId.length) {
            dispatch(selectLeads({
                ...currentSelection,
                leadId: cleaned,
            }));
        }
    }, [tableData]);

    const dataFiltered = applySortFilter({
        tableData,
        filterStatus,
    });

    const isNotFound =
        (!dataFiltered.length && (!!filterStatus || filterStatus === 0 ? true : filterStatus)) || !dataFiltered;
    const bookedWithLabel = getUserList()
        .filter((el) => bookedWithData.includes(el.user.id))
        ?.map((ele) => `${ele?.user?.salutation || ''} ${ele?.user?.first_name || ''} ${ele?.user?.last_name || ''}`);
    const consultationBookedWithLabel = getUserList()
        .filter((el) => consultationBookedWithData.includes(el.user.id))
        ?.map((ele) => `${ele?.user?.salutation || ''} ${ele?.user?.first_name || ''} ${ele?.user?.last_name || ''}`);

    const defaultValues = {
        multiSelect: treatmentData || [],
        referral: referral || '',
        practices: practices || '',
        category,
        bookedWith: bookedWithData ? bookedWithLabel : [] || [],
        consultationBookedWith: consultationBookedWithData ? consultationBookedWithLabel : [] || [],
        multiSelectAssignee: assigneeData || [],
        archiveReason: archiveReason || '',
    };

    const methods = useForm({
        defaultValues,
    });

    const { setValue, handleSubmit } = methods;

    const { toggle: openContacts, onClose: onCloseContacts } = useToggle();

    const { toggle: leadDetailModal, onOpen: onLeadDetail, onClose: onCloseLeadDetail } = useToggle();

    const { toggle: openFollowLead, onOpen: onOpenFollowLead, onClose: onCloseFollowLead } = useToggle();

    const {
        toggle: openConsultationAttend,
        onOpen: onOpenConsultationAttend,
        onClose: onCloseConsultationAttend,
    } = useConsultationAttendToggle();

    const {
        toggle: openRecordAttend,
        onOpen: onOpenRecordAttend,
        onClose: onCloseRecordAttend,
    } = useRecordAttendToggle();

    const { toggle: openAttendedNote, onOpen: onOpenAttendedNote, onClose: onCloseAttendedNote } = useToggle();

    const {
        toggle: openUnRecordAttend,
        onOpen: onOpenUnRecordAttend,
        onClose: onCloseUnRecordAttend,
    } = useUnRecordAttendToggle();

    const {
        toggle: openRestoreArchived,
        onOpen: onOpenRestoreArchived,
        onClose: onCloseRestoreArchived,
    } = useRestoreArchived();

    const { toggle: openArchiveLead, onOpen: onOpenArchiveLead, onClose: onCloseArchiveLead } = useArchivedToggle();

    const { toggle: openAddTreatment, onOpen: onOpenAddTreatment, onClose: onCloseAddTreatment } = useAddTreatment();

    const { toggle: OpenReSchedule, onOpen: onOpenReSchedule, onClose: onCloseReSchedule } = useToggle();

    const { toggle: toggleDuplicatePopup, onOpen: openDuplicatePopup, onClose: closeDuplicatePopup } = useToggle();
    const {
        toggle: toggleUnMarkAsDuplicate,
        onOpen: openUnMarkAsDuplicate,
        onClose: closeUnMarkAsDuplicate,
    } = useToggle();

    const {
        toggle: toggleMarkAsSpam,
        onOpen: openMarkAsSpamDialog,
        onClose: closeMarkAsSpamDialog,
    } = useToggle();

    const {
        toggle: openContactLead,
        onOpen: onOpenContactLead,
        onClose: onCloseContactLead,
    } = useToggle();

    const {
        toggle: openAppointment,
        onOpen: onOpenAppointment,
        onClose: onCloseAppointment
    } = useAppointmentToggle();

    const handleReScheduleClose = () => {
        onCloseReSchedule();
        handleClose('finish');
    };

    const handleAppointmentClose = () => {
        onCloseAppointment();
        handleClose('finish');
    };

    const editDetailHandler = () => onLeadDetail();

    const closeEditDetails = () => {
        handleReloadAPI('finish');
        onCloseLeadDetail();
    };

    useEffect(() => {
        if (practiceUser) {
            const getUserList = () =>
                practiceUser?.results?.filter((el) => el.user && el.user.first_name && !el.user.is_superuser);
            const data = _.orderBy(
                getUserList(),
                [(o) => (o.user?.first_name).toLowerCase(), (o) => (o.user?.last_name).toLowerCase()],
                ['asc', 'asc']
            );
            setUserList(data);
        }
    }, [practiceUser]);

    useEffect(() => {
        if (filterStatus && headings) {
            const filteredData = commonType
                ? treatmentStartedType
                    ? headings.filter((el) => Number(el.id) === Number(filterStatus))[0]?.name
                    : headings.filter((el) => el.value === filterStatus)[0]?.label
                : '';
            setFilters({
                status: filteredData,
                treatment: treatmentValue,
                tags: searchFilterTags,
                referral: referralData?.filter((e) => e.value === referral)[0]?.label || '',
                startDate,
                practices,
                endDate,
                assignTo: bookedWith,
                consultationBookedWith,
                statusLabel:
                    (consultantBookedType && 'Appointment method') || (treatmentStartedType && 'Treatment category') || '',
                depositPaidFilter: depositPendingStatus,
                assigneeSelectedForFilter,
                archiveReason: archiveReasonData?.filter((e) => e.value === archiveReason)[0]?.label || '',
            });
        }
    }, [
        filterStatus,
        headings,
        treatmentValue,
        searchFilterTags,
        referral,
        practices,
        startDate,
        endDate,
        bookedWith,
        consultationBookedWith,
        userList,
        depositPendingStatus,
        assigneeSelectedForFilter,
        archiveReason,
    ]);

    const handleStartedTablePayload = (payloadData) => {
        if (!treatmentStartedType) return;
        payloadData.consultationBookedWith = consultationBookedWithData?.toString();
        payloadData.apptType = apptType;
    };

    useEffect(() => {
        const practiceMap = {};
        practiceTreatment?.results?.forEach?.(val => {
            practiceMap[val?.id] = val?.name
        })
        setPracticeListMap(practiceMap);
        setRowsPerPage(perPage);
        setPage(pageNumber / perPage);
        setPaginationModel({ pageSize: perPage, page: pageNumber / perPage });
        // On checklist-bound tabs, treatment and contactedCount must not leak into
        // API calls — the tab's filter scope comes from customTabId / checklistState.
        // This useEffect fires when practiceTreatment loads (after a tab switch), at
        // which point treatmentData may still hold a prior-tab value from Redux.
        //
        // ── Task #46 ──────────────────────────────────────────────────────────────
        // Resolve tasks-mode from the LIVE ref (not the stale closure) so a re-fire on
        // practiceTreatment load can't dispatch a contacts-mode (has_new_or_null_treatment,
        // contactedCount='0') fetch that races and overwrites the wrapper's task_due_bucket
        // fetch. A tasks deep-link URL is always authoritative here, covering the
        // sub-render window before the mode ref flips (there is no manual toggle any more).
        const liveTasksMode = newLeadTasksModeRef.current || isTasksDeepLinkUrl;
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: checklistStateValue ? undefined : treatmentData?.toString(),
            startDate,
            endDate,
            // In tasks mode the BE owns the NEW base via task_due_bucket — never send a
            // contacts-mode contacted-count partition (would emit has_new_or_null_treatment).
            contactedCount: liveTasksMode ? undefined : (checklistStateValue ? 'All' : contactCount),
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            // Use the ref (not the state value) so that if the smart-default effect
            // has already switched the bucket (e.g. to 'overdue' because due_today is
            // empty) and this effect re-fires due to practiceTreatment loading, we
            // send the already-chosen bucket rather than clobbering it with 'due_now'.
            taskDueBucket: liveTasksMode ? (taskDueBucketRef.current || initialFilters.bucket || 'due_now') : undefined,
            // Only request the overdue-task count annotation when in tasks mode;
            // passing undefined omits the param entirely for Contact-attempts mode.
        };
        handleStartedTablePayload(payloadData);

        // ── Task #46: single-fetch gate ───────────────────────────────────────────
        // For NewLeadTable, the wrapper (NewLeadTable.jsx) owns the initial fetch via
        // its own `initialFetchFiredRef` effect keyed on [practiceId, permissionsReady].
        // That effect fires ONE correctly-scoped getNewLead (tasks-mode if the URL
        // carries ?viewMode=tasks, contacts-mode otherwise) and sets the ref to true.
        //
        // `externalInitialFetchRef` is that same ref, passed in as a prop. While it's
        // false (initial fetch not yet fired), this effect skips updateLeadPage and
        // reloadCounter — both would fire contacts-mode params because this effect
        // runs before permissionsReady resolves and before newLeadViewMode is corrected.
        // The non-fetch side-effects (loadCustomTabs, startLoadingData, updateDashNewLead)
        // still fire so the table shell renders correctly while the fetch is pending.
        //
        // Once externalInitialFetchRef.current is true (wrapper fired the initial fetch),
        // this effect's subsequent firings (on practiceTreatment reload, practice switch,
        // tab change, etc.) are allowed through normally.
        //
        // For all other table types (no externalInitialFetchRef prop), this gate is a
        // no-op and the effect fires as it always has.
        const deferredToWrapper = externalInitialFetchRef && !externalInitialFetchRef.current;
        if (wrapperOwnsCurrentPractice) {
            // ConsultantAttend owns every list/counter hydration for this practice,
            // including re-fires after its initial request. Preserve support data
            // and shell state, but never compete for the shared lead-table slice.
            if (isReportData && practiceId) dispatch(getPracticeItem(practiceId));
            if (practiceId) dispatch(loadCustomTabs(practiceId));
            // Pending hydration needs an empty/loading shell. Once the wrapper has
            // dispatched, later practiceTreatment updates have no matching list
            // request and therefore must not re-arm a loader that cannot settle.
            if (!wrapperHydratedCurrentPractice) {
                dispatch(startLoadingData(true));
                dispatch(updateDashNewLead({ results: [] }));
            }
            if (practiceId && practiceTreatment?.results?.length > 0) {
                const data = {
                    limit: 50,
                    offset: 0,
                    category: categoryName !== 'All' && categoryName,
                };
                if (isReportData && type !== 'treatmentStartedWithInvisalign' && selectedTab !== 'invisalignAdditional') {
                    dispatch(getPracticeTreatmentList(practiceId, data));
                }
            }
        } else if (deferredToWrapper) {
            // Shell side-effects only — no data fetch while wrapper hasn't fired yet.
            if (practiceId) dispatch(loadCustomTabs(practiceId));
            dispatch(startLoadingData(true));
            dispatch(updateDashNewLead({ results: [] }));
        } else {
            if (isReportData) {
                updateLeadPage(payloadData);
                if (practiceId) {
                    dispatch(getPracticeItem(practiceId));
                }
            }
            if (practiceId) dispatch(loadCustomTabs(practiceId));
            dispatch(startLoadingData(true));
            dispatch(updateDashNewLead({ results: [] }));
            if (practiceId && practiceTreatment?.results?.length > 0) {
                const data = {
                    limit: 50,
                    offset: 0,
                    category: categoryName !== 'All' && categoryName,
                };
                if (isReportData && type !== 'treatmentStartedWithInvisalign' && selectedTab !== 'invisalignAdditional') {
                    dispatch(getPracticeTreatmentList(practiceId, data));
                }
            }
            if (noConsultantBookedType && notArchType && results) {
                dispatch(updateCounter([]));
            }

            if (tableData && practiceId && wrappedReloadCounter && practiceTreatment?.results?.length > 0) {
                wrappedReloadCounter(payloadData);
            }
        }

    }, [practiceId, practiceTreatment, activePracticeIdsKey, wrapperOwnsCurrentPractice, wrapperHydratedCurrentPractice]);

    // Custom checklist tabs MUST load reliably on every practice load/navigation,
    // independent of practiceTreatment timing. The dispatch above (in the
    // practiceTreatment-gated effect) is skipped when practiceTreatment is already
    // cached (GET dedupe / prior visit), so loadCustomTabs never fires that session
    // and `customTabsLoaded` stays false — ConsultantAttend's tab-resolution guard
    // and initial-fetch gate then bail, intermittently rendering an empty table
    // (0 rows / no checklist columns) for ?tab=custom:N URLs. This dedicated effect,
    // keyed only on practiceId, guarantees the fetch fires deterministically.
    // loadCustomTabs is idempotent (pure GET → setForPractice replace; callApi
    // dedupes identical GETs within 8s) so the duplicate dispatch is harmless.
    useEffect(() => {
        if (practiceId) dispatch(loadCustomTabs(practiceId));
    }, [practiceId]);

    useEffect(() => {
        if (searchQuery !== null) {
            if (debouncedValue) {
                dispatch(updateCounter([]));
                const payloadData = {
                    limit: perPage,
                    offset: pageNumber,
                    filterStatus: notAllType ? contactCount : filterStatus,
                    order: tableOrder,
                    orderId: tableOrderBy,
                    searchQuery: searchValue,
                    treatment: treatmentData?.toString(),
                    startDate,
                    endDate,
                    contactedCount: contactCount,
                    tags: searchTags,
                    referral,
                    practices,
                    depositPendingStatus,
                    category,
                    bookedWith: bookedWithData?.toString(),
                    assigneeIds: assigneeData?.toString(),
                    archiveReason,
                    noTreatment: false,
                    customTabId: undefined,
                    ...(consultantBookedType ? { bookedWidgetFilter: null } : {}),
                    ...currentTaskModeFields(),
                };
                handleStartedTablePayload(payloadData);
                updateLeadPage(payloadData);
                if (tableData && wrappedReloadCounter) {
                    wrappedReloadCounter(payloadData);
                }
                setCurrentTab(notAllType ? contactCount : filterStatus);
            } else {
                dispatch(updateCounter([]));
                const payloadData = {
                    limit: perPage,
                    offset: pageNumber,
                    filterStatus: tableStatus,
                    order: tableOrder,
                    orderId: tableOrderBy,
                    searchQuery: searchValue,
                    treatment: treatmentData?.toString(),
                    startDate,
                    endDate,
                    contactedCount: contactCount,
                    tags: searchTags,
                    referral,
                    practices,
                    depositPendingStatus,
                    category,
                    bookedWith: bookedWithData?.toString(),
                    assigneeIds: assigneeData?.toString(),
                    archiveReason,
                    noTreatment: false,
                    customTabId: undefined,
                    ...(consultantBookedType ? { bookedWidgetFilter: null } : {}),
                    ...currentTaskModeFields(),
                };
                handleStartedTablePayload(payloadData);
                updateLeadPage(payloadData);
                if (tableData && practiceId && wrappedReloadCounter) {
                    wrappedReloadCounter(payloadData);
                }
            }
        }
    }, [debouncedValue]);

    useEffect(() => {
        if (selectedRow && followUpLead === 'contactLead' && shouldCallReminder?.current) {
            dispatch(getActivities(practiceId, selectedRow?.lead_id, 10, 0));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 50, 0, 'leadNotes', selectedRow?.lead_id, '', '', '', 'counter'));
        }
    }, [selectedRow, practiceId]);

    useEffect(() => {
        // Pass active bookedWith assignee ids so nearestData can prefer the
        // matching consultant's appointment on the Consultant Booked table.
        const rowOptions = consultantBookedType && bookedWithData?.length > 0
            ? { bookedWithIds: bookedWithData }
            : undefined;
        // Local array + seen-set per effect run so we never accumulate across
        // re-renders (Bug A: component-scope rowData caused double-rows on filter
        // changes) and deduplicate any BE cross-join duplicates in the same pass
        // (Bug B: multi-appointment leads appear twice in the API response when
        // both status + assignee appointment filters fire on different JOIN paths).
        // When a top-strip custom tab is active on the Attended OR Treatment Started
        // table, scope lead_treatments to only the treatments that belong to that tab
        // BEFORE building the row. Without this, handleLatestData picks the most-
        // recently-updated treatment regardless of which tab is active, causing
        // multi-treatment leads (e.g. Composite Bonding + Perio) to display the
        // wrong treatment name on every non-primary tab and to fold cross-tab
        // treatments into the "+N" chip count (Bug: Beth Priddy, practice 19).
        // Note: treatmentStartedWithInvisalign has its own dedicated Invisalign
        // filter below; only the plain treatmentStarted variant needs tab scoping.
        const isAttendedWithCustomTab =
            (consultantAttendedType || attendedChecklistsType) &&
            activeCustomTab != null;
        const isTreatmentStartedWithCustomTab =
            type === 'treatmentStarted' &&
            activeCustomTab != null;
        const localRowData = [];
        const seen = new Set();
        leadData.forEach((item) => {
            if (item?.id != null) {
                const key = String(item.id);
                if (seen.has(key)) return;
                seen.add(key);
            }
            // Scope lead_treatments to the active tab before passing to handlers so
            // that both latestData (primary treatment row display) and treatmentData
            // ("+N" chip count) reflect only this tab's treatments.
            const scopedTreatments = (isAttendedWithCustomTab || isTreatmentStartedWithCustomTab)
                ? filterLeadTreatmentsForCustomTab(item?.lead_treatments, activeCustomTab, customTabs)
                : item?.lead_treatments;
            const scopedItem = (isAttendedWithCustomTab || isTreatmentStartedWithCustomTab || type === 'treatmentStartedWithInvisalign')
                ? {
                    ...item,
                    lead_treatments: type === 'treatmentStartedWithInvisalign'
                        ? item?.lead_treatments?.filter(treatment =>
                            treatment.treatment === 'Invisalign' && treatment.status === 'TREATMENT_STARTED'
                        )
                        : scopedTreatments,
                }
                : item;
            const latestData = handleLatestData(scopedItem, type, rowStatus);
            localRowData.push(handleTableData(scopedItem, latestData, practiceListMap, rowOptions));
        });
        setTableData(localRowData);
    }, [leadData, page]);

    const handleSetTableData = (item) => {
        const rowOptions = consultantBookedType && bookedWithData?.length > 0
            ? { bookedWithIds: bookedWithData }
            : undefined;
        const isAttendedWithCustomTabInline =
            (consultantAttendedType || attendedChecklistsType) && activeCustomTab != null;
        const isTreatmentStartedWithCustomTabInline =
            type === 'treatmentStarted' && activeCustomTab != null;
        setTableData((state) => state.map((ele) => {
            if (ele.lead_id === item.id) {
                const scopedTreatments = (isAttendedWithCustomTabInline || isTreatmentStartedWithCustomTabInline)
                    ? filterLeadTreatmentsForCustomTab(item?.lead_treatments, activeCustomTab, customTabs)
                    : item?.lead_treatments;
                const latestItem = type === 'treatmentStartedWithInvisalign'
                    ? {
                        ...item,
                        lead_treatments: item?.lead_treatments?.filter(treatment =>
                            treatment.treatment === 'Invisalign' && treatment.status === 'TREATMENT_STARTED'
                        )
                    }
                    : (isAttendedWithCustomTabInline || isTreatmentStartedWithCustomTabInline)
                    ? { ...item, lead_treatments: scopedTreatments }
                    : item;
                const latestData = handleLatestData(latestItem, type, rowStatus);
                return handleTableData(latestItem, latestData, practiceListMap, rowOptions);
            }
            return ele;
        }));
    };

    const handleArchivedClose = () => {
        onCloseArchiveLead();
        if (type === 'NewLeadTable' && setUpdateList) {
            setUpdateList(true);
        }
        if (openFollowLead) {
            dispatch(updateFollowUpLead('contactLead'));
        } else {
            dispatch(getLeadReminderData(practiceId, 'dashboard', limit, offset, filter, '', assignUser));
        }
    };

    const resolveTableArchiveContext = useCallback((row) => {
        const rawLeadId = row?.lead_id ?? row?.leadId ?? row?.lead ?? row?.id;
        const leadId = typeof rawLeadId === 'string' && rawLeadId.includes('-')
            ? rawLeadId.split('-')[0]
            : rawLeadId;
        const matchingTreatment = Array.isArray(row?.treatmentData)
            ? row.treatmentData.find((treatment) => String(treatment?.id) === String(row?.treatment_id))
            : null;
        const leadTreatmentId =
            row?.treatment_id ??
            row?.lead_treatment_id ??
            row?.leadTreatmentId ??
            matchingTreatment?.id ??
            row?.treatmentData?.[0]?.id ??
            row?.lead_treatments?.[0]?.id ??
            null;
        const resolvedPracticeId =
            row?.practiceId ??
            row?.practice_id ??
            row?.practice?.id ??
            practiceId;

        return {
            leadId,
            practiceId: resolvedPracticeId,
            leadTreatmentId,
        };
    }, [practiceId]);

    const handleExplicitTableArchiveSubmit = useCallback(async ({ data, openCommunication }) => {
        const archiveRow = tableRowLead?.lead_id || tableRowLead?.id ? tableRowLead : selectedRow;
        const {
            leadId,
            practiceId: resolvedPracticeId,
            leadTreatmentId,
        } = resolveTableArchiveContext(archiveRow);

        await dispatch(beginArchiveLead({
            leadId,
            practiceId: resolvedPracticeId,
            leadTreatmentId,
            reason: data?.archiveReason || '',
            note: data?.archiveNotes || '',
            isOpenForCommunication: openCommunication?.is_open_for_communication,
            source: 'leads-table:single-archive',
            handleClose: handleArchivedClose,
        }));
        handleReloadLeads();
    }, [handleArchivedClose, handleReloadLeads, resolveTableArchiveContext, selectedRow, tableRowLead]);

    useEffect(() => {
        if (message) {
            enqueueSnackbar(message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            setTimeout(() => {
                dispatch(clearMessage());
            }, 3000);
        }
        if (error) {
            enqueueSnackbar(error?.detail || 'something went wrong', {
                variant: 'error',
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
            });
            setTimeout(() => {
                dispatch(clearMessage());
            }, 3000);
        }
    }, [message, error]);

    useEffect(() => {
        if (markAsComplete) {
            switch (followUpLead) {
                case 'contactLead':
                    // Clear attendance='payment' before completing so addAppointment falls through
                    // to the clean success path (toast + close) instead of diverting to
                    // updatePersonalDetail when Mark As Complete is used (appointmentThunks.js:66).
                    dispatch(updateSteps(null));
                    dispatch(updateLeadDetail(isAppointmentBooked, handleClose));
                    break;
                case 'consultationAttended':
                    dispatch(ConsultationAttended(handleClose));
                    break;
                case 'recordAttended':
                    dispatch(RecordAttended(handleClose));
                    break;
                case 'recordUnAttended':
                    dispatch(recordUnAttended(handleClose));
                    break;
                case 'archivedLead':
                    dispatch(ArchivedLeadDashBoard(handleClose));
                    break;
                case 'restoreArchived':
                    dispatch(restoreArchived(handleClose));
                    break;
                case 'StartTreatmentConfirmation':
                    dispatch(ConsultationAttended(handleClose));
                    break;
                default:
                    break;
            }
        }
    }, [markAsComplete, followUpLead]);

    const handlePaginationChange = (newPageData) => {

        const { page, pageSize } = newPageData;
        // Task #32: read tasks-mode from the live ref so that if React hasn't
        // re-rendered yet after a mode switch the handler still sees the current
        // value. Mirrors the same pattern used in the main table-load useEffect
        // (line ~1872) that was fixed in the e8ce9cc6f popup-close patch.
        const liveTasksMode = newLeadTasksModeRef.current || isTasksDeepLinkUrl;
        const payloadData = {
            limit: pageSize,
            offset: pageSize * page,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            // In tasks mode the BE owns the NEW-lead base via task_due_bucket —
            // never send a contacts-mode contactedCount (contactCount defaults to
            // '0' which hits the useBlankCount branch → has_new_or_null_treatment,
            // no status filter → collapses 157 leads to 19 on page 2+).
            contactedCount: liveTasksMode ? undefined : (checklistStateValue ? 'All' : contactCount),
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            bookedWidgetFilter,
            // Preserve the EXACT current bucket across pages — including null (no bucket).
            // A null ref means the user explicitly deselected the bucket to view all 157
            // unfiltered leads. Sending no param preserves that state; falling back to
            // 'due_now' would force the filter back on and collapse the set.
            taskDueBucket: liveTasksMode ? (taskDueBucketRef.current || undefined) : undefined,
        };
        handleStartedTablePayload(payloadData);
        updateLeadPage(payloadData);
        onChangePage('', page);
        UpdateTableData(type, { perPage: pageSize, pageNumber: pageSize * page });
    };

    const handleChangePerPage = (event) => {
        // Task #32 sibling fix: same liveTasksMode guard as handlePaginationChange —
        // page-SIZE change triggered the identical 157→19 collapse (contactedCount='0'
        // → useBlankCount → has_new_or_null_treatment, no task_due_bucket).
        const liveTasksMode = newLeadTasksModeRef.current || isTasksDeepLinkUrl;
        const payloadData = {
            limit: event.target.value,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: liveTasksMode ? undefined : (checklistStateValue ? 'All' : contactCount),
            checklistState: checklistStateValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            bookedWidgetFilter,
            // Same as handlePaginationChange: mirror the live ref exactly, null → no param.
            taskDueBucket: liveTasksMode ? (taskDueBucketRef.current || undefined) : undefined,
        };
        handleStartedTablePayload(payloadData);
        updateLeadPage(payloadData);
        onChangeRowsPerPage(event);
        UpdateTableData(type, { perPage: event.target.value });
    };

    const handleChangeStatus = (event, newValue) => {
        setPage(0);
        setRowsPerPage(10);
        setForceUpdate(prv => !prv);
        onChangeFilterStatus(event, newValue);
        setPaginationModel({ pageSize: 10, page: 0 });
        // Custom sub-tab detection happens before the treatment-started category
        // shortcut — custom tabs use a synthetic "custom:<id>" value that must
        // not be misinterpreted as a category id.
        const isCustomTab = typeof newValue === 'string' && newValue.startsWith('custom:');
        const customTabId = isCustomTab ? newValue.slice('custom:'.length) : undefined;
        // Universal "All" reset: clears any active custom tab + category filter +
        // contact-count, surfaces every lead the parent is responsible for. Behavior
        // per parent:
        //   - ConsultantAttend / NewLeadTable / DashNewLeadTable: parent wrapper
        //     hardcodes `filterStatus` (CONSULTATION_ATTENDED / NEW), so the API
        //     query still scopes to the parent status — All shows ALL leads in
        //     that status, regardless of category or custom tab.
        //   - NoTaskTable / Dashboard: no wrapper override, so filterStatus is
        //     updated to 'All' here too and coreThunks treats that as "no status
        //     filter" — All means leads across every status (per the existing
        //     `filterStatus === 'All'` sentinel pattern in coreThunks.js:160).
        //   - treatmentStarted: routed through handleCategory below, which
        //     follows the same reset semantics as the dynamic All category.
        //
        // Value is 'All' (capital) to match the existing contactedCount sentinel
        // already special-cased throughout coreThunks.js. Slug is 'all' (lowercase) —
        // that's the admin-hide key in TABS_PER_TABLE and is intentionally separate
        // from the runtime tab.value.
        if (newValue === 'All') {
            if (treatmentStartedType) {
                handleCategory({ target: { innerText: 'All' } }, null);
                return;
            }
            const resetPayload = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder || 'desc',
                orderId: tableOrderBy || 'created_at',
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: 'All',
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category: '0',
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
                customTabId: undefined,
            };
            updateLeadPage(resetPayload);
            if (tableData && practiceId && wrappedReloadCounter) {
                wrappedReloadCounter(resetPayload);
            }
            UpdateTableData(type, { count: 'All', category: '0', categoryName: '', perPage: 10, pageNumber: 0 });
            return;
        }
        if (treatmentStartedType && !isCustomTab) {
            handleCategory(event, newValue);
            return;
        }
        // When entering a custom sub-tab on Treatment Started, clear any
        // residual category state from prior category-tab clicks — the
        // custom-tab branch in coreThunks supplies its own treatment scope
        // and shouldn't be filtered by category as well.
        if (treatmentStartedType && isCustomTab) {
            UpdateTableData(type, { category: '0', categoryName: '', treatment: [] });
        }
        // AttendedChecklists standalone route sub-tabs use checklist_state
        // (in_progress | completed), not contactedCount. Keep filterStatus as
        // CONSULTATION_ATTENDED. Custom tabs with checklist_binding now render
        // BOTH strips (task #100 Risk 2); their checklist strip uses
        // handleChangeChecklistState instead of this handler.
        if (type === 'AttendedChecklists') {
            const checklistPayload = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: 'desc',
                orderId: 'created_at',
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: 'All',
                checklistState: newValue,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
                ...currentTaskModeFields(),
            };
            updateLeadPage(checklistPayload);
            if (tableData && practiceId && wrappedReloadCounter) {
                wrappedReloadCounter(checklistPayload);
            }
            UpdateTableData(type, { count: newValue, checklistState: newValue, perPage: 10, pageNumber: 0 });
            return;
        }
        // Custom sub-tab selected: keep the parent table's filterStatus (don't
        // overwrite with the synthetic "custom:<id>" value), and pass customTabId
        // so coreThunks adds the treatment-scope and predicate filters.
        // Task #100 Risk 2: preserve checklistState when clicking the
        // contacted-count strip on a checklist-bound custom tab so the two
        // strips compose (e.g. FU1 click keeps the active In Progress filter).
        const requestedContactCount = isCustomTab ? contactCount : (newValue === 'AWAITING_RESPONSE' ? '' : newValue);
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus: isCustomTab ? filterStatus : newValue,
            order: 'desc',
            orderId: 'created_at',
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: requestedContactCount,
            checklistState: checklistStripActive ? (checklistStateValue || undefined) : undefined,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category: isCustomTab ? '0' : category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            customTabId,
            // Redux still holds the previous strip selection until UpdateTableData below.
            ...currentTaskModeFields(undefined, requestedContactCount),
        };
        updateLeadPage(payloadData);
        if (isNoTaskLeadsTable) {
            UpdateTableData(type, { count: newValue, perPage: 10, pageNumber: 0 });
        } else {
            UpdateTableData(type, { count: newValue, perPage: 10, pageNumber: 0 });
        }
    };

    // Task #100 Risk 2 — Composable second strip handler.
    // Fires when the user clicks the [In Progress | Follow-Up Complete] strip
    // that renders BELOW the normal contacted-count strip on a custom tab with
    // checklist_binding active. Only mutates checklistState — leaves contactCount
    // (first-strip selection) untouched so the two filters compose: e.g.
    // "Follow up 1 + In Progress" hits contacted_count_for_status=1,exact,CONSULTATION_ATTENDED
    // AND checklist_state=in_progress on the same query.
    const handleChangeChecklistState = (event, newValue) => {
        // Bug 1 fix: raise the busy gate so the DataGrid stays in loading state
        // until BOTH the new rows AND their checklist cells have resolved.
        // The gate is cleared via onChecklistSwitchingDone passed to NewLeadDataGrid.
        setIsChecklistSwitching(true);
        // Bug 2c fix: write the new state to the URL so browser-back restores it.
        // ConsultantAttend passes this callback; other wrappers pass null (no-op).
        onChecklistStateChange?.(newValue);
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        const checklistPayload = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder || 'desc',
            orderId: tableOrderBy || 'created_at',
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount, // preserve first-strip selection
            checklistState: newValue,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            customTabId: activeCustomTab?.id ?? undefined,
            ...currentTaskModeFields(),
        };
        updateLeadPage(checklistPayload);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(checklistPayload);
        }
        UpdateTableData(type, { checklistState: newValue, perPage: 10, pageNumber: 0 });
    };

    const sortingApiCall = (id, defaultOrder) => {
        onChangePage(id, 0);
        const payloadData = {
            limit: rowsPerPage,
            offset: 0,
            filterStatus,
            order: defaultOrder,
            orderId: id,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            bookedWidgetFilter,
            ...currentTaskModeFields(),
        };

        handleStartedTablePayload(payloadData);
        updateLeadPage(payloadData);
    };

    useEffect(() => {
        if (contactLead) {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />,
                },
            ];
            setLeadStep(STEPS);
        } else {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <Activities activityList={activityList?.results} notAllow />,
                },
            ];
            setLeadStep(STEPS);
        }
    }, [contactLead]);

    useEffect(() => {
        if (BookingAttendance) {
            const steps = [...STEPS];
            if (isAppointmentBooked === 'Booking Details' && !pmsScope.ready) {
                steps.push({ label: 'Booking settings', component: <PmsSchedulingStatus scope={pmsScope} />, buttonDisabled: true });
                setLeadStep(steps);
                return;
            }
            const row = rowLead.current;
            if (isAppointmentBooked === 'Booking Details' && pmsEnabledGlobal && !dentallyEnabledGlobal) {
                // PMS path: 2 steps — Availability → Confirm Booking
                steps.push({
                    label: 'Select Appointment',
                    component: (
                        <PmsAvailabilityWizardStep
                            ref={inputRef}
                            handleNext={onSubmit}
                            practiceId={practiceId}
                            leadId={followLead?.id}
                            treatmentId={currentTreatmentDataGlobal?.treatmentData?.id}
                            pmsSlot={pmsSlot}
                            onSlotSelected={setPmsSlot}
                            selectedPractitioner={pmsPractitioner}
                            onPractitionerSelected={setPmsPractitioner}
                            selectedDate={pmsDate}
                            onDateSelected={setPmsDate}
                            appointmentDuration={pmsDuration}
                            onDurationChange={setPmsDuration}
                        />
                    ),
                });
                steps.push({
                    label: 'Confirm Booking',
                    ...pmsConfirmStepState,
                    component: (
                        <PmsBookingConfirmStep
                            {...pmsBookingSession.confirmationProps}
                            ref={inputRef}
                            pmsSlot={pmsSlot}
                            practiceId={practiceId}
                            existingLead={followLead ? {
                                id: followLead.id,
                                first_name: followLead.first_name,
                                last_name: followLead.last_name,
                                lead_contact: {
                                    phone: followLead.lead_contact?.phone,
                                    email: followLead.lead_contact?.email,
                                },
                            } : null}
                            existingTreatmentId={currentTreatmentDataGlobal?.treatmentData?.id ? Number(currentTreatmentDataGlobal.treatmentData.id) : null}
                            onClose={(success) => {
                                if (success) handleClose('finish');
                            }}
                            onStepStateChange={setPmsConfirmStepState}
                            appointmentDuration={pmsDuration}
                        />
                    ),
                });
            } else if (isAppointmentBooked === 'Booking Details' && dentallyEnabledGlobal && useDentallyFlow) {
                // Dentally path: 2 steps — Treatment & Availability → Confirm Booking
                steps.push({
                    label: 'Treatment & Availability',
                    component: (
                        <Box>
                            <BookingModeToggle useDentally onChange={handleToggleBookingMode} />
                            <DentallyTreatmentAvailabilityWizardStep
                                ref={inputRef}
                                handleNext={onSubmit}
                                practiceId={practiceId}
                                dentallySlot={dentallySlot}
                                onSlotSelected={setDentallySlot}
                                selectedDentallyTreatment={selectedDentallyTreatment}
                                onTreatmentSelected={(treatment) => {
                                    setSelectedDentallyTreatment(treatment);
                                }}
                                assignees={dentallyAssignees}
                                onAssigneesChanged={setDentallyAssignees}
                            />
                        </Box>
                    ),
                });
                steps.push({
                    label: 'Confirm Booking',
                    ...followUpConfirmStepState,
                    component: (
                        <DentallyFollowUpConfirmWizardStep
                            ref={inputRef}
                            selectedSlot={dentallySlot}
                            selectedDentallyTreatment={selectedDentallyTreatment}
                            assignees={dentallyAssignees}
                            practiceId={practiceId}
                            existingLead={followLead ? {
                                id: followLead.id,
                                first_name: followLead.first_name,
                                last_name: followLead.last_name,
                                lead_contact: {
                                    phone: followLead.lead_contact?.phone,
                                    email: followLead.lead_contact?.email,
                                },
                                dob: followLead.dob,
                            } : null}
                            existingTreatmentId={currentTreatmentDataGlobal?.treatmentData?.id ? Number(currentTreatmentDataGlobal.treatmentData.id) : null}
                            onClose={(success) => {
                                if (success) handleClose('finish');
                            }}
                            onStepStateChange={setFollowUpConfirmStepState}
                        />
                    ),
                });
            } else if (isAppointmentBooked === 'Booking Details') {
                // Standard CRM-only path (Dentally disabled or user toggled to CRM-only)
                steps.push({
                    label: isAppointmentBooked,
                    component: (
                        <Box>
                            {dentallyEnabledGlobal && <BookingModeToggle useDentally={false} onChange={handleToggleBookingMode} />}
                            <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview hideDentally />
                        </Box>
                    ),
                });
            } else if (isAppointmentBooked === 'WhatsApp Follow Up') {
                steps.push({
                    label: 'Follow Up',
                    component: <WhatsAppFollowUpStep ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />,
                });
            } else if (isAppointmentBooked === 'WhatsApp Close') {
                steps.push({
                    label: 'Close',
                    component: <WhatsAppCloseStep ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />,
                });
            } else {
                // Unable to contact or appointment page
                steps.push({
                    label: isAppointmentBooked,
                    component:
                        isAppointmentBooked === 'Unable to contact' ? (
                            <UnableToContact
                                ref={inputRef}
                                handleNext={onSubmit}
                                openArchivePopup={() => onOpenArchiveLead(row?.lead_id)}
                                isOverview
                                completeFlow={handleClose}
                            />
                        ) : (
                            <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                        ),
                });
            }
            setLeadStep(steps);
        } else {
            setLeadStep(STEPS);
        }
    }, [pmsScope.ready, pmsScope.error, pmsScope.retry, pmsEnabledGlobal, BookingAttendance, dentallySlot, selectedDentallyTreatment, dentallyAssignees, followLead, followUpConfirmStepState, useDentallyFlow, pmsSlot, pmsPractitioner, pmsDate, pmsDuration, pmsConfirmStepState, pmsBookingSession.status, currentTreatmentDataGlobal?.treatmentData?.id]);

    useEffect(() => {
        if (attendance && isAppointmentBooked !== 'Appointment Not Booked') {
            const steps = [...STEPS];
            const row = rowLead.current;
            if (attendance === 'attendance') {
                steps.push({
                    label: isAppointmentBooked,
                    component:
                        isAppointmentBooked === 'Booking Details' ? (
                            <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        ) : isAppointmentBooked === 'Unable to contact' ? (
                            <UnableToContact
                                ref={inputRef}
                                handleNext={onSubmit}
                                openArchivePopup={() => onOpenArchiveLead(row?.lead_id)}
                                isOverview
                                completeFlow={handleClose}
                            />
                        ) : (
                            <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                        ),
                });
                steps.push({
                    label: 'Appointment Outcome',
                    component: <AttendedAppointment ref={inputRef} handleNext={onSubmit} isOverview />,
                });
            } else {
                steps.push({
                    label: isAppointmentBooked,
                    component:
                        isAppointmentBooked === 'Booking Details' ? (
                            <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        ) : isAppointmentBooked === 'Unable to contact' ? (
                            <UnableToContact
                                ref={inputRef}
                                handleNext={onSubmit}
                                openArchivePopup={() => onOpenArchiveLead(row?.lead_id)}
                                isOverview
                                completeFlow={handleClose}
                            />
                        ) : (
                            <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                        ),
                });
                steps.push({
                    label: 'Personal Details',
                    component: <PersonalDetails ref={inputRef} handleNext={onSubmit} />,
                });
                steps.push({
                    label: 'Payment options',
                    component: <PaymentOption ref={inputRef} handleNext={onSubmit} />,
                });
                if (dentallyEnabledGlobal && isDentallyBooking) {
                    steps.push({
                        label: 'Dentally Confirmation',
                        component: <DentallyPaymentConfirmation ref={inputRef} handleNext={onSubmit} />,
                    });
                }
                steps.push({
                    label: 'Message review & reminders',
                    component: <MessageAndReminder ref={inputRef} handleNext={onSubmit} type={'FollowUp'} row={selectedRow} />,
                });
            }
            setLeadStep(steps);
        } else {
            setLeadStep(STEPS);
        }
    }, [attendance, isDentallyBooking]);

    useEffect(() => {
        // Task #36: skip the cold-mount invocation. On mount followUpLead is null
        // (Redux initial state), so !followUpLead is true and handleClose() would fire
        // a contacts-mode reload that races the wrapper's tasks-mode fetch. The ref
        // starts false and is set true here on the first run; subsequent null
        // transitions (genuine popup closes that dispatch updateFollowUpLead(null))
        // still reach handleClose() correctly.
        if (!followUpLeadMountedRef.current) {
            followUpLeadMountedRef.current = true;
            return;
        }
        if (!followUpLead) {
            handleClose();
            dispatch(updateSteps(null));
        }
    }, [followUpLead]);

    const handleCompletedToStartAPI = () => {
        const row = rowLead.current;
        const data = {
            id: row.treatment_id,
            practiceId,
            leadId: row?.lead_id,
            handleClose
        };
        dispatch(completedToStart(data));
    };

    const onSelectedRow = async (row, typed, isFlowButtonClicked, event) => {
        if (showPracticeColumn && typed !== "changePractice") {
            enqueueSnackbar(`Switching Practice to ${capitalizeFirstLetter(row?.practiceName)}`, {
                variant: 'warning',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
            dispatch(updatePracticeIdToChange(row?.practiceId));
            await new Promise(resolve => setTimeout(resolve, 2000));
            enqueueSnackbar(`Practice switched to ${capitalizeFirstLetter(row?.practiceName)}`, {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
        }
        localStorageRemoveItem('localTreatmentData');
        setSelectedRow(row);
        if (isFlowButtonClicked) {
            shouldCallReminder.current = false;
        } else {
            shouldCallReminder.current = true;
        }
        const latestData = handleLatestData({ lead_treatments: row?.treatmentData || [] }, type, rowStatus);
        setDepositStatus(!latestData?.[0]?.is_treatment_fee_pending);
        dispatch(updateFollowUpLead(typed));
        switch (typed) {
            case 'consultationAttended': {
                // When opened via a task-cell Email/WhatsApp action, event carries
                // v2TaskId (for task auto-complete on send) and initialSidebarTab
                // ('email' or 'whatsapp' to pre-select the correct sidebar tab).
                // For Follow-up button opens event is undefined — always-set pattern
                // clears any stale pendingV2TaskIdRef left from a prior task-cell open.
                const { v2TaskId: consultV2TaskId, initialSidebarTab: consultSidebarTab } = event ?? {};
                pendingV2TaskIdRef.current = consultV2TaskId ?? null;
                setConsultationAttendSidebarTab(consultSidebarTab ?? null);
                onOpenConsultationAttend();
                break;
            }
            case 'deleteTreatmentPayment':
                paymentDeleteToggle.onOpen();
                onCloseDepositPaymentPopup();
                setAnchorDepositPayment(null);
                break;
            case 'recordAttended':
                onOpenRecordAttend();
                break;
            case 'recordUnAttended':
                setAppointmentOutcomeSelection(null);
                onOpenUnRecordAttend();
                break;
            case 'restoreArchived':
                // Task #29 Defect 4: V2-flat rows have composite id ("42-3"); use lead_id
                // (numeric) which useLeadTableHelper derives via split("-")[0]. Mirrors the
                // correct pattern at line ~2562 `openArchivePopup={() => onOpenArchiveLead(row?.lead_id)}`
                onOpenRestoreArchived(row.lead_id ?? row.id);
                break;
            case 'archivedLead':
                onOpenArchiveLead(row.lead_id ?? row.id);
                break;
            case 'backToAttended':
                onOpenAttendedNote(row.lead_id ?? row.id);
                break;
            case 'addTreatment':
                onOpenAddTreatment('openAddTreatment');
                setAnchorEditTreatment(event.currentTarget);
                break;
            case 'editTreatment':
                onopenTreatmentEditPopup();
                setAnchorEditTreatment(event.currentTarget);
                break;
            case 'changePractice':
                // "Practice Name" cell of the All Practice Leads table: same shared dialog as the
                // row menu, always for the ROW's own practice (practiceId comes from the row).
                if (hasMultiplePractices && isLeadTransferable(row)) setTransferRow(row);
                break;
            case 'deposit_payment':
                onOpenDepositPaymentPopup();
                setAnchorDepositPayment(event.currentTarget);
                break;
            case 'markAsDuplicate':
                openDuplicatePopup();
                rowLead.current = row;
                break;
            case 'unMarkAsDuplicate':
                openUnMarkAsDuplicate();
                rowLead.current = row;
                break;
            case 'markAsSpam':
                openMarkAsSpamDialog();
                rowLead.current = row;
                break;
            case 'TreatmentConfirmation':
                setConfirmation(true);
                rowLead.current = row;
                break;
            case 'StartTreatmentConfirmation':
                setStartConfirmation(true);
                rowLead.current = row;
                break;
            case 'CompletedToStartTreatment':
                rowLead.current = row;
                handleCompletedToStartAPI();
                break;
            case 'EditAppointment':
                onOpenReSchedule(row);
                setAppoinmentSelectData(row);
                break;
            case 'AddAppointment':
                onOpenAppointment();
                break;
            case 'ClinCheckStatusOpen':
                openClinCheckStatusPopup(row, event);
                break;
            case 'contactLead': {
                const { openWhatsapp, v2TaskId: incomingV2TaskId, debugSource: incomingDebugSource } = event ?? {};
                setContactLeadDefaultTab(openWhatsapp ? 'whatsapp' : 'overview');
                // Record which specific leads-table control opened the popup for
                // the superadmin debug box. Falls back to a tab-aware default.
                setContactLeadDebugSource(
                    incomingDebugSource ||
                    `leads-table:${typed || 'lead'}-row→Contact(whatsapp=${!!openWhatsapp})`
                );
                // Store the V2 task UUID so handleClose can complete it on genuine save.
                // Cleared on close regardless of outcome.
                pendingV2TaskIdRef.current = incomingV2TaskId ?? null;
                onOpenContactLead(row);
                break;
            }
            default:
                onOpenFollowLead();
                break;
        }
    };

    useEffect(() => {
        if (leadData.length > 0) {
            dispatch(startArchivedLoading(false));
        }
    }, [leadData]);

    useEffect(() => {
        if (displayForCategorySummary && leadCategoryType !== filterStatus) {
            handleChangeStatus("", leadCategoryType);
        }
    }, [filterStatus]);

    const completeTreatmentAPI = () => {
        const row = rowLead.current;
        const data = {
            treatment: row.treatment_name || '',
            custom_price: row.price,
        };
        dispatch(setLoader(true));
        dispatch(CompleteTreatment(data, row.lead_id, row.treatment_id, practiceId, handleReloadAPI));
    };

    const startTreatmentAPI = () => {
        const row = rowLead.current;
        const data = {
            treatment: row.treatment_name || '',
            custom_price: row.price,
            lead: row.lead_id,
            id: row.treatment_id,
        };
        dispatch(setLoader(true));
        dispatch(StartingTreatment(data, practiceId, handleClose, 'startingTreatmentFinish'));
    };

    const handleMarkAsDuplicateAPI = () => {
        const row = rowLead.current;
        dispatch(markAsDuplicate({ practiceId, leadId: row?.lead_id, handleClose }));
    };
    const handleUnMarkAsDuplicateAPI = () => {
        const row = rowLead.current;
        dispatch(unMarkAsDuplicate({ practiceId, leadId: row?.lead_id, handleClose }));
    };

    const handleMarkAsSpamAPI = () => {
        const row = rowLead.current;
        closeMarkAsSpamDialog();
        dispatch(markAsSpam({ practiceId, leadId: row?.lead_id, handleClose }));
    };

    // The hub's sidebar can change the treatment start date, which this grid
    // renders in its Started-date column. Reloading the moment it saves is
    // wrong: handleReloadAPI('finish') ends with setConfirmation(false), so the
    // dialog would vanish under the user mid-edit. Record that something
    // changed and reload when the hub is dismissed (Done / Cancel / backdrop —
    // all of them route through handleClose), so the grid is correct when the
    // user gets back to it and the dialog stays put until they close it.
    const hubDataChangedRef = useRef(false);

    // The archive request is accepted immediately but completes in the background (~2s), so
    // the immediate reload can still show the source row as "Archiving". One delayed
    // follow-up reload (via a ref, so it uses the filters current at that time) clears it.
    const transferReloadTimer = useRef(null);
    const reloadRef = useRef(null);
    useEffect(() => () => clearTimeout(transferReloadTimer.current), []);
    const handleTransferDone = (status, result) => {
        setTransferRow(null);
        handleReloadAPI(status);
        if (result?.archived) {
            clearTimeout(transferReloadTimer.current);
            transferReloadTimer.current = setTimeout(() => reloadRef.current?.('finish'), 3000);
        }
    };

    const handleReloadAPI = (value) => {
        if (value === 'finish') {
            dispatch(updateCounter([]));
            const reloadPayLoad = {
                limit: perPage,
                offset: pageNumber,
                filterStatus: notAllType ? contactCount : filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
            };
            updateLeadPage(reloadPayLoad);
            if (tableData && practiceId && wrappedReloadCounter) {
                wrappedReloadCounter(reloadPayLoad);
            }
            dispatch(getLeadReminderData(practiceId, 'dashboard', limit, offset, filter, '', assignUser));
            setConfirmation(false);
            dispatch(setLoader(false));
        }
    };
    reloadRef.current = handleReloadAPI;

    const handleSearch = (data) => {
        let search = data.trim();
        if (data.includes('+')) {
            search = `+44${parseInt(data.split('+44')[1], 10)}`;
        }
        if (Number(data) && !data.includes('+')) {
            search = `${parseInt(data, 10)}`;
        }
        setSearchQuery(data);
        setSearch(data);

        if (data !== '') {
            // Clear all active filters so search results are not silently narrowed
            const { setStartDate, setEndDate } = picker;
            setValue('practices', '');
            setValue('multiSelect', []);
            setValue('referral', '');
            setValue('archiveReason', '');
            setValue('category', '');
            setValue('bookedWith', []);
            setValue('consultationBookedWith', []);
            setValue('multiSelectAssignee', []);
            setNoTreatmentFilter(false);
            setDepositPendingFilter('');
            setStartDate(null);
            setEndDate(null);
            setDate([null, null]);
            const updatedTableData = {
                search: encodeURIComponent(search),
                date: [],
                treatment: [],
                perPage: 10,
                pageNumber: 0,
                tag: [],
                filterTags: [],
                referral: '',
                practices: '',
                bookedWith: [],
                depositPendingStatus: '',
                assignee: [],
                archiveReason: '',
                count: 'All',
                contactedCountFilter: '',
                checklistState: '',
                // Clear custom-tab scope so the search is not silently narrowed to
                // a specific treatment checklist. The wrapper resets controlledCustomTabId
                // via onClearCustomTab, but also clear Redux here so in-flight queries
                // (fired before the wrapper re-renders) also lack the stale scope.
                customTabId: undefined,
            };
            if (treatmentStartedType) {
                updatedTableData.apptType = '';
                updatedTableData.consultationBookedWith = [];
            }
            UpdateTableData(type, updatedTableData);
            // Reset local Tabs state to 'All' so the strip visual matches the cleared
            // filter state. activeStripValue converts 'All'→false for tables that have
            // no 'All' Tab child (e.g. NewLeadTable), avoiding the MUI invalid-value warning.
            setCurrentTab('All');
            // Tell the wrapper (ConsultantAttend / TreatmentStarted / GeneralApp) to
            // reset its top-strip tab to the default. This updates controlledCustomTabId
            // → null and triggers useChecklistTabUrlState to delete ?tab=custom:N.
            onClearCustomTab?.();
            // Strip ?tab and ?checklist_state from the URL in the same setSearchParams
            // write as the other filter params, so there is no intermediate URL state
            // with a stale ?tab after the wrapper's state update settles.
            syncToUrl(buildUrlFilterState({ search: data }), { clearExtra: ['tab', 'checklist_state'] });
        } else {
            // Search cleared — leave filters in their current (already-cleared) state
            UpdateTableData(type, { search: '', perPage: 10, pageNumber: 0 });
            syncToUrl({});
        }
    };

    const onResetFilter = () => {
        const { setStartDate, setEndDate } = picker;
        if (dashBoardDateProps?.dateChange) {
            dashBoardDateProps.dateChange([null, null]);
        }
        if (shouldRunEffect) {
            shouldRunEffect.current = false;
        }
        dispatch(updateCounter([]));
        dispatch(updateSuperAdmin({
            practices: []
        }));
        setSearch('');
        setSearchQuery(null);
        setNoTreatmentFilter(false);
        setValue('practices', '');
        setValue('multiSelect', []);
        setValue('referral', '');
        setValue('archiveReason', '');
        setValue('category', '');
        setValue('bookedWith', []);
        setValue('consultationBookedWith', []);
        setValue('multiSelectAssignee', [])
        setDepositPendingFilter('');
        setStartDate(null);
        setEndDate(null);
        setDate([null, null]);
        const liveTasksMode = newLeadTasksModeRef.current || isTasksDeepLinkUrl;
        const resetTaskBucket = liveTasksMode ? 'due_now' : null;
        if (liveTasksMode) {
            setTaskBucket(resetTaskBucket);
        }
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order,
            orderId: orderByValue,
            searchQuery: null,
            treatment: null,
            startDate: null,
            endDate: null,
            contactedCount: contactCount,
            tags: '',
            referral: '',
            practices: '',
            depositPendingStatus: '',
            category,
            bookedWith: '',
            assigneeIds: '',
            archiveReason: '',
            ...(consultantBookedType ? { bookedWidgetFilter: null } : {}),
            ...taskModeReloadFields(liveTasksMode, {
                checklistStateValue: '',
                contactCount,
                taskDueBucket: resetTaskBucket,
            }),
        };
        const updatedTableData = {
            search: '',
            date: [],
            treatment: [],
            perPage: 10,
            pageNumber: 0,
            tag: [],
            filterTags: [],
            referral: '',
            practices: '',
            bookedWith: [],
            depositPendingStatus: '',
            assignee: [],
            archiveReason: ''
        };
        if (treatmentStartedType) {
            payloadData.apptType = '';
            payloadData.consultationBookedWith = '';
            updatedTableData.apptType = '';
            updatedTableData.consultationBookedWith = [];
        }
        updateLeadPage(payloadData);
        if (tableData && practiceId && wrappedReloadCounter) {
            if (dashType) {
                wrappedReloadCounter({ ...payloadData, isComeFromDateChange: true });
            } else {
                wrappedReloadCounter(payloadData);
            }
        }
        UpdateTableData(type, updatedTableData);
        setPaginationModel({ pageSize: 10, page: 0 });
        syncToUrl({});
    };

    const handleTreatment = (e, value) => {
        if (value) {
            // Detect "No treatment" sentinel — mutually exclusive with real treatment selections.
            // When sentinel present: route through contactedCount='No Treatment' so NewLeadTable's
            // updateLeadPage switch dispatches getBlankTreatmentLeads (lead_treatments__isnull=true).
            // Also clear taskDueBucket — orphan leads have no tasks, bucket mode must exit.
            // When a real treatment is picked instead, clear the sentinel.
            const hasSentinel = value.some((item) => item?.id === NO_TREATMENT_SENTINEL_ID);
            const realTreatments = hasSentinel ? [] : value.filter((item) => item?.id !== NO_TREATMENT_SENTINEL_ID);

            const ids = [];
            realTreatments.map((data) => ids.push(data.id));
            setNoTreatmentFilter(hasSentinel);
            if (hasSentinel) {
                setTaskBucket(null);
            }
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: ids?.toString(),
                startDate,
                endDate,
                // 'No Treatment' routes updateLeadPage → getBlankTreatmentLeads (isnull=true).
                // For real selections keep the current contacted-count tab.
                contactedCount: hasSentinel ? 'No Treatment' : contactCount,
                // Exit tasks-mode when switching to "No treatment" — orphan leads have no tasks.
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
                ...(hasSentinel ? {} : currentTaskModeFields()),
            };
            handleStartedTablePayload(payloadData);
            updateLeadPage(payloadData);
            setPage(0);
            setRowsPerPage(10);
            setPaginationModel({ pageSize: 10, page: 0 });
            setValue('multiSelect', ids);
            if (tableData && practiceId && wrappedReloadCounter) {
                wrappedReloadCounter(payloadData);
            }
            // Store real treatments in Redux (sentinel is display-only, not persisted as a treatment)
            UpdateTableData(type, { treatment: realTreatments, perPage: 10, pageNumber: 0 });
            syncToUrl(buildUrlFilterState({ treatment: realTreatments, noTreatment: hasSentinel }));
        } else {
            setNoTreatmentFilter(false);
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: '',
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
                ...currentTaskModeFields(),
            };
            handleStartedTablePayload(payloadData);
            updateLeadPage(payloadData);
            if (tableData && practiceId && wrappedReloadCounter) {
                wrappedReloadCounter(payloadData);
            }
            setPage(0);
            setRowsPerPage(10);
            setPaginationModel({ pageSize: 10, page: 0 });
            setValue('multiSelect', []);
            UpdateTableData(type, { treatment: [], perPage: 10, pageNumber: 0 });
            syncToUrl(buildUrlFilterState({ treatment: [], noTreatment: false }));
        }
    };

    const handleAssigneeFilter = (e, value) => {

        if (value) {
            const ids = [];
            value.map((data) => ids.push(data.id));
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: ids?.toString(),
                archiveReason,
                noTreatment: false,
                ...currentTaskModeFields(),
            };
            updateLeadPage(payloadData);
            setPage(0);
            setRowsPerPage(10);
            setPaginationModel({ pageSize: 10, page: 0 });
            setValue('multiSelectAssignee', ids);

            if (tableData && practiceId && wrappedReloadCounter) {
                wrappedReloadCounter(payloadData);
            }
            UpdateTableData(type, { assignee: value, perPage: 10, pageNumber: 0 });
            syncToUrl(buildUrlFilterState({ assignee: value }));
        } else {
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: '',
                archiveReason,
                noTreatment: false,
                ...currentTaskModeFields(),
            };
            updateLeadPage(payloadData);
            if (tableData && practiceId && wrappedReloadCounter) {
                wrappedReloadCounter(payloadData);
            }
            setPage(0);
            setRowsPerPage(10);
            setPaginationModel({ pageSize: 10, page: 0 });
            setValue('multiSelectAssignee', []);
            UpdateTableData(type, { assignee: [], perPage: 10, pageNumber: 0 });
            syncToUrl(buildUrlFilterState({ assignee: [] }));
        }
    }

    const CONTACTED_COUNT_OPTIONS = [
        { value: '', label: 'All' },
        { value: '0', label: 'New (0)' },
        { value: '1', label: 'Follow up 1' },
        { value: '2', label: 'Follow up 2' },
        { value: '3+', label: 'Follow up 3+' },
    ];

    // useAttendedScope=true delegates to the shared buildAttendedCountFilterQuery (constants/newLead.js)
    // which emits the status-scoped param for CONSULTATION_ATTENDED — one source of truth.
    // NoTaskTable always passes false (default) — unscoped output byte-identical to before.
    const buildCountFilterQuery = (val, useAttendedScope = false) => {
        if (!val) return '';
        if (useAttendedScope) return buildAttendedCountFilterQuery(val);
        if (val === '3+') return '&lead_treatments__lead_contacted_counts__count__gte=3';
        return `&lead_treatments__lead_contacted_counts__count=${val}`;
    };

    // ISS-041: the legacy Attended widget's "Consultation follow ups" card needs the
    // SAME filter the contacted-count dropdown applies, so both go through one function.
    // val '' clears (buildCountFilterQuery returns '' for a falsy value, and the stored
    // Redux value is reset so ConsultantAttend's
    // `directCountFilter ?? buildAttendedCountFilterQuery(storedCountFilter)` fallback
    // cannot silently re-impose it on the next fetch).
    const applyContactedCountFilter = (val) => {
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus: filterStatus || 'All',
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            tags: searchTags,
            referral,
            assigneeIds: assigneeData?.toString(),
            directCountFilter: buildCountFilterQuery(val, consultantAttendedType),
            ...currentTaskModeFields(),
        };
        updateLeadPage(payloadData);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, { contactedCountFilter: val, perPage: 10, pageNumber: 0 });
    };

    const handleContactedCountFilter = (event) => applyContactedCountFilter(event.target.value);

    const tabCounter = (data) => counter?.filter((value) => (value.filterStatus === data ? value.count : null));

    // Map a checklist strip value to a fresh count for the badge.
    //
    // '' (All):
    //   - TS table: read from tsChecklistCounts.all — fetched by getTsChecklistCounts as a
    //     third parallel call alongside in_progress / complete (tab-scoped, race-free).
    //   - Attended table: read from attendedTabCounts.all — fetched by getAttendedTabWidgetCounts
    //     as a parallel limit=1 call to leads/?custom_tab_id=N (tab-scoped by construction,
    //     race-free; same structural fix as the TS path).
    //
    // in_progress / complete (Attended table): read from attendedTabCounts (re-fetched on every
    // custom-tab switch by AttendedTabContextualWidget).
    //
    // in_progress / complete (Treatment Started table): attendedTabCounts is always null for TS
    // because AttendedTabContextualWidget only mounts on the Attended table. Read from
    // tsChecklistCounts instead — populated by getTsChecklistCounts in TreatmentStarted.jsx on
    // every custom-tab switch.
    //
    // Returns null when the value isn't known — caller falls back to counter.
    const checklistCountFromWidget = (value) => {
        // TS All: sourced directly from getTsChecklistCounts (tab-scoped, race-free)
        if (value === '' && tsChecklistCounts) return tsChecklistCounts.all ?? null;
        // Attended All: sourced from attendedTabCounts.all (tab-scoped, race-free)
        if (value === '' && attendedTabCounts) return attendedTabCounts.all ?? null;
        // Attended path (in_progress / complete)
        if (attendedTabCounts) {
            if (value === 'in_progress') return attendedTabCounts.in_progress ?? null;
            if (value === 'complete') return attendedTabCounts.follow_up_complete ?? null;
        }
        // Treatment Started path
        if (tsChecklistCounts) {
            if (value === 'in_progress') return tsChecklistCounts.in_progress ?? null;
            if (value === 'complete') return tsChecklistCounts.complete ?? null;
        }
        return null;
    };

    const labelCount = (data, stripKind = 'contacted') => {
        // Checklist sub-strip items are keyed by `.value` ('in_progress'/'complete')
        // in the counter store — even on treatmentStarted, where the contacted-count
        // strip would otherwise key by `data?.id`. Branch so the checklist badge resolves.
        // Checklist keys are namespaced as `${type}:${checklistState}` in coreThunks.js to
        // prevent DashNewLeadTable (exhaustive) and ConsultantAttend (non-exhaustive) from
        // overwriting each other's 'in_progress'/'complete' entries in the shared counter.
        const response = tabCounter(stripKind === 'checklist' ? `${type}:${data.value}` : (treatmentStartedType ? data?.id : data.value));
        // C3 fix: the checklist sub-strip (In Progress / Follow-Up Complete) must
        // compare against checklistStateValue, NOT activeStripValue. activeStripValue
        // is the contacted-count strip's value (contactCount / filterStatus) and never
        // equals a checklist state, so the checklist chips' active styling never lit up.
        const isActive = stripKind === 'checklist'
            ? data.value === (checklistStateValue || '')
            : (treatmentStartedType ? data?.id : data.value) === activeStripValue;
        const rawLabel = treatmentStartedType ? (data?.name || data?.label) : data?.label;
        // Resolve per-practice rename override (set via TableDefaults inline rename).
        // Falls through to rawLabel when no override exists or the parent isn't
        // mapped (treatmentStartedType, custom-tab values, etc.).
        const slug = stripParentForOverrides && stripSlugMap[String(data?.value)];
        // System-default cascade: resolveTabLabel falls back to the global record's
        // tab_label_overrides when the practice has no per-slug override. globalPrefForStrip
        // is computed inline because labelCount runs per-tab in the strip render — keeping
        // the lookup local avoids a useMemo that depends on a derived slice.
        const globalPrefForStrip = stripParentForOverrides
            ? selectGlobalPrefForTable(globalTablePreferencesForStrip, stripParentForOverrides)
            : null;
        const effectiveLabel = (slug && stripParentForOverrides)
            ? resolveTabLabel(practice?.preferences, stripParentForOverrides, slug, rawLabel, globalPrefForStrip)
            : rawLabel;
        return (
            <>
                <Box sx={{ fontWeight: '600' }}>
                    {/* The checklist sub-strip always shows its count badge (both
                        Attended and Treatment Started). The contacted-count top strip
                        stays suppressed on treatmentStarted/booked as before. */}
                    {(stripKind === 'checklist' || (noTreatmentStartedType && noConsultantBookedType)) && (
                        <Label
                            sx={{
                                m: '5px 8px',
                                color: isActive ? primary.main : (isLight ? common.slateGray : common.white),
                                background: isActive ? 'rgba(0, 167, 111, 0.08)' : (isLight ? grey[300] : common.stillBlue),
                            }}
                        >
                            {' '}
                            {(() => {
                                // For checklist strip items, prefer the widget payload
                                // (re-fetched on every custom-tab switch) over the counter
                                // prop (only refreshed on data reload). Fall back to counter
                                // for the 'All' tab and for legacy practices without widget.
                                if (stripKind === 'checklist') {
                                    const widgetCount = checklistCountFromWidget(data.value);
                                    if (widgetCount !== null) return widgetCount;
                                }
                                return (response && response[0]?.count) || 0;
                            })()}{' '}
                        </Label>
                    )}
                    <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                        {effectiveLabel}
                    </Box>
                    <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                        {(() => {
                            const name = effectiveLabel;
                            if (name === 'Waiting/Scheduled') return 'W/S';
                            if (name === 'Follow up 1') return 'FU1';
                            if (name === 'Follow up 2') return 'FU2';
                            if (name === 'Follow up 3 +' || name === 'Follow up 3+') return 'FU3+';
                            return name;
                        })()}
                    </Box>
                </Box>
            </>
        );
    };

    const { toggle: openAssignTask, onOpen: onOpenAssignTask, onClose: onCloseAssignTask } = useAssignTaskToggle();
    const {
        toggle: openTreatmentPlan,
        onOpen: onOpenOpenTreatmentPlan,
        onClose: onCloseTreatmentPlan,
    } = useAssignTaskToggle();

    const {
        toggle: openAppointmentAssignTask,
        onOpen: onOpenAppointmentAssignTask,
        onClose: onCloseAppointmentAssignTask,
    } = useAssignTaskToggle();
    const {
        toggle: openClinCheckStatus,
        onOpen: onOpenClinCheckStatus,
        onClose: onCloseClinCheckStatus,
    } = useAssignTaskToggle();

    const OpenAssignTask = (row, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        onOpenAssignTask();
        onCloseTreatmentEditPopup();
        setSelectedRowId(row?.lead_id);
    };
    const openClinCheckStatusPopup = (row, event) => {
        setAnchorClinCheck(anchorClinCheck ? null : event.currentTarget);
        onOpenClinCheckStatus();
        setSelectedRowId(row?.lead_id);
    };

    const openAppointmentAssignTaskFuc = (row, assignees, event, id) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget || event);
        onOpenAppointmentAssignTask();
        setSelectedRowId(row?.lead_id || row?.id);
        setAssignees(assignees);
        setAppoinmentSelectedId(id);
    };

    const onCloseAssignTaskPopup = (isReload, data) => {
        if (isReload) {
            setTableData((state) => state.map((ele) => {
                if (ele.id === data?.id) {
                    return { ...ele, assignees: data?.assignees };
                }
                return ele;
            }));
        }
        onCloseAssignTask();
    };

    const onCloseTreatmentPlanDatePicker = () => {
        handleReloadAPI('finish');
        onCloseTreatmentPlan();
    };

    const onCloseAppointmentAssignTaskPopup = (isReload, data) => {
        if (isReload) {
            handleSetTableData(data);
        }
        onCloseAppointmentAssignTask();
    };

    const handlePracticeFilter = (e, value) => {
        const data = {
            practices: value
        };
        let practiceArray = value?.map(e => e?.id);
        if (practiceArray && practiceArray?.length) {
            practiceArray = practiceArray?.join(",");
        } else {
            practiceArray = "";
        }
        dispatch(updateSuperAdmin(data));
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            practiceId: value,
            practices: practiceArray,
            ...currentTaskModeFields(),
        };
        handleStartedTablePayload(payloadData);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        updateLeadPage(payloadData);
        UpdateTableData(type, { practices: practiceArray, perPage: 10, pageNumber: 0 });
        setValue('practices', value);
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });

    }

    const handleReferral = (e, data) => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral: data?.id ? "CLINICIAN" : data?.value,
            ...(data?.id ? { affiliate_user: data.affiliate_user, type: "CLINICIAN" } : {}),
            depositPendingStatus,
            practices,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            ...currentTaskModeFields(),
        };
        handleStartedTablePayload(payloadData);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        updateLeadPage(payloadData);
        UpdateTableData(type, { referral: data?.value, perPage: 10, pageNumber: 0 });
        setValue('referral', data?.id ? "CLINICIAN" : data?.value);
        if (data?.id) {
            setValue('affiliate_user', data?.id);
            setValue('type', "CLINICIAN");
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        syncToUrl(buildUrlFilterState({ referral: data?.id ? 'CLINICIAN' : data?.value }));
    };

    const handleArchiveFilter = (e, data) => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason: data?.value,
            noTreatment: false,
            ...currentTaskModeFields(),
        };
        handleStartedTablePayload(payloadData);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        updateLeadPage(payloadData);
        UpdateTableData(type, { archiveReason: data?.value, perPage: 10, pageNumber: 0 });
        setValue('archiveReason', data?.value);
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        syncToUrl(buildUrlFilterState({ archiveReason: data?.value }));
    }
    const handleDepositPendingFilter = (e) => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus: e?.target?.value || '',
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            ...currentTaskModeFields(),
        };
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        updateLeadPage(payloadData);
        UpdateTableData(type, { depositPendingStatus: e?.target?.value || '', perPage: 10, pageNumber: 0 });
        setDepositPendingFilter(e?.target?.value || '');
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        syncToUrl(buildUrlFilterState({ depositPaid: e?.target?.value || '' }));
    };

    const handleCloseTreatment = () => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: notAllType ? contactCount : filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            ...currentTaskModeFields(),
        };
        updateLeadPage(payloadData);
        if (tableData && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        document.body.classList.remove('points-event');
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
    };

    const referralValue = () => {
        // A clinician selection is stored as the sentinel 'CLINICIAN', which has no
        // matching entry in the referral schema list — surface a clean display label
        // instead of going blank (display-only; the API filter already works).
        if (referral === 'CLINICIAN') {
            return [{ value: 'CLINICIAN', label: 'Clinician' }];
        }
        return referralData?.filter((data) => data.value === referral);
    };
    const archiveReasonValue = () => archiveReasonData?.filter((data) => data.value === archiveReason);

    const handleCategory = (e, newValue) => {
        const data = {
            limit: 30,
            offset: 0,
            category: e?.target?.innerText !== 'All' ? e?.target?.innerText : null,
            callBack: () => setCheckOptions(true),
        };
        dispatch(getPracticeTreatmentList(practiceId, data));
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: notAllType ? contactCount : filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: '',
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category: newValue,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            ...currentTaskModeFields(),
        };
        updateLeadPage(payloadData);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        UpdateTableData(type, {
            treatment: [],
            category: newValue,
            categoryName: e?.target?.innerText !== 'All' ? e?.target?.innerText : '',
            perPage: 10,
            pageNumber: 0,
        });
    };

    useEffect(() => {
        if (results && checkOptions) {
            const data = treatmentValue.filter((el) => results.map((elem) => elem?.id).includes(el?.id) && el);
            UpdateTableData(type, { treatment: data, perPage: 10, pageNumber: 0 });
            setCheckOptions(false);
        }
    }, [checkOptions]);

    // skipFetch: when true, dateChange updates the date state / picker label / URL /
    // sessionStorage / Redux table-data but does NOT dispatch updateLeadPage or reloadCounter.
    // skipCounterReload: still fetches the table, but skips the legacy widget-counter fan-out.
    // Used by the Treatment Started contextual card: its own widget row owns those metrics, so
    // refreshing the hidden legacy counters on card click makes the interaction feel like a full
    // dashboard reload without changing the visible result.
    // Used when the caller will issue a single combined fetch itself (e.g. the contextual
    // widget clearing the this-month date scope AND applying a different filter in one go) —
    // avoids the double-fetch + table flicker.
    const dateChange = (newValue, shouldNotCall, skipFetch = false, { skipCounterReload = false } = {}) => {
        setDate(newValue);
        if (!shouldNotCall && dashBoardDateProps?.dateChange) {
            dashBoardDateProps.dateChange(newValue);
        }
        if (shouldRunEffect) {
            shouldRunEffect.current = false;
        }
        const startDate = newValue[0] ? moment(newValue[0]?.$d, 'YYYY-MM-DD').format('YYYY-MM-DD') : '';
        const endDate = newValue[1] ? moment(newValue[1]?.$d, 'YYYY-MM-DD').format('YYYY-MM-DD') : '';
        if (startDate && endDate && !skipFetch) {
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus: notAllType ? contactCount : filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
                ...currentTaskModeFields(),
            };
            updateLeadPage(payloadData);
            if (!skipCounterReload && tableData && practiceId && wrappedReloadCounter) {
                wrappedReloadCounter(payloadData);
            }
        }

        if (newValue[0] === null && newValue[1] === null && !skipFetch) {
            dispatch(updateCounter([]));
            const payloadData = {
                limit: 10,
                offset: 0,
                filterStatus: notAllType ? contactCount : filterStatus,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate: null,
                endDate: null,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                practices,
                depositPendingStatus,
                category,
                bookedWith: bookedWithData?.toString(),
                assigneeIds: assigneeData?.toString(),
                archiveReason,
                noTreatment: false,
                ...currentTaskModeFields(),
            };
            updateLeadPage(payloadData);
            if (!skipCounterReload && tableData && practiceId && wrappedReloadCounter) {
                if (!shouldNotCall && dashType) {
                    wrappedReloadCounter({ ...payloadData, isComeFromDateChange: true });
                } else {
                    wrappedReloadCounter(payloadData);
                }
            }
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, { date: [{ startDate, endDate }], pageNumber: 0, perPage: 10 });
        syncToUrl(buildUrlFilterState({ startDate: startDate || '', endDate: endDate || '' }));
        // Persist date range in sessionStorage per table type
        try {
            if (startDate && endDate) {
                sessionStorage.setItem(sessionDateKey, JSON.stringify({ startDate, endDate }));
            } else {
                sessionStorage.removeItem(sessionDateKey);
            }
        } catch { /* ignore storage errors */ }
    };

    // Expose date range controls to parent (for inline calendar in page heading)
    useEffect(() => {
        if (onDateRangeReady) {
            onDateRangeReady({ date, dateChange, setDate, startDate, endDate });
        }
    }, [date, startDate, endDate]);

    useEffect(() => {
        if (shouldRunEffect && shouldRunEffect.current) {
            const today = moment();
            if (today.isSame(dashBoardDateProps?.startDateDashboard, 'day') && today.isSame(dashBoardDateProps?.endDateDashboard, 'day')) {
                dateChange([null, null], true);
                return;
            }
            dateChange(dashBoardDateProps.date, true);
        }
    }, [dashBoardDateProps?.date]);

    const handlePage = () => {
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
    };

    // const practiceUserId = (e) =>
    //     practiceUser.results.filter((el) =>
    //         e?.includes(`${el?.user?.salutation || ''} ${el?.user?.first_name || ''} ${el?.user?.last_name || ''}`)
    //     )[0]?.user.id;

    const handlePractitioner = (e, value) => {
        const ids = [];
        value.map((data) => ids.push(data.id));
        setValue('bookedWith', value);
        dispatch(updateCounter([]));
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: ids?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            ...currentTaskModeFields(),
        };
        const updatedTableData = {
            bookedWith: value, pageNumber: 0, perPage: 10,
        };
        if (treatmentStartedType) {
            setValue('consultationBookedWith', []);
            payloadData.apptType = ids.length ? 'TREATMENT' : '';
            payloadData.consultationBookedWith = '';
            updatedTableData.apptType = ids.length ? 'TREATMENT' : '';
            updatedTableData.consultationBookedWith = []
        }

        updateLeadPage(payloadData);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, updatedTableData);
        syncToUrl(buildUrlFilterState({ bookedWith: value }));
    };
    const handleConsultationBookedWith = (e, value) => {
        const ids = [];
        value.map((data) => ids.push(data.id));
        setValue('consultationBookedWith', value);
        setValue('bookedWith', []);
        dispatch(updateCounter([]));
        const payloadData = {
            limit: perPage,
            offset: pageNumber,
            filterStatus: tableStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: treatmentData?.toString(),
            startDate,
            endDate,
            contactedCount: contactCount,
            tags: searchTags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: '',
            consultationBookedWith: ids?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            noTreatment: false,
            ...currentTaskModeFields(),
        };
        updateLeadPage({ ...payloadData, apptType: ids.length ? 'CONSULTATION' : '' });
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter({ ...payloadData, apptType: ids.length ? 'CONSULTATION' : '' });
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, { bookedWith: [], consultationBookedWith: value, apptType: ids.length ? 'CONSULTATION' : '', pageNumber: 0, perPage: 10 });
        syncToUrl(buildUrlFilterState({ consultationBookedWith: value, bookedWith: [] }));
    };

    const handleTags = (data, tags) => {
        dispatch(updateCounter([]));
        const payloadData = {
            limit: 10,
            offset: 0,
            filterStatus,
            order: tableOrder,
            orderId: tableOrderBy,
            searchQuery: searchValue,
            treatment: '',
            startDate,
            endDate,
            contactedCount: contactCount,
            tags,
            referral,
            practices,
            depositPendingStatus,
            category,
            bookedWith: bookedWithData?.toString(),
            assigneeIds: assigneeData?.toString(),
            archiveReason,
            ...currentTaskModeFields(),
        };
        handleStartedTablePayload(payloadData);
        updateLeadPage(payloadData);
        if (tableData && practiceId && wrappedReloadCounter) {
            wrappedReloadCounter(payloadData);
        }
        setPage(0);
        setRowsPerPage(10);
        setPaginationModel({ pageSize: 10, page: 0 });
        UpdateTableData(type, { tag: data, filterTags: tags, perPage: 10, pageNumber: 0 });
        syncToUrl(buildUrlFilterState({ tags: data }));
    };

    const onSelectionModelChange = (newSelectionModel) => {
        // Off-by-one guard (bsel-repro: 6 checkboxes for "5 selected"). Drop ids for
        // current-page rows that are mid-archive (checkbox suppressed) so the model
        // can't inflate count/object_ids; cross-page ids (absent from tableData) are
        // preserved. Result: checkbox count === count === object_ids exactly.
        const isFlatSelection = isFlatSelectionForRows(tableData);
        const cleanedModel = cleanSelectionModel(newSelectionModel, tableData, { isFlatSelection });

        const updatedData = tableData.map((item) => {
            if (item.lead_id && !item.is_archive_pending) {
                const checked = isRowSelected(item, cleanedModel);
                return { ...item, checked };
            }
            return item;
        });
        setTableData(updatedData);
        dispatch(
            selectLeads({
                leadId: cleanedModel,
                isFlatSelection,
                type: archType ? 'Restore' : 'Archive',
                loading: false,
            })
        );
    };

    const handleClearReportTable = () => {
        if (onClose) {
            onClose(true);
        }
        UpdateTableData(type, {
            search: '',
            date: [],
            treatment: [],
            perPage: 10,
            pageNumber: 0,
            tag: [],
            filterTags: [],
            referral: '',
            practices: '',
            bookedWith: '',

        });
    };

    const isDisabled = () => {
        if (loadingForLead) {
            return { pointerEvents: 'none', opacity: 0.5 };
        }
        return {};
    };

    const handleDepositPendingChange = (e) => {
        setDepositStatus(e.target.checked);
        let treatment = '';
        let id = '';
        const latestData = handleLatestData({ lead_treatments: selectedRow.treatmentData || [] }, type, rowStatus);
        if (isArray(latestData) && latestData.length > 0) {
            treatment = latestData[0]?.treatment;
            id = latestData[0]?.id;
        } else {
            return;
        }
        const data = {
            leadId: selectedRow.lead_id,
            treatmentId: id,
            payload: {
                treatment,
                is_treatment_fee_pending: !e.target.checked,
            },
        };
        dispatch(startLoadingDepositPending(true));
        dispatch(UpdateDepositPendingStatus(data, handleReloadLeads));
    };

    const handleCloseStartTreatment = () => {
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        setStartConfirmation(false);
    };

    const onWidgetClick = (value) => {
        if (newType) {
            handleChangeStatus('', value);
            return;
        }
        // Handle new booked table widget keys (string values)
        if (consultantBookedType && typeof value === 'string') {
            // Set the booked widget filter and reload data. The toggle rules
            // (including the "Upcoming" card's two-level body/chip scope —
            // Task L) live in resolveBookedWidgetClickTarget so they're
            // unit-tested without NewLead.jsx's dependency graph.
            const newFilter = resolveBookedWidgetClickTarget(value, bookedWidgetFilter);
            setPaginationModel({ pageSize: 10, page: 0 });
            setPage(0);
            const payloadData = {
                limit: 10,
                offset: 0,
                order: tableOrder,
                orderId: tableOrderBy,
                searchQuery: searchValue,
                treatment: treatmentData?.toString(),
                startDate,
                endDate,
                contactedCount: contactCount,
                tags: searchTags,
                referral,
                bookedWith: bookedWithData?.toString(),
                depositPendingStatus,
                assigneeIds: assigneeData?.toString(),
                noTreatment: false,
                bookedWidgetFilter: newFilter
            };
            updateLeadPage(payloadData);
            return;
        }
        if (consultantBookedType || failedToAttendType || treatmentStartedType || consultantAttendedType || attendedChecklistsType || consultantClinCheckAttendedType) {
            handleTreatment('', value);
        }
    };
    const handleClickAwayLister = (e, popup1Ref) => {
        if (popup1Ref && popup1Ref.current) {
            if (!popup1Ref.current?.contains(e.target)) {
                onCloseTreatmentEditPopup();
                setAnchorElAssign(null);
                return;
            }
            return;
        }
        onCloseTreatmentEditPopup();
        setAnchorElAssign(null);
    };

    const handleCloseAddTreatment = (e, popup1Ref) => {
        if (popup1Ref && popup1Ref.current) {
            if (!popup1Ref.current?.contains(e.target)) {
                onCloseAddTreatment();
                setAnchorElAssign(null);
                return;
            }
            return;
        }
        onCloseAddTreatment();
        setAnchorElAssign(null);
    };

    const handleCloseAssignPopup = (isReload, data) => {
        onCloseAssignTaskPopup(isReload, data);
        setAnchorElAssign(null);
    };
    const handleCloseAppointmentAssignPopup = (isReload, data) => {
        onCloseAppointmentAssignTaskPopup(isReload, data);
        setAnchorElAssign(null);
    };

    const onClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAssignTask();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const appointmentClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAppointmentAssignTaskPopup();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const handleDepositPaymentOnclose = (leadId) => {
        onCloseDepositPaymentPopup();
        paymentDeleteToggle.onClose();
        if (leadId) {
            dispatch(followUpSlice(leadId, practiceId, 'LeadDetail', (data) => handleSetTableData(data)));
        }
    };

    const onCloseClickCheckPopup = (data) => {
        onCloseClinCheckStatus(data);
        setAnchorClinCheck(null);
    };

    // Active-widget guidance: shared by the TableShell trace and the
    // ActiveFilterChip rendered in the filter toolbar so both stay in sync.
    const activeChipLabel = activeFilterLabel || internalActiveWidget?.label;
    const activeChipColor = activeFilterColor || internalActiveWidget?.color;

    return (
        <>
            <Helmet>
                <title> {`${noDashType ? tableTitle : displayForCategorySummary ? 'Category Summary' : 'Dashboard'}`} | Dental SEM CRM</title>
            </Helmet>
            {reportData && (
                <Box sx={{ textAlign: 'right' }}>
                    <Button variant='outlined' onClick={handleClearReportTable}>
                        Cancel
                    </Button>
                </Box>
            )}
            <Box sx={{ mb: reportData ? 0 : 5 }}>
                {allType && !hideDashboardWidget && !isNoTaskLeadsTable && !displayForCategorySummary && tableTitle !== 'All Patients' && < DashBoardReportsWidget
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                    activeWidgetProps={{ currentWidget, setCurrentWidget }}
                />}
                {newType && !displayForCategorySummary && (
                    <Box>
                        {/* Tasks/Due widget — the forward New Lead control surface.
                            Same gate as Attended's widget row: newLeadTasksMode is lazily
                            initialised BEFORE permissions settle (see the correction effect
                            keyed on permissionsReady), so on a cold load it can read false,
                            render no widget row, and then pop one in once the flags land.
                            Hold the space with skeletons until the answer is known. */}
                        {!permissionsReady && (
                            <ActionCards cards={[]} forceSkeletons skeletonCount={5} />
                        )}
                        {permissionsReady && newLeadTasksMode && (
                            <NewLeadTaskDueWidget
                                practiceId={practiceId}
                                activeBucket={taskDueBucket}
                                onBucketSelect={handleBucketSelect}
                                searchQuery={searchQuery || null}
                                onActiveWidgetChange={setInternalActiveWidget}
                            />
                        )}
                    </Box>
                )}
                {consultantBookedType && !displayForCategorySummary && <BookedTableReportsWidget
                    onWidgetClick={onWidgetClick}
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                    selectedWidget={bookedWidgetFilter}
                    practiceId={practiceId}
                    liveCounts={bookedWidgetCounts}
                    liveCountsLoading={bookedWidgetCountsLoading}
                    liveCountsError={bookedWidgetCountsError}
                />}
                {failedToAttendType && !displayForCategorySummary && <FTATableReportsWidget
                    onWidgetClick={onWidgetClick}
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                />}
                {treatmentStartedType && selectedTab !== 'invisalignAdditional' && !displayForCategorySummary && !suppressDefaultStartedWidget &&
                    <StartedTableReportsWidget
                        onWidgetClick={onWidgetClick}
                        dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                        tableTitle={tableTitle}
                    />}
                {(consultantAttendedType || attendedChecklistsType) && !displayForCategorySummary && !suppressDefaultAttendedWidget && <AttendedTableReportsWidget
                    onWidgetClick={onWidgetClick}
                    onContactedCountFilter={applyContactedCountFilter}
                    dateRangeProps={!onDateRangeReady ? { date, dateChange, setDate, startDate, endDate } : undefined}
                />}
                {(consultantClinCheckAttendedType) && !displayForCategorySummary && !onDateRangeReady && <Box sx={{ mb: 2 }}>
                    <MultiDatePicker
                        value={date}
                        endDate={new Date()}
                        dateChange={dateChange}
                        setValue={setDate}
                        startDateValue={startDate}
                        endDateValue={endDate}
                        inputFieldType='button'
                    />
                </Box>}
                {/* Computed once and reused by both the TableShell trace and the
                    ActiveFilterChip rendered in the filter toolbar below, so the
                    two stay in sync (same label/colour = the widget driving this
                    table, whether passed in via props or set internally). */}
                <TableShell
                    activeFilterLabel={activeChipLabel}
                    activeFilterColor={activeChipColor}
                >
                <Card sx={{ bgcolor: 'background.paper', padding: '0', border: '1px solid', borderColor: 'divider', boxShadow: '0 1px 3px 0 rgba(0,0,0,0.04)', ...isDisabled() }}>
                    {isReportData && !displayForCategorySummary && !hideCounterTabs && commonType && notClinCheckType && tableTitle !== 'Aligner Approve Leads' && tableTitle !== 'All Patients' && selectedTab !== 'invisalignAdditional' && !newLeadTasksMode && (type === 'ConsultantAttend' ? displayedHeadings.length > 1 : displayedHeadings.length > 0) && (
                        <Tabs
                            allowScrollButtonsMobile
                            variant='scrollable'
                            scrollButtons='auto'
                            value={activeStripValue}
                            onChange={handleChangeStatus}
                            sx={tabsStyle}
                        >
                            {displayedHeadings.map((item) => (
                                <Tab
                                    sx={{
                                        ...tabStyle(
                                            type,
                                            item,
                                            item?.value === 'AWAITING_RESPONSE'
                                                ? noAwatingCount && noAwatingCount[0]?.count
                                                : nhsCount && nhsCount[0]?.count
                                        ),
                                    }}
                                    disableRipple
                                    key={treatmentStartedType ? item?.id : item.value}
                                    label={labelCount(item)}
                                    value={treatmentStartedType ? item?.id : item.value}
                                />
                            ))}
                        </Tabs>
                    )}
                    {/* Tasks-mode bucket sub-tab strip — replaces contacted-count strip
                        for V2 practices when the view toggle is set to "Tasks". */}
                    {/* Tasks-mode bucket sub-tabs removed — the widget cards
                        (NewLeadTaskDueWidget) are the sole bucket control, matching
                        the CA Pipeline (attended-v2) widgets-only pattern. */}
                    {/* Task #100 Risk 2 — Second strip rendered ADDITIVELY below
                        the normal contacted-count strip when a top-placement
                        custom tab has checklist_binding active. Composes with
                        the first strip via checklistState query param. */}
                    {/* Attended page (ConsultantAttend) intentionally hides the In Progress /
                        Follow-Up Complete checklist sub-tab strip — that filtering now lives
                        entirely in the AttendedTabContextualWidget cards (Due Now / In Progress
                        / Follow-Up Complete), so the strip would be a redundant second control.
                        TreatmentStarted passes hideChecklistStrip for the same reason (its contextual widget owns it). */}
                    {isReportData && !displayForCategorySummary && !hideCounterTabs && !hideChecklistStrip && checklistStripActive && type !== 'AttendedChecklists' && type !== 'ConsultantAttend' && (
                        <Tabs
                            allowScrollButtonsMobile
                            variant='scrollable'
                            scrollButtons='auto'
                            value={checklistStateValue || (type === 'DashNewLeadTable' ? 'in_progress' : '')}
                            onChange={handleChangeChecklistState}
                            sx={tabsStyle}
                        >
                            {(type === 'DashNewLeadTable' ? DASH_V2_CHECKLIST_TAB_HEAD : ATTENDED_CHECKLISTS_TAB_HEAD).map((item) => (
                                <Tab
                                    sx={{ ...tabStyle(type, item, 0) }}
                                    disableRipple
                                    key={item.value}
                                    label={labelCount(item, 'checklist')}
                                    value={item.value}
                                />
                            ))}
                        </Tabs>
                    )}
                    {isReportData && selectedTab !== 'invisalignAdditional' && !displayForCategorySummary && (
                        <Box>
                            {showPracticeColumn ? (<Stack
                                className='filter-toggle-stack'
                                sx={stackStyle}
                                alignItems='left'
                                direction={{
                                    xs: 'column',
                                    md: 'row',
                                }}
                            >
                                {
                                    <Box sx={treatmentTagFilterStyle}>
                                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                            <Box sx={filterFormBoxStyle}>
                                                {activeChipLabel && activeChipColor && <ActiveFilterChip label={activeChipLabel} color={activeChipColor} />}
                                                <Box sx={searchWrapperStyle}>
                                                    <TextField
                                                        fullWidth
                                                        onChange={(event) => handleSearch(event.target.value)}
                                                        value={search}
                                                        sx={textFieldStyle}
                                                        placeholder='Search Lead Name, Email & Phone'
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position='start'>
                                                                    <Iconify
                                                                        icon={'eva:search-fill'}
                                                                        sx={{ color: 'text.disabled', width: 20, height: 20 }}
                                                                    />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Box>
                                                <Box sx={referralOutBoxStyle}>
                                                    <ReferralDropdown
                                                        name={'referral'}
                                                        value={referralValue()[0]?.label || ''}
                                                        onChange={handleReferral}
                                                        sx={{ ...referralBoxStyle }}
                                                        type={'search'}
                                                        affiliateUser={rowLead.current?.lead_source?.affiliate_user}
                                                    />
                                                </Box>
                                                <Box sx={referralOutBoxStyle}>
                                                    <PracticeDropdowns
                                                        name={'practices'}
                                                        label="Select Practices"
                                                        onChange={handlePracticeFilter}
                                                        value={superData?.practices || []}
                                                    />
                                                </Box>
                                            </Box>
                                        </FormProvider>
                                    </Box>
                                }
                            </Stack>) : (<Box
                                className='filter-toggle-stack'
                                sx={{ ...stackStyle, flexDirection: 'column', mt: '8px', mb: '6px' }}
                            >
                                {
                                    <Box sx={treatmentTagFilterStyle}>
                                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                            {/* V3 — Unified filter bar with inline clear */}
                                            <Box sx={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '8px',
                                                alignItems: 'center',
                                                py: '4px',
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    height: 34,
                                                    fontSize: '12px',
                                                    borderRadius: '8px',
                                                    '& fieldset': { borderColor: 'rgba(145, 158, 171, 0.20)' },
                                                    '&:hover fieldset': { borderColor: 'rgba(145, 158, 171, 0.40)' },
                                                    '&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: '1.5px' },
                                                },
                                                '& .MuiInputBase-input': { fontSize: '12px', py: '5px !important' },
                                                '& .MuiInputLabel-root': { fontSize: '12px', color: 'rgba(145, 158, 171, 0.7)' },
                                                '& .MuiInputLabel-shrink': { top: '0' },
                                                '& .MuiTextField-root > .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { top: '-8px' },
                                                '& .MuiFormControl-root:not(.MuiTextField-root) > .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { top: '-1px' },
                                                '& .MuiAutocomplete-inputRoot': { py: '2px !important', pr: '8px !important' },
                                                '& .MuiAutocomplete-endAdornment': { top: '50% !important', transform: 'translateY(-50%)' },
                                                '& .MuiSelect-select': { py: '5px !important', fontSize: '12px' },
                                                '& .MuiSelect-icon': { top: '50% !important', transform: 'translateY(-50%)' },
                                            }}>
                                                {activeChipLabel && activeChipColor && <ActiveFilterChip label={activeChipLabel} color={activeChipColor} />}
                                                <Box sx={{ ...searchWrapperStyle, flex: '1.5 1 200px', maxWidth: 320 }}>
                                                    <TextField
                                                        fullWidth
                                                        size='small'
                                                        onChange={(event) => handleSearch(event.target.value)}
                                                        value={search}
                                                        sx={{
                                                            ...textFieldStyle,
                                                            '& .MuiOutlinedInput-root': {
                                                                ...textFieldStyle['& .MuiOutlinedInput-root'],
                                                                height: 34,
                                                                borderRadius: '8px',
                                                            },
                                                        }}
                                                        placeholder='Search name, email, phone'
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position='start'>
                                                                    <Iconify
                                                                        icon={'eva:search-fill'}
                                                                        sx={{ color: 'text.disabled', width: 16, height: 16 }}
                                                                    />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Box>

                                                {isMobileFilters && (
                                                    <Box
                                                        component="button"
                                                        onClick={() => setMobileFiltersExpanded(!mobileFiltersExpanded)}
                                                        sx={{
                                                            display: 'flex', alignItems: 'center', gap: '4px',
                                                            px: '12px', py: '8px', borderRadius: '8px',
                                                            border: '1px solid rgba(145,158,171,0.24)',
                                                            bgcolor: mobileFiltersExpanded ? 'rgba(0,167,111,0.08)' : 'transparent',
                                                            color: mobileFiltersExpanded ? '#007B55' : '#637381',
                                                            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
                                                            width: '100%', justifyContent: 'center', mt: 1,
                                                        }}
                                                    >
                                                        {mobileFiltersExpanded ? 'Hide Filters' : 'Filters'}
                                                    </Box>
                                                )}

                                                {(!isMobileFilters || mobileFiltersExpanded) && <>

                                                {tableTitle !== 'Aligner Approve Leads' && !hiddenFilters.includes('treatments') && <MultiTreatmentDropdown
                                                    name={'multiSelect'}
                                                    label='Treatments'
                                                    sx={{ ...treatmentBoxStyle, flex: '1 1 140px' }}
                                                    onChange={handleTreatment}
                                                    value={treatmentValue}
                                                    type={type}
                                                    noTreatmentSelected={noTreatmentFilter}
                                                    // New Lead table's own practiceTreatment effect (above) fetches its
                                                    // copy at limit:50 — match it here so the dropdown's SPA-nav
                                                    // hydration-guard self-fetch (SelectMultiTreatments.jsx) can dedupe
                                                    // against it via callApi's in-flight URL match instead of doubling
                                                    // the request. Every other NewLead.jsx host keeps the 30 default.
                                                    selfFetchLimit={type === 'NewLeadTable' ? 50 : 30}
                                                />}

                                                {!hiddenFilters.includes('referral') && <Box sx={{ ...referralOutBoxStyle, flex: '1 1 120px' }}>
                                                    <ReferralDropdown
                                                        name={'referral'}
                                                        value={referralValue()[0]?.label || ''}
                                                        onChange={handleReferral}
                                                        sx={{ ...referralBoxStyle }}
                                                        type={'search'}
                                                        affiliateUser={rowLead.current?.lead_source?.affiliate_user}
                                                    />
                                                </Box>}

                                                {!hiddenFilters.includes('assignees') && <MultiAssigneesDropdown
                                                    name={'multiSelectAssignee'}
                                                    label='Assignees'
                                                    sx={{ ...treatmentBoxStyle, flex: '1 1 130px' }}
                                                    onChange={handleAssigneeFilter}
                                                    value={assigneeSelectedForFilter}
                                                    type={type}
                                                />}

                                                {bookedWithFilter && !hiddenFilters.includes('booked-with') && (
                                                    <MultiAssigneesDropdown
                                                        name={'bookedWith'}
                                                        label={treatmentStartedType && tableTitle !== 'Aligner Approve Leads' ? 'Tx booked with' : 'Booked with'}
                                                        sx={{ ...treatmentBoxStyle, flex: '1 1 130px' }}
                                                        onChange={(e, value) => handlePractitioner(e, value)}
                                                        value={bookedWith}
                                                        type={type}
                                                    />
                                                )}

                                                {treatmentStartedType && type !== "treatmentStartedWithInvisalign" && !hiddenFilters.includes('consult-booked-with') && (
                                                    <MultiAssigneesDropdown
                                                        name={'consultationBookedWith'}
                                                        label='Consult booked with'
                                                        sx={{ ...treatmentBoxStyle, flex: '1 1 150px' }}
                                                        onChange={(e, value) => handleConsultationBookedWith(e, value)}
                                                        value={consultationBookedWith}
                                                        type={type}
                                                    />
                                                )}

                                                {(isNoTaskLeadsTable || consultantAttendedType) && !hiddenFilters.includes('contacted') && (
                                                    <Box sx={{ flex: '1 1 120px' }}>
                                                        <FormControl fullWidth size='small'>
                                                            <InputLabel>Contacted</InputLabel>
                                                            <Select
                                                                value={contactedCountFilterValue}
                                                                label='Contacted'
                                                                onChange={handleContactedCountFilter}
                                                            >
                                                                {CONTACTED_COUNT_OPTIONS.map((opt) => (
                                                                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                )}

                                                {(type === 'ConsultantAttend' || type === 'AttendedChecklists' || type === 'ConsultantClinCheckAttend' || type === 'ConsultantBooked') && !hiddenFilters.includes('deposit') && (
                                                    <Box sx={{ flex: '1 1 110px' }}>
                                                        <FormControl fullWidth size='small'>
                                                            <InputLabel>Deposit</InputLabel>
                                                            <Select
                                                                value={depositPendingStatus}
                                                                label='Deposit'
                                                                onChange={handleDepositPendingFilter}
                                                            >
                                                                <MenuItem value={'YES'}>Yes</MenuItem>
                                                                <MenuItem value={'NO'}>No</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                )}

                                                {type === "ArchiveTable" && !hiddenFilters.includes('archive-reason') && (
                                                    <Box sx={{ ...referralOutBoxStyle, flex: '1 1 120px' }}>
                                                        <SelectArchiveReasons
                                                            name={'archive'}
                                                            value={archiveReasonValue()[0]?.label || ''}
                                                            onChange={handleArchiveFilter}
                                                            sx={{ ...referralBoxStyle }}
                                                            type={'search'}
                                                            archiveReasonData={archiveReasonData}
                                                        />
                                                    </Box>
                                                )}

{!hiddenFilters.includes('tags') && <Box sx={{ flex: '1 1 120px' }}>
                                                    <SearchAutocompleteTags
                                                        updateLeadPage={updateLeadPage}
                                                        tableType={type}
                                                        reloadCounter={wrappedReloadCounter}
                                                        handlePage={handlePage}
                                                        handleStartedTablePayload={handleStartedTablePayload}
                                                    />
                                                </Box>}

                                                {hasActiveFilters && !showEmptyStateClear && (
                                                    <>
                                                        <Box sx={{ width: '1px', height: 20, bgcolor: 'rgba(145, 158, 171, 0.20)', alignSelf: 'center', mx: 0.5, flexShrink: 0 }} />
                                                        <Button
                                                            size='small'
                                                            onClick={onResetFilter}
                                                            startIcon={<Iconify icon='solar:close-circle-bold' width={14} />}
                                                            sx={{
                                                                height: 30,
                                                                fontSize: '12px',
                                                                fontWeight: 600,
                                                                px: 1,
                                                                borderRadius: '6px',
                                                                color: 'error.main',
                                                                bgcolor: 'rgba(255, 86, 48, 0.06)',
                                                                '&:hover': { bgcolor: 'rgba(255, 86, 48, 0.14)' },
                                                                whiteSpace: 'nowrap',
                                                                minWidth: 'auto',
                                                                textTransform: 'none',
                                                                flexShrink: 0,
                                                            }}
                                                        >
                                                            Clear
                                                        </Button>
                                                    </>
                                                )}

                                                </>}

                                                {/* Right end of the filter bar: page-level extras (e.g. All Patients' Export),
                                                    then the date-range calendar (moved here from the page header). Only on
                                                    pages that previously hosted the calendar in their header
                                                    (i.e. that pass onDateRangeReady). */}
                                                {(toolbarEnd || onDateRangeReady) && (
                                                    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                                                        {toolbarEnd}
                                                        {onDateRangeReady && (
                                                            <WidgetButtons
                                                                compact
                                                                dateRangeProps={{ date, dateChange, setDate, startDate, endDate }}
                                                                showActiveRangeChip={type === 'treatmentStarted'}
                                                            />
                                                        )}
                                                    </Box>
                                                )}
                                            </Box>
                                        </FormProvider>
                                    </Box>
                                }
                            </Box>)}
                            {showPracticeColumn && (tableTitle === 'All Patients' || multiLead?.leadId?.length === 0) && (
                                <Stack
                                    className='filter-toggle-stack'
                                    sx={searchFilterContent}
                                    alignItems='left'
                                    direction={{
                                        xs: 'column',
                                        md: 'row',
                                    }}
                                >
                                    <TableFilterResult
                                        filters={filters}
                                        onResetFilters={onResetFilter}
                                        onReset={
                                            searchValue ||
                                            treatmentValue?.length > 0 ||
                                            startDate ||
                                            endDate ||
                                            referral?.length > 0 ||
                                            bookedWith?.length > 0 ||
                                            depositPendingStatus ||
                                            consultationBookedWith?.length > 0 ||
                                            assigneeSelectedForFilter?.length > 0 ||
                                            archiveReason?.length > 0 ||
                                            practices?.length > 0
                                        }
                                        isTreatmentStarted={treatmentStartedType && type !== "treatmentStartedWithInvisalign"}
                                        handleTreatment={handleTreatment}
                                        handleReferral={handleReferral}
                                        dateChange={dateChange}
                                        handleTags={handleTags}
                                        handlePractitioner={handlePractitioner}
                                        handleDepositPendingFilter={handleDepositPendingFilter}
                                        handleConsultationBookedWith={handleConsultationBookedWith}
                                        tableTitle={tableTitle}
                                        handleAssigneeFilter={handleAssigneeFilter}
                                        handleArchiveFilter={handleArchiveFilter}
                                        selectedCount={tableTitle === 'All Patients' ? (multiLead?.leadId?.length || 0) : 0}
                                    />
                                </Stack>
                            )}
                        </Box>
                    )}
                    <Box sx={{ borderTop: 'solid 1px rgba(145, 158, 171, 0.16)' }}>
                        {checklistEmptyStateProbeEnabled
                            && (tableData?.length || 0) === 0
                            && !loadingForLead
                            ? (attendedChecklistsType ? (
                                <EmptyContent
                                    filled
                                    title="No checklist data yet"
                                    description="This practice has Tasks v2 enabled but no checklist templates configured, or no tasks have been auto-created yet."
                                    sx={{ py: 6, my: 2 }}
                                    action={
                                        <Button
                                            component={RouterLink}
                                            to={PATH_DASHBOARD.superAdmin.systemTaskTemplates}
                                            variant="contained"
                                            startIcon={<Iconify icon="solar:clipboard-list-bold" />}
                                            sx={{ mt: 2 }}
                                        >
                                            Go to System Task Templates
                                        </Button>
                                    }
                                />
                            ) : (
                                <EmptyContent
                                    filled
                                    title="No leads in this checklist state yet"
                                    description="This tab is bound to checklist template(s). Either no tasks have been created on attended leads yet, or all leads are in a different sub-tab. Try switching sub-tabs or wait for the next attended consultation."
                                    sx={{ py: 6, my: 2 }}
                                />
                            ))
                            : tableTitle === 'Aligner Approve Leads' ?
                            <AlignerApproveLeadDataGrid
                                tableTitle={tableTitle}
                                tableData={tableData}
                                typed={type}
                                isReportData={isReportData}
                                selectedRow={onSelectedRow}
                                onTransferLead={setTransferRow}
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                handlePaginationChange={handlePaginationChange}
                                pageCount={pageCount}
                                handleChangePerSize={(event) => handleChangePerPage(event)}
                                OpenAssignTask={OpenAssignTask}
                                reloadCounter={wrappedReloadCounter}
                                updateLeadPage={updateLeadPage}
                                onSelectionModelChange={onSelectionModelChange}
                                isNotFound={isNotFound}
                                onOpenOpenTreatmentPlan={onOpenOpenTreatmentPlan}
                                forceUpdate={forceUpdate}
                                tablePath={currentPagePath}
                                sortingApiCall={sortingApiCall}
                                defaultHideColumn={defaultHideColumn}
                                columnVisibilityModel={columnVisibilityModel}
                                handleColumnVisibilityChange={handleColumnVisibilityChange}
                                handleColumnOrderChange={handleColumnOrderChange}
                                openAppointmentAssignTaskFuc={openAppointmentAssignTaskFuc}
                                handleReloadAPI={handleReloadAPI}
                                setTableData={setTableData}
                                handleSetTableData={handleSetTableData}
                                setCurrentTreatmentData={setCurrentTreatmentData}
                                setColumnVisibilityModel={setColumnVisibilityModel}
                                selectedTab={selectedTab}
                                isCombinedName={isCombinedName}
                                handleToggleCombineName={handleToggleCombineName}
                                setIsCombinedName={setIsCombinedName}
                                isEnforcedByPractice={isEnforcedByPractice}
                                setIsEnforcedByPractice={setIsEnforcedByPractice}
                                resetColumns={pinProps?.resetColumns}
                            /> :
                            <NewLeadDataGrid
                                tableTitle={tableTitle}
                                tableData={tableData}
                                typed={type}
                                customTabOverride={activeCustomTab?.column_overrides || null}
                                activeCustomTabSlug={activeCustomTab?.slug || undefined}
                                forceLoading={displayForCategorySummary && leadCategoryType !== filterStatus}
                                isReportData={isReportData}
                                selectedRow={onSelectedRow}
                                onTransferLead={setTransferRow}
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                handlePaginationChange={handlePaginationChange}
                                pageCount={pageCount}
                                handleChangePerSize={(event) => handleChangePerPage(event)}
                                OpenAssignTask={OpenAssignTask}
                                reloadCounter={wrappedReloadCounter}
                                updateLeadPage={updateLeadPage}
                                refreshTable={refreshTableWithCurrentFilters}
                                refreshCounters={refreshCountersOnly}
                                refreshTaskDueCounters={refreshNewLeadTaskWidgetCounts}
                                removeRowOptimistically={removeRowOptimistically}
                                restoreRowOptimistically={restoreRowOptimistically}
                                onSelectionModelChange={onSelectionModelChange}
                                selectedLeadIds={multiLead?.leadId || []}
                                isNotFound={isNotFound}
                                onOpenOpenTreatmentPlan={onOpenOpenTreatmentPlan}
                                forceUpdate={forceUpdate}
                                tablePath={currentPagePath}
                                sortingApiCall={sortingApiCall}
                                defaultHideColumn={defaultHideColumn}
                                columnVisibilityModel={columnVisibilityModel}
                                handleColumnVisibilityChange={handleColumnVisibilityChange}
                                handleColumnOrderChange={handleColumnOrderChange}
                                openAppointmentAssignTaskFuc={openAppointmentAssignTaskFuc}
                                handleReloadAPI={handleReloadAPI}
                                setTableData={setTableData}
                                handleSetTableData={handleSetTableData}
                                setCurrentTreatmentData={setCurrentTreatmentData}
                                setColumnVisibilityModel={setColumnVisibilityModel}
                                pinProps={pinProps}
                                showPracticeColumn={showPracticeColumn}
                                hasActiveFilters={hasActiveFilters}
                                onClearFilters={onResetFilter}
                                // RCA 2026-09-06 (new-lead search scoping): the New tab's
                                // search is scoped to the NEW stage, so a patient who has
                                // moved on (booked / attended / closed) correctly returns
                                // nothing. At Parrock that is the common case — 62 leads in
                                // scope vs 603 out of it — so a bare "No results found"
                                // reads as a broken search. Pass the query + stage label so
                                // the empty state can say WHY and point at the ⌘K palette,
                                // which searches every stage. Only this table sets these;
                                // every other table's empty state is unchanged.
                                searchScopeQuery={searchValue || ''}
                                searchScopeStageLabel={newType ? 'New' : ''}
                                isCombinedName={isCombinedName}
                                handleToggleCombineName={handleToggleCombineName}
                                setIsCombinedName={setIsCombinedName}
                                isCombinedContact={isCombinedContact}
                                handleToggleCombineContact={handleToggleCombineContact}
                                setIsCombinedContact={setIsCombinedContact}
                                activeSubTab={contactCount ? String(contactCount) : undefined}
                                // Task #100 follow-up (Raj 2026-05-25, practice 92):
                                // suppress the dynamic checklist columns on the "All" /
                                // built-in parent views of ConsultantAttend AND
                                // TreatmentStarted (Raj 2026-05-28 — mixed-treatment built-in
                                // boards are too noisy with every show_in_tables template
                                // stacked together). Those views have no checklist_binding so
                                // they would otherwise inherit every template configured via
                                // `show_in_tables` and leak the per-custom-tab checklist UI
                                // onto the unfiltered list. Custom-top tabs
                                // (controlledCustomTabId is a number) keep their
                                // checklist_binding-resolved columns.
                                suppressTaskChecklistColumns={
                                    (type === 'ConsultantAttend' || type === 'treatmentStarted')
                                    && controlledCustomTabId !== undefined
                                    && controlledCustomTabId === null
                                }
                                checklistSwitching={isChecklistSwitching}
                                onChecklistSwitchingDone={() => setIsChecklistSwitching(false)}
                                onBulkCompleteReady={setBulkCompleteAnimate}
                                onChecklistColumnsChange={setActiveChecklistColumns}
                                newLeadTasksMode={newLeadTasksMode}
                            />
                        }

                    </Box>
                </Card>
                </TableShell>
                <CustomConfirmationDialog
                    toggle={paymentDeleteToggle.toggle}
                    handleClose={() => paymentDeleteToggle.onClose()}
                    handleSubmit={() => handleDeletePaymentMethods(selectedRow, handleDepositPaymentOnclose)}
                    message={'Are you sure you want to delete this payment?'}
                />
                {openContacts && <PracticeEditDialog open={openContacts} onClose={onCloseContacts} />}
                {openFollowLead && (
                    <OpenDialogPopup
                        {...pmsBookingSession.navigationProps}
                        recoveryContent={<PmsBookingRecovery session={pmsBookingSession} practiceId={practiceId} onRetry={() => setPmsSlot(null)} onFound={() => handleClose('finish')} />}
                        open={openFollowLead}
                        headerButtons
                        onClose={handleClose}
                        openArchivePopup={onOpenArchiveLead}
                        user={selectedRow}
                        steps={leadStep}
                        type={'followup'}
                        validStep={validStep}
                        BookingAttendance={BookingAttendance}
                        updateStep={(v) => setValidStep(!!v)}
                        inputRef={inputRef}
                        active={active}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        setActive={setActive}
                        ContactedCount={
                            selectedRow &&
                            selectedRow?.lead_treatments &&
                            selectedRow?.lead_treatments[0]?.lead_contacted_counts?.length > 0 &&
                            selectedRow?.lead_treatments[0]?.lead_contacted_counts[0]?.count
                        }
                        timeLineCount={activityList?.results?.length}
                    />
                )}
                {/* Contact popup — routed through ContactLeadPopupRouter (single V1/V2 swap path) */}
                {openContactLead && (
                    <BookingContactPopup
                        {...pmsBookingSession.navigationProps}
                        recoveryContent={<PmsBookingRecovery session={pmsBookingSession} practiceId={practiceId} onRetry={() => setPmsSlot(null)} onFound={() => handleClose('finish')} />}
                        open={openContactLead}
                        headerButtons
                        onClose={handleClose}
                        openArchivePopup={onOpenArchiveLead}
                        user={selectedRow}
                        leadDetail={selectedRow}
                        leadTreatmentId={selectedRow?.treatment_id || null}
                        practiceId={practiceId}
                        steps={leadStep}
                        type={'followup'}
                        validStep={validStep}
                        BookingAttendance={BookingAttendance}
                        updateStep={(v) => setValidStep(!!v)}
                        inputRef={inputRef}
                        active={active}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        setActive={setActive}
                        handleReloadLeads={handleReloadLeads}
                        ContactedCount={
                            selectedRow &&
                            selectedRow?.treatmentData &&
                            selectedRow?.treatmentData[0]?.lead_contacted_counts?.length > 0 &&
                            selectedRow?.treatmentData[0]?.lead_contacted_counts[0]?.count
                        }
                        timeLineCount={activityList?.results?.length}
                        defaultTab={contactLeadDefaultTab}
                        debugSource={contactLeadDebugSource}
                    />
                )}
                {openConsultationAttend && (
                    <OpenConsultationPopup
                        open={openConsultationAttend}
                        headerButtons
                        onClose={() => { onCloseConsultationAttend(); setConsultationAttendSidebarTab(null); pendingV2TaskIdRef.current = null; }}
                        handleCloseAndReload={handleClose}
                        handleReloadLeads={handleReloadLeads}
                        user={selectedRow}
                        type={'consultationAttended'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        startTreatment={startTreatment}
                        OpenAssignTask={openAppointmentAssignTaskFuc}
                        editDetailHandler={editDetailHandler}
                        selectedTreatmentData={currentTreatmentData}
                        defaultTab="Follow Up"
                        initialSidebarTab={consultationAttendSidebarTab}
                        onSendComplete={handleConsultationSendComplete}
                    />
                )}
                {openRecordAttend && (
                    <OpenAttendedPopup
                        open={openRecordAttend}
                        headerButtons
                        onClose={() => onCloseRecordAttend()}
                        handleCloseAndReload={handleClose}
                        user={selectedRow}
                        type={'recordAttended'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        OpenAssignTask={openAppointmentAssignTaskFuc}
                        editDetailHandler={editDetailHandler}
                        handleReloadLeads={handleReloadLeads}
                        isOverview
                        // followUpLead must NOT be nulled here: the [followUpLead] close effect treats null as
                        // "a popup closed" and would immediately close the outcome popup we open below.
                        // 'recordUnAttended' is the value the row's own record-unattended action sets, so the
                        // eventual Finish routes to recordUnAttended(handleClose) via the markAsComplete switch.
                        handleNoAttended={(selection) => { setAppointmentOutcomeSelection(selection); dispatch(updateCompleteStatus(false)); dispatch(updateFollowUpLead('recordUnAttended')); onCloseRecordAttend(); onOpenUnRecordAttend(); }}
                        debugSource={`leads-table:${type || 'lead'}-row→RecordAttendance`}
                    />
                )}
                {openAttendedNote && (
                    <AttendedNotePopup
                        open={openAttendedNote}
                        headerButtons
                        onClose={() => onCloseAttendedNote()}
                        handleCloseAndReload={handleClose}
                        user={selectedRow}
                        type={'backtoAttended'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                    />
                )}
                {openUnRecordAttend && (
                    <OpenUnAttendedPopup
                        appointmentSelection={appointmentOutcomeSelection}
                        open={openUnRecordAttend}
                        headerButtons
                        onClose={() => onCloseUnRecordAttend()}
                        handleCloseAndReload={handleClose}
                        user={selectedRow}
                        type={'recordUnAttended'}
                        tableType={type}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                    />
                )}
                {openArchiveLead && (
                    <ArchivedLeadPopUp
                        open={openArchiveLead}
                        headerButtons
                        onClose={handleArchivedClose}
                        user={selectedRow}
                        type={'archiveLead'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                        setForceUpdate={setForceUpdate}
                        onExplicitArchiveSubmit={handleExplicitTableArchiveSubmit}
                    />
                )}
                {openRestoreArchived && (
                    <OpenRestoreArchived
                        open={openRestoreArchived}
                        headerButtons
                        onClose={() => onCloseRestoreArchived()}
                        user={selectedRow}
                        type={'RestoreArchived'}
                        inputRef={inputRef}
                        CreateLeadHeaderData={CreateLeadHeaderData}
                    />
                )}
                {openAddTreatment && (
                    <TreatmentEditPopover
                        handleReloadAPI={handleCloseTreatment}
                        open={openAddTreatment}
                        anchorEl={anchorEditTreatment}
                        handleClickAwayLister={handleCloseAddTreatment}
                        leadId={tableRowLead?.lead_id}
                        isAddTreatment
                    />
                )}
                {openTreatmentEditPopup && (
                    <TreatmentEditPopover
                        handleReloadAPI={handleReloadAPI}
                        treatmentData={selectedRow?.treatmentData}
                        treatment={selectedRow?.treatment_name || ''}
                        leadTreatmentSpecification={selectedRow?.leadTreatmentSpecification || null}
                        open={openTreatmentEditPopup}
                        anchorEl={anchorEditTreatment}
                        handleClickAwayLister={handleClickAwayLister}
                        treatmentId={selectedRow?.treatment_id}
                        treatmentPrice={selectedRow?.price}
                        treatmentCategory={selectedRow?.treatmentCategory}
                        leadId={selectedRow?.lead_id}
                    />
                )}
                {transferRow && (
                    <TransferLeadDialog
                        open
                        onClose={() => setTransferRow(null)}
                        leadId={transferRow.lead_id}
                        practiceId={transferRow.practiceId || practiceId}
                        leadName={`${transferRow.first_name || ''} ${transferRow.last_name || ''}`.trim()}
                        onDone={handleTransferDone}
                    />
                )}
                {openDepositPaymentPopup && (
                    <DepositPaymentPopover
                        rowData={selectedRow}
                        open={openDepositPaymentPopup}
                        anchorEl={anchorDepositPayment}
                        handleClickAwayLister={handleDepositPaymentOnclose}
                    />
                )}
                {openAssignTask && (
                    <ClickAwayListener onClickAway={onClickAwayEvent}>
                        <Popper open={openAssignTask} anchorEl={anchorElAssign} transition placement='bottom' sx={zIndexStyle}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={borderRadiosStyle}>
                                        <AssignTaskPopup
                                            open={openAssignTask}
                                            onClose={handleCloseAssignPopup}
                                            user={selectedRow}
                                            leadId={selectedRowId}
                                            type={'leadAssign'}
                                            assignees={tableData?.find((ele) => ele.id === selectedRowId)?.assignees?.filter(
                                                (el) => el?.user?.first_name && !el?.user?.is_superuser)?.map((ele) => ele.id)}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
                {openClinCheckStatus && (
                    <ClickAwayListener onClickAway={() => { onCloseClinCheckStatus(); setAnchorClinCheck(null); }}>
                        <Popper open={openClinCheckStatus} anchorEl={anchorClinCheck} transition placement='bottom' sx={zIndexStyle}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper>
                                        <ClinCheckStatusPopup
                                            open={openClinCheckStatus}
                                            onClose={onCloseClickCheckPopup}
                                            handleClose={handleClose}
                                            leadDetail={selectedRow}
                                            leadId={selectedRowId}
                                            type={'leadAssign'}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
                {openTreatmentPlan && (
                    <TreatmentPlanDatePicker
                        open={openTreatmentPlan}
                        onClose={() => onCloseTreatmentPlanDatePicker()}
                        user={selectedRow}
                        leadId={selectedRowId}
                        type={'leadAssign'}
                    />
                )}
                {openAppointmentAssignTask && (
                    <ClickAwayListener onClickAway={() => appointmentClickAwayEvent()}>
                        <Popper open={openAppointmentAssignTask} anchorEl={anchorElAssign} transition placement='bottom' sx={zIndexStyle}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={borderRadiosStyle}>
                                        <AppointmentAssignTaskPopup
                                            open={openAppointmentAssignTask}
                                            onClose={handleCloseAppointmentAssignPopup}
                                            user={selectedRow}
                                            leadId={selectedRowId}
                                            type={'leadAssign'}
                                            assignees={assignees}
                                            appoinmentSelectedId={appoinmentSelectedId}
                                            selectedTreatmentData={currentTreatmentData}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
                {OpenReSchedule && (
                    <OpenEditAppointmentPopup
                        open={OpenReSchedule}
                        headerButtons
                        onClose={handleReScheduleClose}
                        inputRef={inputRef}
                        appoinmentSelectData={appoinmentSelectData}
                    />
                )}
                {leadDetailModal && (
                    <EditPersonalDetailsPopup
                        open={leadDetailModal}
                        handleClose={closeEditDetails}
                        selectedRow={selectedRow}
                        type={'editLead'}
                        inputRef={personalDetailPopupRef}
                        title='Edit Details'
                        headerButtons
                    />
                )}
                {openAppointment && <AppointmentBookingRouter
                    open={openAppointment}
                    headerButtons
                    onClose={handleAppointmentClose}
                    practiceId={practiceId}
                    existingLead={selectedRow}
                    existingTreatmentId={selectedRow?.treatmentData?.[0]?.id}
                    treatmentData={selectedRow?.treatmentData[0]}
                    inputRef={inputRef}
                    type={'leadTable'}
                />}
                {open.value && <ArchivedOrRestorePopup open={open.value} onClose={open.onFalse} handleClose={handleClose} practiceByLeadId={practiceByLeadId} />}
                {openBulkReminder.value && (
                    isNoTaskLeadsTable
                        ? <SmartBulkReminderModal open={openBulkReminder.value} onClose={openBulkReminder.onFalse} onSuccess={() => handleClose('finish')} />
                        : <BulkReminderPopup open={openBulkReminder.value} onClose={openBulkReminder.onFalse} />
                )}
                <CustomCompleteTreatmentDialog
                    handleClose={() => {
                        setConfirmation(false);
                        if (hubDataChangedRef.current) {
                            hubDataChangedRef.current = false;
                            handleReloadAPI('finish');
                        }
                    }}
                    handleYes={() => { hubDataChangedRef.current = false; completeTreatmentAPI(); }}
                    isLoader={isLoader}
                    open={confirmation}
                    row={rowLead.current}
                    practiceId={practiceId}
                    onDataChanged={() => { hubDataChangedRef.current = true; }}
                />
                {startConfirmation && <StartTreatmentPopup
                    isOpen={startConfirmation}
                    handleCloseStartTreatment={handleCloseStartTreatment}
                    isPaymentMandatory={isPaymentMandatory}
                    depositStatus={depositStatus}
                    handleDepositPendingChange={handleDepositPendingChange}
                    startTreatmentAPI={startTreatmentAPI}
                />}
                <Dialog open={toggleDuplicatePopup} onClose={() => closeDuplicatePopup()}>
                    <DialogTitle sx={dialogTitleStyle}>
                        Mark this lead as duplicate? This links exact email or phone matches. It will not mark the lead as spam or remove it.
                    </DialogTitle>
                    <DialogActions sx={dialogActionStyle}>
                        <Button sx={cancelBtnStyle} onClick={() => closeDuplicatePopup()}>
                            Cancel
                        </Button>
                        <Button type='submit' sx={yesBtnStyle} onClick={() => handleMarkAsDuplicateAPI()}>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={toggleUnMarkAsDuplicate} onClose={() => closeUnMarkAsDuplicate()}>
                    <DialogTitle sx={dialogTitleStyle}>
                        Are you sure you want to un mark as duplicate?
                    </DialogTitle>
                    <DialogActions sx={dialogActionStyle}>
                        <Button sx={cancelBtnStyle} onClick={() => closeUnMarkAsDuplicate()}>
                            Cancel
                        </Button>
                        <Button type='submit' sx={yesBtnStyle} onClick={() => handleUnMarkAsDuplicateAPI()}>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={toggleMarkAsSpam} onClose={() => closeMarkAsSpamDialog()}>
                    <DialogTitle sx={dialogTitleStyle}>
                        Mark {rowLead.current ? `${rowLead.current.first_name || ''} ${rowLead.current.last_name || ''}`.trim() : 'this lead'} as spam? This lead will be removed from all counts and reports.
                    </DialogTitle>
                    <DialogActions sx={dialogActionStyle}>
                        <Button sx={cancelBtnStyle} onClick={() => closeMarkAsSpamDialog()}>
                            Cancel
                        </Button>
                        <Button type='submit' sx={{ ...yesBtnStyle, bgcolor: 'error.main', '&:hover': { bgcolor: 'error.dark' } }} onClick={() => handleMarkAsSpamAPI()}>
                            Mark as Spam
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* Persistent auto-skip summary.
                    Shown when bulk Complete server-side skipped ≥1 non-yes/no item.
                    Groups are: needs_send (email/WA/consent), needs_data (text/date/
                    choice), needs_next_action (Book/FTA/status-change), needs_artifact
                    (file/reminder/appointment).  Not auto-dismissed — requires "Got it". */}
                <Dialog
                    open={Boolean(skipGroups)}
                    maxWidth="sm"
                    fullWidth
                    disableEscapeKeyDown
                    PaperProps={{ sx: { borderRadius: 2 } }}
                >
                    <DialogTitle sx={{ fontSize: '1rem', pb: 1 }}>
                        Non-yes/no items skipped
                    </DialogTitle>
                    <DialogContent>
                        {skipGroups && [
                            {
                                key: 'needs_next_action',
                                heading: 'Next-action items skipped',
                                body: "Bulk complete did not choose a lead status (Book, Attended, FTA, etc.). These checklist items were marked Skipped with bulk-complete audit provenance for:",
                            },
                            {
                                key: 'needs_send',
                                heading: 'Send-required items skipped',
                                body: 'Bulk complete did not send an email, WhatsApp, SMS, or other message. These checklist items were marked Skipped for:',
                            },
                            {
                                key: 'needs_data',
                                heading: 'Input-required items skipped',
                                body: 'Bulk complete did not manufacture text, dates, choices, payment data, or other input. These checklist items were marked Skipped for:',
                            },
                            {
                                key: 'needs_artifact',
                                heading: 'Attachment or appointment items skipped',
                                body: 'Bulk complete did not create a document, reminder, linked checklist, or booking. These checklist items were marked Skipped for:',
                            },
                        ]
                            .filter(({ key }) => skipGroups[key] && skipGroups[key].length > 0)
                            .map(({ key, heading, body }, sectionIdx) => (
                                <Stack key={key} sx={{ mb: sectionIdx < 3 ? 2 : 0 }}>
                                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                                        {heading}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                        {body}
                                    </Typography>
                                    <Stack component="ul" spacing={0.5} sx={{ pl: 2.5, m: 0 }}>
                                        {skipGroups[key].map((id) => {
                                            // Best-effort name lookup from the current page rows.
                                            // Falls back to "Lead #<id>" if the row has scrolled off.
                                            const row = tableData.find(
                                                (r) => String(r.lead_id) === String(id) || String(r.id) === String(id)
                                            );
                                            const name = row
                                                ? `${row.first_name || ''} ${row.last_name || ''}`.trim() || `Lead #${id}`
                                                : `Lead #${id}`;
                                            return (
                                                <Typography key={id} component="li" variant="body2" fontWeight={500}>
                                                    {name}
                                                </Typography>
                                            );
                                        })}
                                    </Stack>
                                </Stack>
                            ))}
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button
                            variant="contained"
                            onClick={() => setSkipGroups(null)}
                            sx={{ borderRadius: 1.5, textTransform: 'none', minWidth: 100 }}
                        >
                            Got it
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* Floating bulk action bar — portal-rendered at document.body level */}
                {isReportData && (
                    <FloatingBulkActionBar
                        practiceId={practiceId}
                        onClearSelection={() => dispatch(selectLeads({ leadId: [], type: '', loading: false }))}
                        onRefresh={refreshTableWithCurrentFilters}
                        onBulkComplete={handleBulkComplete}
                        onOpenBulkReminder={openBulkReminder.onTrue}
                        onItemsSkipped={handleItemsSkipped}
                        isArchive={archType}
                        treatmentTargets={treatmentTargets}
                        treatmentTargetStatus={treatmentTargetStatus}
                        checklistColumns={activeChecklistColumns}
                        taskDueBucket={newLeadTasksMode ? (taskDueBucketRef.current || undefined) : undefined}
                        paidRowIds={paidRowIds}
                        practiceByLeadId={practiceByLeadId}
                    />
                )}
            </Box>
        </>
    );
};

function applySortFilter({ tableData }) {
    const stabilizedThis = tableData.map((el, index) => [el, index]);
    tableData = stabilizedThis.map((el) => el[0]);

    return tableData;
}

export default NewLead;

NewLead.propTypes = {
    leadData: PropTypes.array,
    updateLeadPage: PropTypes.func,
    pageCount: PropTypes.number,
    type: PropTypes.string,
    setUpdateList: PropTypes.func,
    tableTitle: PropTypes.string,
    counter: PropTypes.array,
    reloadCounter: PropTypes.func,
    reloadTaskCounter: PropTypes.func,
    onClose: PropTypes.func,
    rowStatus: PropTypes.string,
    clinCheck: PropTypes.string,
    defaultHideColumn: PropTypes.object,
    columnVisibilityModel: PropTypes.object,
    handleColumnVisibilityChange: PropTypes.func,
    handleColumnOrderChange: PropTypes.func,
    shouldRunEffect: PropTypes.object,
    dashBoardDateProps: PropTypes.object,
    isNoTaskLeadsTable: PropTypes.bool,
    selectedTab: PropTypes.string,
    setColumnVisibilityModel: PropTypes.func,
    pinProps: PropTypes.object,
    displayForCategorySummary: PropTypes.bool.isRequired,
    leadCategoryType: PropTypes.string.isRequired,
    forceReload: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    hideCounterTabs: PropTypes.bool,
    archiveReasonData: PropTypes.array,
    showPracticeColumn: PropTypes.bool,
    onDateRangeReady: PropTypes.func,
    // Optional node rendered at the right end of the filter bar (before the calendar).
    toolbarEnd: PropTypes.node,
    isCombinedName: PropTypes.bool,
    handleToggleCombineName: PropTypes.func,
    isCombinedContact: PropTypes.bool,
    handleToggleCombineContact: PropTypes.func,
    setIsCombinedContact: PropTypes.func,
    setIsCombinedName: PropTypes.func,
    bookedWidgetFilter: PropTypes.string,
    bookedWidgetCounts: PropTypes.shape({
        upcoming: PropTypes.number,
        upcoming_week: PropTypes.number,
        past: PropTypes.number,
    }),
    bookedWidgetCountsLoading: PropTypes.bool,
    bookedWidgetCountsError: PropTypes.string,
    activeFilterLabel: PropTypes.string,
    activeFilterColor: PropTypes.string,
    isEnforcedByPractice: PropTypes.bool,
    setIsEnforcedByPractice: PropTypes.func,
    // null = built-in board scope, Number = PracticeCustomTableTab id, undefined = legacy (standalone NewLead).
    controlledCustomTabId: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
    // Bug 2c: URL-driven checklist strip state. null = no URL override (use Redux).
    checklistStateFromUrl: PropTypes.string,
    // Bug 2c: callback from ConsultantAttend to write checklistState to URL on strip change.
    onChecklistStateChange: PropTypes.func,
    // Suppress the legacy AttendedTableReportsWidget when the tab-contextual widget row is active.
    suppressDefaultAttendedWidget: PropTypes.bool,
    // Task #46: wrapper-owned initial-fetch ref. While false, practiceTreatment effect defers
    // updateLeadPage/reloadCounter to avoid multi-fetch races on tasks deep-links.
    // eslint-disable-next-line react/forbid-prop-types
    externalInitialFetchRef: PropTypes.object,
    // ConsultantAttend wrapper owns list/counter hydration for its selected practice.
    wrapperOwnsLeadHydration: PropTypes.bool,
    // Practice whose settled initial list request has been dispatched by the wrapper.
    wrapperHydratedPracticeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Suppress the legacy StartedTableReportsWidget when the new contextual widget row is active.
    suppressDefaultStartedWidget: PropTypes.bool,
    hideDashboardWidget: PropTypes.bool,
    // Hide the additive checklist_state sub-strip (All / In Progress / Follow-Up Complete).
    hideChecklistStrip: PropTypes.bool,
    // Wrapper callback: called by handleSearch to reset the top-strip tab to the default,
    // clearing ?tab=custom:N from the URL via useChecklistTabUrlState.
    onClearCustomTab: PropTypes.func,
};
